import "./expore.css";
import "./exploreMasonry.css"
import React, { useEffect, useState, useContext, useRef, lazy, useLayoutEffect, useMemo, useCallback } from "react";
import Loader from "./Loader";
import ScrollTag from "./ScrollTag"; // Add this line to import ScrollTag
import AppPagesHeading from "./AppPagesHeading"; // Add this line to import AppPagesHeading
import axios from "axios";
import EmptyCartImage from "../appimages/empty_cart.webp";
import defaultBlogImage from "../defaultBlog.jpg";
import ExploreLinkButton from "./ExploreLinkButton";
import SkeltonLoading from "./SkeltonLoading";
import { handleShare, ShareOnDesktop } from "./HandleShare";
import { getImageColors, generateCaption, getCachedColor, useSessionCache, useIndexedDBCache } from "./GetImageColors";
import { Link, useLocation, useMatch, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import AppShareer from "./AppShareer";
import Alert from "./Alert";
import { toast } from "react-toastify";
import Masonry from "react-masonry-css";
import Tooltip from "./Tooltip";
import { content, timeBasedContent, fallbackKeywords, timeCategoryResolver, isNatureQuery } from "./ImagesCategory";
import { saveMessages } from "./savedMessage";
import {hitDownload, makeButtonSmall, makeButtonBig, showPostReady, formatLikeCount, createSafePixabayQuery, timeForPage, trackEvent, trackImages} from  "./UtilsFunction"
import WeeklyForms from "./WeeklyForm";
import { GetCaptionForImages } from "./GetCaptionForImages";
import "./ImageTopAction.css"
import {pickStrongTopImages, rankImages, rankLongExploreNextImages, rankRightRelatedImages, softSortByInterest} from "./GoogleSearchRanking"
import { StatusDownloadCard } from "./StatusDownloadCard";
import "./ExploreImageHoverControls.css"
import RenderImageBatches, { CreatorsBadge }  from "./RenderImageBatches";
import RenderImageOverlay from "./RenderImageOverlay";
import RenderImageOverlayForBackground from "./RenderImageOverlayForBackground";
import { GetTopTags, BuildChips } from "./BuildImageChips";
import { FiDownload } from "react-icons/fi";
import {fetchCuratedExploreNextImages} from "../utils/ImagesUtils"
import { getImageQualityScore } from "./CheckImageQuality";
import { PintrestJson } from "../data/featuredImages";
import ranking from "../data/ranking.json";
import { ExploreIntent } from "./ExploreIntent";
import "./PostCard.css"
import { rankForUserAction } from "./GoogleSearchRankingV1";
import {adjustRankingByPerformance } from "../recommendations/adjustRankingByPerformance";

const pexelsImagesRef = {
  current: []
};
let pexelsRequest = null;

const STOP_WORDS = new Set([
    "man",
  "woman",
  "people",
  "person",
  "male",
  "female",
  "lover",
  "nature",
  "landscape",
  "photo",
  "image",
  "wallpaper"
]);

const SaveButton = React.memo(({ image, handleSaveImage, downloadImageFromButton, isMobile }) => {
  const [saved, setSaved] = useState(false);
  const displaySave = true;

  useEffect(() => {
    const savedLS = JSON.parse(
      localStorage.getItem("savedImages") || "[]"
    );

    setSaved(savedLS.some((img) => img.id === image.id));

    const syncSaveState = (e) => {
      if (e.detail.id === image.id) {
        setSaved(true);
      }
    };

    window.addEventListener("BN_SAVE_UPDATED", syncSaveState);

    return () =>
      window.removeEventListener("BN_SAVE_UPDATED", syncSaveState);
  }, [image.id]);

  const onSaveClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    handleSaveImage(image.id, image, false, false);
    setSaved(true);
  };
     const onDownloadClick = (event) => {
      event.stopPropagation();
      event.preventDefault();

      downloadImageFromButton(image);
    };

  const onAnimateClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    trackEvent("animate_request", {
      from: timeForPage(),
      viewed3SImageUrl: image?.previewURL

    })

    toast.info("Animate Photo is coming soon! 🎬");
  };

  function DeskTopSaveIcon({saved}){
    return(saved ? (<><i className="fa-solid fa-circle-check saved_action_icon"></i> Saved </>): (<> Save <i className="fa-solid fa-circle-plus save_action_icon" style={{color: "white"}}></i></>))
  }
  function MobileSaveIcon({saved}){
    return(saved ? "Saved" : "Save")
  }

  return displaySave ? (
    <div
      className="saved_badge main_action_button main_save_button"
      onClick={onSaveClick}
        role="button"
        tabIndex={0}
    >
      {isMobile ? <MobileSaveIcon saved={saved} /> : <DeskTopSaveIcon saved={saved} />}
      
      
      
    </div>
  ) : (
    <div
      className="saved_badge main_action_button main_save_button"
      // onClick={onAnimateClick}
      onClick={onDownloadClick}
      // title="Animate Photo — For Reels & Status"
      // title="Download image"
    >
      {/* <i className="fa-solid fa-clapperboard"></i> {" "}
      Animate */}

      Download 
    </div>
            // <i class="fa-solid fa-download explore_image_share_icon"></i>

  );
});

const captionCache = new Map();

function getStableCaption(image, imageCategory, componentFrom) {
  if (!image?._uid) return null;

  if (captionCache.has(image._uid)) {
    return captionCache.get(image._uid);
  }
let caption
  if(componentFrom === "exploreNext"){

    caption = GetCaptionForImages(image, imageCategory);
  }else{
    caption = GetCaptionForImages(image);

  }

  captionCache.set(image._uid, caption);

  return caption;
}

function getRankingExperimentVariant() {
  const storageKey = "home-ranking-ab-test";

  let variant = localStorage.getItem(storageKey);

  if (variant !== "A" && variant !== "B") {
    // variant = Math.random() < 0.5 ? "A" : "B";
    variant = "B"
    localStorage.setItem(storageKey, variant);
  }

  return variant;
}





  const animalKeywords = [
    "animal", "cow", "dog", "cat", "lion", "tiger",
    "bird", "monkey", "horse", "sheep", "goat",
    "wildlife", "pet", "puppy", "kitten",
    "chicken", "hen", "duck", "fish",
    "zoo", "farm animal", "cattle", "hourse", "elephant", "elephants", "lion", "grasshoppers", "spider",

    "insect", "insects", "grasshopper", "grasshoppers",  "katydid", "bee", "honey bee", "butterfly", "moth",  "ant", "ants", "spider",  "bug", "bugs"
  ];

// const PURPOSE_TEXTS_DESKTOP = [
//   "Images you’ll want to save ✨",          // save
//   "Perfect visuals for your next post 📸",  // share
//   "High-quality images, ready to download ⬇️", // download
//   "Explore visuals that match your vibe 🌿",   // explore
//   "Worth keeping for later 💾",              // save again
//   "Made to be shared with the world 🌍",     // share again
// ];
const PURPOSE_TEXTS_DESKTOP = [
  // "Save visuals that stand out ✨",
  // "Find images ready for your next post 📸",
  // "High-quality visuals made for creators ⬇️",
  // "Explore images tailored to your taste 🌿",
  // "Build your personal inspiration library 💾",
  // "Share visuals that get attention 🌍",


  //  "Tap image → download or explore ⬇️",
   "Perfect for wallpaper or posts 📱",
  "Perfect for stories and status 📲",
  "Save images you’ll actually use 💾",
  "Quick picks for your next upload 📸",
  "Scroll less, find better visuals ⚡",
  "Explore similar images instantly 🔍",
  "Tap image to get captions 💬",
  "Popular this week 🔥"
  
];

// const PURPOSE_TEXTS_MOBILE = [
//   "Save-worthy picks ✨",
//   "Post-ready visuals 📸",
//   "Download & use ⬇️",
//   "Explore your vibe 🌿",
//   "Keep for later 💾",
//   "Made to share 🌍",
// ];

const PURPOSE_TEXTS_MOBILE = [
  // "Save visuals you love ✨",
  // "Ready for your next post 📸",
  // "High-quality downloads ⬇️",
  // "Explore your style 🌿",
  // "Build your collection 💾",
  // "Share what stands out 🌍",

    // "Tap to download ⬇️",
    
  "Perfect for wallpaper 📱",
  "Save for later 💾",
  "Ready for your post 📸",
  "Better visuals fast ⚡",
  "Find similar images 🔍",
  "Tap image to get captions 💬",
  "Perfect for status 📲",
  "Popular this week 🔥"
];

// 🔁 Get the current hour index to rotate categories
// const updatedHours = () => new Date().getHours() % content.length;

function extractImageCategory(tagsString, categories) {
  if (!tagsString) return null;

  const tags = tagsString
    .toLowerCase()
    .split(",")
    .map(t => t.trim());

  // 1️⃣ Exact match (highest confidence)
  for (const tag of tags) {
    if (categories.includes(tag)) {
      return tag;
    }
  }

  // 2️⃣ Partial match (startup → start-up, tech → technology)
  for (const tag of tags) {
    const found = categories.find(cat =>
      tag.includes(cat) || cat.includes(tag)
    );
    if (found) return found;
  }

  // 3️⃣ Smart fallback: first meaningful tag
  return tags[0];
}

function getSessionInteractions() {
  return JSON.parse(sessionStorage.getItem("sessionInteraction") || "{}");
}

function setSessionInteractions(data) {
  sessionStorage.setItem("sessionInteraction", JSON.stringify(data));
}


// 📈 Function to update localStorage score
function updateInteractionScore(imageTags ,category, weight = 1) {
  console.log("image category", category, weight)

  const mainCategory = extractImageCategory(imageTags, content)
  console.log("main catgeoyr", mainCategory)

  const stored = localStorage.getItem("interactionScore");
  const score = stored ? JSON.parse(stored) : {};
  score[mainCategory] = (score[mainCategory] || 0) + weight;  // Increment by weight, where weight can be customized (e.g., 1 for a click, 5 for a like)
  localStorage.setItem("interactionScore", JSON.stringify(score));



  // 🔥 SESSION-TERM
  const sessionData = getSessionInteractions();
  sessionData[mainCategory] = (sessionData[mainCategory] || 0) + 1;
  setSessionInteractions(sessionData);

  // 🔥 NEW: track last explored category
  localStorage.setItem("lastExploredCategory", mainCategory);

    

}

// 🧠 Function to get next best category based on scores
function getPreferredCategory(defaultIndex) {
  const scores = JSON.parse(localStorage.getItem("interactionScore")) || {};
  const sorted = [...content].sort((a, b) => (scores[b] || 0) - (scores[a] || 0)); // Higher score = higher rank
  return sorted[0] || content[defaultIndex];  // Default to category at defaultIndex if no scores
}
function normalizeKey(str = "") {
  return str
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9\s]/g, "")
    .trim();
}

function getInteractionScores() {
  const raw =
    JSON.parse(localStorage.getItem("interactionScore") || "{}");

  const normalized = {};
  Object.keys(raw).forEach((key) => {
    normalized[normalizeKey(key)] = raw[key];
  });

  return normalized;
}

function scoreImageByInterest(img, scores) {
  let score = 0;

  const tagList =
    typeof img.tags === "string"
      ? img.tags.split(",").map(t => t.trim())
      : img.tags || [];

  const rawKeys = [
    ...tagList,
    img._category,
    img.category,
    img.q,
  ].filter(Boolean);

  const normalizedKeys = rawKeys.map(normalizeKey);

  normalizedKeys.forEach((key) => {
    // exact match
    if (scores[key]) score += scores[key];

    // partial match (CRITICAL)
    Object.keys(scores).forEach((scoreKey) => {
      if (
        key.includes(scoreKey) ||
        scoreKey.includes(key)
      ) {
        score += scores[scoreKey] * 0.4;
      }
    });
  });

  return Math.round(score);
}




function getTopInterestKeywords(limit = 3) {
  const scores = getInteractionScores();

  return Object.entries(scores)
    .sort((a, b) => b[1] - a[1])
    .map(([key]) => key)
    .slice(0, limit);
}
function stableShuffle(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
function getInterestCategoryForPage(pageNum) {
  const order = getInterestRotationOrder();
  if (!order.length) return null;

  return order[(pageNum - 1) % order.length];
}

function getInterestRotationOrder() {
  const cached = sessionStorage.getItem("interestRotationOrder");
  if (cached) return JSON.parse(cached);

  const scores = getInteractionScores();
  if (!scores || Object.keys(scores).length === 0) return [];

  // group by score
  const grouped = {};
  Object.entries(scores).forEach(([key, score]) => {
    grouped[score] = grouped[score] || [];
    grouped[score].push(key);
  });

  // sort scores desc and shuffle ties ONCE
  const order = Object.keys(grouped)
    .sort((a, b) => b - a)
    .flatMap(score => stableShuffle(grouped[score]));

  sessionStorage.setItem(
    "interestRotationOrder",
    JSON.stringify(order)
  );

  return order;
}




function getRotatingInterestCategory() {
  const order = getInterestRotationOrder();
  if (order.length === 0) return null;

  const idx =
    Number(sessionStorage.getItem("interestRotateIndex") || 0);

  const category = order[idx % order.length];

  sessionStorage.setItem(
    "interestRotateIndex",
    idx + 1
  );

  return category;
}

function getTargetTag(image) {
  if (!image?.pageURL) return null;

  // return image.description;
  // return image.name;

  const parts = image.pageURL.split("/").filter(Boolean);
  const slug = parts[parts.length - 1];

  // Remove the trailing image ID
  return slug.replace(/-\d+$/, "");
}


async function fetchInterestImages() {
  const keywords = getTopInterestKeywords(5); 

  if (keywords.length === 0) return [];

const primaryCategory = keywords[0]; 

  const query = keywords.join(" ");
  


//   const category = getRotatingInterestCategory(); // ✅ USE ROTATION
//   if (!category) return [];
//   const secondary = getTopInterestKeywords(3).filter(k => k !== category);
// const query = category

  try {
    const res = await fetch(
      `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&per_page=30`
    );

    const data = await res.json();
    // return data.hits || [];
      return (data.hits || []).map(img => ({
      ...img,
      // _category: category,   // ✅ CATEGORY ATTACHED
      // _category: primaryCategory,   
      _category: getTargetTag(img),   
      
      _source: "interest",
    }));
  } catch {
    return [];
  }
}

function preloadImages(images = []) {

  images.forEach((img) => {

    const image = new Image();

    image.src =
      img.largeImageURL ||
      img.webformatURL ||
      img.previewURL;

  });

}


const ExploreMasonry = (props) => {
  // let content = [ "couples", "Fashion", "Sports", "Music", "Gaming", "Technology", "Health", "Finance", "Education", "Lifestyle"]
    

  // const [index, setIndex] = useState(updatedHours());
  const [index, setIndex] = useState(0);
  const [blogView, setBlogView] = useState(true);
  const [loader, setloader] = useState(true);
  const [images, setImages] = useState([]); // assume this is where you get your images
  const [imageStates, setImageStates] = useState({});
  const blogColRef = useRef([])
  const bottomObserverRef = useRef([])        // target as last element for infintnite loop
  const [pageState, setPageState] = useState(1)
  // const [pageState, setPageState] = useState(50)
  const exploreRef = useRef(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 580);
  const exploreNextRoute = useMatch("/explore-next/:type/:imageTag");    
  const exploreRoute = useMatch("/explore");
  const arrivalTime = new Date();
  const time = arrivalTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  })

  
useEffect(() => {
  const onResize = () => setIsMobile(window.innerWidth <= 580);
  window.addEventListener("resize", onResize);
  return () => window.removeEventListener("resize", onResize);
}, []);

  
  
  
  const [trakImages, setTrakImage] = useState(true);
  const [bottomLoader, setBottomLoader] = useState(false);
  const navigate = useNavigate()
  const [clickedTag, setClickedTag] = useState("")      // for tags
  const [showLike, setShowLike] = useState(sessionStorage.getItem("showLikes") ?? true)      // show like on mobile only
  // Prevents reloading of already loaded images
const location = useLocation();

// const { getCache, setCache, clearCache } = useSessionCache(props.componentFrom === "exploreNext" ? "exploreNext": "exploreImages");
// const { getCache, setCache, clearCache, dbReady  } = useIndexedDBCache("exploreImages");
const { getCache, setCache, clearCache } = useIndexedDBCache();
const [closingTexts, setClosingTexts] = useState(new Set());
const [dismissedTexts, setDismissedTexts] = useState(new Set());


const dismissText = (key) => {
  // step 1: start animation
  setClosingTexts(prev => {
    const next = new Set(prev);
    next.add(key);
    return next;
  });

  // step 2: remove after animation
  setTimeout(() => {
    // setDismissedTexts(prev => {
    //   const next = new Set(prev);
    //   next.add(key);
    //   return next;
    // });
    let dismissText = document.getElementById(key)
    if(dismissText){
      dismissText.remove()
    }


  }, 220); // must match CSS duration
};
 
  useEffect(()=>{
    if(props.componentFrom === "exploreNext"){
      setTrakImage(false)
      // setImages([])
    }
  
  

  }, [])
const fetchedPages = useRef(new Set()); 


  const baseUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${content[index]}&image_type=photo`


  function RemoveDuplicateHits(query, pageNum){

  }

  
function getBeautifulImages(result, perItems = 0, beauty = true) {


  if(beauty){

    return result.filter(img => img.likes > 450 && img.downloads > 1000 && img.imageWidth > 2000)
      .map(img => ({
        ...img,
        score: img.likes * 2 + img.downloads * 0.5 + img.comments * 1.5
      }))
      .sort((a, b) => b.score - a.score)
      .slice(0, perItems);
  }else{
      return perItems > 0 ? result.slice(0, perItems) : result;
  }
}

function prepareLayout(resultImages, startingFrom, endFrom){
   const hits = resultImages.slice(startingFrom, endFrom);

  // Trim to multiple of 3 for neat Masonry rows
  const cleanCount = hits.length - (hits.length % 3);
  let cleanHits = hits.slice(0, cleanCount);

  // Check if last image is too tall
  const lastImage = cleanHits[cleanHits.length - 1];
  const secondLast = cleanHits[cleanHits.length - 2];

  // Sometimes Pixabay gives aspect ratios that create vertical gaps
  if (
    lastImage &&
    secondLast &&
    lastImage.imageHeight / lastImage.imageWidth > 1.4 && // very tall image
    secondLast.imageHeight / secondLast.imageWidth < 1.2 // normal width ones
  ) {
    // Fill the space with 2 more balanced images
    const fillImages = resultImages.slice(cleanHits.length, cleanHits.length + 2);
    cleanHits = [...cleanHits, ...fillImages];
  }
  return cleanHits
}


// function prepareLayout(
//   resultImages,
//   startingFrom,
//   totalItems,
//   forWhichSection = "forExplores"

// ) {

//   // ✅ TAKE next items properly
//   const hits = resultImages.slice(
//     startingFrom,
//     startingFrom + totalItems
//   );

//   // Trim to multiple of 3
//   const cleanCount =
//     hits.length - (hits.length % 3);

//   let cleanHits =
//     hits.slice(0, cleanCount);

//   // Check tall image balancing
//   const lastImage =
//     cleanHits[cleanHits.length - 1];

//   const secondLast =
//     cleanHits[cleanHits.length - 2];

//   if (
//     lastImage &&
//     secondLast &&
//     lastImage.imageHeight /
//       lastImage.imageWidth > 1.4 &&
//     secondLast.imageHeight /
//       secondLast.imageWidth < 1.2
//   ) {

//     const fillImages =
//       resultImages.slice(
//         startingFrom + cleanHits.length,
//         startingFrom + cleanHits.length + 2
//       );

//       if(forWhichSection === "forExplores"){

//         cleanHits = [
//           ...fillImages
          
//         ];
//       }else{

//         cleanHits = [
          
//           ...fillImages
//         ];

//       }
//   }

//   return cleanHits;
// }



async function fallbackImagesLoad() {
  console.log("fallback images load runs...");

   
  // setBottomLoader(false);     

  const randomKeyword = fallbackKeywords[Math.floor(Math.random() * fallbackKeywords.length)];

  blogColRef.current = [];
  fetchedPages.current.clear();
  setPageState(1);

  const fallbackURL = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${randomKeyword}&image_type=photo&page=1`;

  try {
    const fallbackResponse = await fetch(fallbackURL);
    const fallbackData = await fallbackResponse.json();

    console.log("fallback results", fallbackData?.hits?.length);

    if (fallbackData?.hits && fallbackData.hits.length > 0) {
      setupImageOnPage(fallbackData);
      fetchLock.current = false;   
      console.log("fallback results displayed 🚀");
    } else {
      console.log("⚠ No fallback results");
      // Optional: show empty state UI here
    }
  } catch (err) {
    console.error("fallback loading failed", err);
    setBottomLoader(false)
  } finally {
    fetchLock.current = false; 
  }
}

function notifyImageCount(images) {
  if (
    (props.displayFor === "personalized" || props.displayFor === "homeTopic")  &&
    typeof props.onImagesLoaded === "function"
  ) {
    props.onImagesLoaded(images?.length || 0);
    console.log("notify image beased on activity", images?.length)
  }
}

 



const savedPoolRef = useRef([]);
const savedIndexRef = useRef(0);
const interestPoolRef = useRef([]);
const interestIndexRef = useRef(0);

function shuffleOnce(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// async function loadSavedImagesOnce() {
//   if (savedPoolRef.current.length > 0) return;

//   try {
//     let savedFromLocal =
//       JSON.parse(localStorage.getItem("savedImages")) || [];

//     if (!Array.isArray(savedFromLocal) || savedFromLocal.length === 0) {
//       console.log("No saved images in localStorage");
//       return;
//     }

//     // shuffle once
//     const randomized = shuffleOnce(savedFromLocal);

//     // extract IDs
//     const ids = randomized.map(img => img.id).filter(Boolean);

//     const results = await Promise.all(
//       ids.map(async (id) => {
//         try {
//           // const response = await fetch(
//           //   `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&id=${id}`
//           // );
//           const response = safeFetch(
//             `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&id=${id}`
//           );

//           const data = await response.json();

//           return data.hits?.[0] || null;
//         } catch {
//           return null;
//         }
//       })
//     );

//     const validImages = results.filter(Boolean);

//     savedPoolRef.current = validImages.map((img, i) => ({
//       ...img,
//       _isUserSaved: true,
//       _orderIndex: i,
//       imageColor: img.imageColor || "#ffffff",
//     }));

//     console.log("✅ Loaded saved images via API:", savedPoolRef.current);
//   } catch (err) {
//     console.error("Failed to load saved images", err);
//   }
// }

async function loadSavedImagesOnce() {
  if (savedPoolRef.current.length > 0) return;

  try {
    let savedFromLocal =
      JSON.parse(localStorage.getItem("savedImages")) || [];

    if (!Array.isArray(savedFromLocal) || savedFromLocal.length === 0) {
      console.log("No saved images in localStorage");
      return;
    }

    // shuffle once
    const randomized = shuffleOnce(savedFromLocal);

    // extract IDs
    const ids = randomized.map(img => img.id).filter(Boolean);

    // 🔥 LIMIT initial load (very important)
    const limitedIds = ids.slice(0, 6);

    const results = [];

    // ✅ SEQUENTIAL (no burst, no Promise.all)
    for (let i = 0; i < limitedIds.length; i++) {
      try {
        const response = await safeFetch(
          `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&id=${limitedIds[i]}`
        );

        const data = await response.json();

        if (data.hits?.[0]) {
          results.push(data.hits[0]);
        }
      } catch (err) {
        console.log("Error loading saved image:", limitedIds[i]);
      }
    }

    const validImages = results.filter(Boolean);

    savedPoolRef.current = validImages.map((img, i) => ({
      ...img,
      _isUserSaved: true,
      _orderIndex: i,
      imageColor: img.imageColor || "#ffffff",
    }));

    console.log("✅ Loaded saved images via API:", savedPoolRef.current);

  } catch (err) {
    console.error("Failed to load saved images", err);
  }
}

function shouldInjectSavedImages(pageNum) {
  return pageNum >= 2; // after first page
}
// function shouldInjectSavedImages(pageNum) {
//   return pageNum >= 2 && pageNum % 2 === 0;
// }

// function getSavedBatchCount(pageNum) {
//   return 3; // small, steady resurfacing
// }

function getSavedBatchCount(pageNum) {
  if (pageNum === 2) return 5;
  if (pageNum === 4) return 7;
  return 0;
}

function mixSavedImages(normalImages, pageNum) {
  if (!shouldInjectSavedImages(pageNum)) return normalImages;

  const count = getSavedBatchCount(pageNum);
  if (count === 0) return normalImages;

  const saved = savedPoolRef.current.slice(
    savedIndexRef.current,
    savedIndexRef.current + count
  );

  savedIndexRef.current += count;

  // Insert saved images after first few normals
  const insertAt = Math.min(4, normalImages.length);
  const mixed = [
    ...normalImages.slice(0, insertAt),
    ...saved,
    ...normalImages.slice(insertAt),
  ];

  return mixed;
}

async function loadInterestImagesOnce() {
  const interactionScore =
    JSON.parse(localStorage.getItem("interactionScore") || "{}");

  const canPersonalize = Object.keys(interactionScore).length >= 3;
  if (!canPersonalize) return;

  if (interestPoolRef.current.length > 0) return;

  

  const interestHits = await fetchInterestImages();

  if (interestHits.length > 0) {
    interestPoolRef.current = interestHits;
    console.log("🔥 Loaded interest pool:", interestHits.length);
  }
}

async function loadInterestImagesForCategory(category) {
  if (interestPoolRef.current[category]) return;

  try {
    // const res = await fetch(
    //   `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(category)}&image_type=photo&per_page=30`
    // );
    const res = await safeFetch(
      `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(category)}&image_type=photo&per_page=30`
    );

    const data = await res.json();

    interestPoolRef.current[category] = {
      images: data.hits || [],
      index: 0,
    };

    console.log("load interest pool",  interestPoolRef.current);
  } catch (e) {
    console.error("Failed to load interest category", category);
  }
}



function shouldInjectInterest(pageNum) {
  // return pageNum >= 2 && pageNum % 2 === 0;
  return pageNum >= 1;;
}

function getInterestBatchCount(pageNum) {
  // return 5;
    if (pageNum === 1) return 10;
  if (pageNum === 2) return 8;
  if (pageNum === 3) return 10;
  if (pageNum >= 4) return 12;
}

function getRotatingInterestCategoryAt(index) {
  const order = getInterestRotationOrder();
  if (order.length === 0) return null;
  return order[index % order.length];
}



// function mixInterestImages(normalImages, pageNum) {
//   if (!shouldInjectInterest(pageNum)) return normalImages;
//   if (interestIndexRef.current >= interestPoolRef.current.length)
//     return normalImages;
  

//   const count = Math.min(
//     getInterestBatchCount(pageNum),
//     interestPoolRef.current.length - interestIndexRef.current
//   );

//   const interestBatch = interestPoolRef.current.slice(
//     interestIndexRef.current,
//     interestIndexRef.current + count
//   ).map(img => ({
//       ...img,
//       _isInterestImage: true, // ✅ THIS IS THE KEY
//     }));
// ;

//   interestIndexRef.current += count;

//   const insertAt = Math.min(4, normalImages.length);

//   return [
//     ...normalImages.slice(0, insertAt),
//     ...interestBatch,
//     ...normalImages.slice(insertAt),
//   ];
// }

const interestInjectedPagesRef = useRef(new Set());

function mixInterestImages(normalImages, pageNum) {
  if (!shouldInjectInterest(pageNum)) return normalImages;

  const category = getInterestCategoryForPage(pageNum);
  const pool = interestPoolRef.current[category];

  if (!pool || pool.images.length === 0) return normalImages;

  const count = pageNum === 1 ? 15 : 20;

  // const batch = pool.images.slice(
  //   pool.index,
  //   pool.index + count
  // );

  const batch = pool.images
  .slice(pool.index, pool.index + count)
  .map(img => ({
    ...img,
    _isInterestImage: true,   // ✅ REQUIRED
    _category: category,     // ✅ REQUIRED (for badge text)
    _uid: `${img.id}-interest-${category}`, 
    // _uid: `${img.id}-${img.webformatURL}-${img.webformatWidth}`, 
  }));

  pool.index += count;

  if (batch.length === 0) return normalImages;

  const insertAt = Math.min(4, normalImages.length);

  return [
    ...normalImages.slice(0, insertAt),
    ...batch,
    ...normalImages.slice(insertAt),
  ];
}




let requestQueue = Promise.resolve();
let queueLength = 0;

function safeFetch(url, fetchPexelsImage = false) {
  queueLength++;

  requestQueue = requestQueue.then(async () => {
    try {
      if (queueLength > 10) {
        await new Promise(r => setTimeout(r, 500));
      }

      await new Promise(r => setTimeout(r, 300));
      let res
      if(fetchPexelsImage){

            res = await fetch(url,
            {
              headers: {
                Authorization: "t3EEwN3KyliycBEUbAqzdCAC1uUoGoWl717OzmnnguaFBhbDGpI4wfwX"
              }
            }
          );

      }else{
        res = await fetch(url);

      }
      

      if (res.status === 429) {
      // if (true) {
        console.log("🚨 TESTING PIXABAY 429 FALLBACK");

        // await new Promise(r => setTimeout(r, 2000));
        // res = (url.includes("pexels")) ? await fetch(url,
        //     {
        //       headers: {
        //         Authorization: "t3EEwN3KyliycBEUbAqzdCAC1uUoGoWl717OzmnnguaFBhbDGpI4wfwX"
        //       }
        //     }
        //   ) : await fetch(url) 

          if(props.componentFrom === "home"){
           let fallbackQuery 
            

    if (props.displayFor === "homeTopic") {
      fallbackQuery = props.forcedCategory;
    } else {
      fallbackQuery = moodQuery;
    }

          callExploreNextFallback(fallbackQuery, 1, "pixabay_rate_limit")
        }
           throw new Error("PIXABAY_RATE_LIMIT");
      }

      return res;

    } finally {
      console.log("Queue length:", queueLength);

      queueLength--; // ✅ ALWAYS runs
    }
  });

  return requestQueue;
}



async function exploreNextFetchImages(exploreNextInfiniteScroll, exploreNextUrl, pageNum, cacheKey){
  // try {

  // 🔥 1) Infinite scroll → ALWAYS fetch new pages
  let exploreNextPhotos
  if (exploreNextInfiniteScroll) {

    console.log("⬇️ Infinite scroll page", pageNum);

    const response = await safeFetch(exploreNextUrl);
    exploreNextPhotos = await response.json();

    setCache(cacheKey, exploreNextPhotos);

  }

  // 🔥 2) Initial load (page 1 shared between components)
  else {

    // ⭐ Memory cache first
    if (exploreNextDataRef.current[props.displayImage]) {

      exploreNextPhotos =
        exploreNextDataRef.current[props.displayImage];

      console.log("⚡ Using memory cache");

    }

    // ⭐ Otherwise fetch once
    else {

      const response = await safeFetch(exploreNextUrl);

      exploreNextPhotos = await response.json();

      exploreNextDataRef.current[props.displayImage] =
        exploreNextPhotos;

      setCache(cacheKey, exploreNextPhotos);

      console.log("🌐 Fetched from API");
    }
  }

  // --------------------------------------

  const fullHits = exploreNextPhotos?.hits || [];

  // ⭐ Short section (Google preview)
  if (props?.exploreNextType === "short") {

    let strongTopImages = pickStrongTopImages(fullHits, props.displayImage, 9, showPexelsOnShortSection);
   

    setupImageOnPage({ hits: strongTopImages });

  }

  // ⭐ Long section (main feed)
  else {

    const remainingImages = fullHits.slice(8);

    setupImageOnPage({ hits: remainingImages });

  }

// }
}


async function fetchPexelsImages(url) {
  try {

    
    const response = await safeFetch(url, true)

    const result = await response.json();

    return result.photos || [];

  } catch (error) {

    console.log("pexels fetch error", error);

    return [];
  }
}

function randomPexelsRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getNormalizedDimensions(photo) {

  const originalWidth =
    photo.width || 1000;

  const originalHeight =
    photo.height || 1000;

  const aspectRatio =
    originalWidth / originalHeight;

  // 🔥 normalized width
  const normalizedWidth = 1000;

  // 🔥 calculate proportional height
  let normalizedHeight =
    normalizedWidth / aspectRatio;

  // 🔥 clamp very tall images
  const MAX_HEIGHT = 1800;
  const MIN_HEIGHT = 600;

  normalizedHeight = Math.max(
    MIN_HEIGHT,
    Math.min(normalizedHeight, MAX_HEIGHT)
  );

  return {
    width: normalizedWidth,
    height: Math.round(normalizedHeight),
  };
}

function normalizePexelsImages(photos = [], imageTopic) {

  console.log("pexels response", photos)
 return photos.map((photo) => {
    
    const dimensions = getNormalizedDimensions(photo);


return{
    id: `${photo.id}`,

    webformatURL: photo.src.large,

    largeImageURL: photo.src.large2x,

    previewURL: photo.src.tiny,

    // webformatWidth: 880,
    webformatWidth: dimensions.width,

    // webformatHeight: 940,
    // webformatHeight:  dimensions.height,
    webformatHeight:  dimensions.height,
    imageNewHeight: getRandomPexelsHeight(),

    // imageWidth: 880,    
    // imageHeight: 940,
    imageWidth: photo.width,    
    imageHeight: photo.height,

    previewWidth: 280,

    likes:  randomPexelsRange(3000, 5000),

    views: randomPexelsRange(10000,  12000),

    downloads: randomPexelsRange(7000,  9000),

    tags: photo.alt || "pexels image",

    user: photo.photographer,

    pageURL: photo.url ,

    type: "photo",

    _source: "pexels",
    _uid: `pexels-${photo.id}`,

    _category: imageTopic || props?.displayImage,
}
  });
}

const pexelsSeenRef = useRef(new Set())
function removeDuplicatePixelsImage(normalizedPexels){

  return normalizedPexels.filter(
    img => {

      const key =
        `pexels-${img.id}`;

      if (
        pexelsSeenRef.current.has(
          key
        )
      ) {

        return false;

      }

      pexelsSeenRef.current.add(
        key
      );

      return true;

    }
  );

}


let showPexelsOnShortSection = true 
// let showPexelsImagePage = 5
let showPexelsImagePage = 3
// const pexelsImagesRef = useRef([]);
async function callPexel(imageTopic, pageNumber, initalLoadPage){
  // if(props?.exploreNextType === "long" && Number(pageNumber) === 2)  return
    // Already have Pexels images → don't call API again
    // Already fetched → return existing images
 if (pexelsImagesRef.current.length > 0) {
    return pexelsImagesRef.current;
  }
  
    // Request already running
  if (pexelsRequest) {
    return pexelsRequest;
  }

  // if(props?.exploreNextType === "short")  return

  let blockedPages =  Number(pageNumber) === 3  || Number(pageNumber) === showPexelsImagePage 

// if(props?.exploreNextType === "long" || blockedPages){
// if(props?.exploreNextType === "long" && Number(pageNumber) < showPexelsImagePage){
//   if((!showPexelsOnShortSection && props?.exploreNextType === "short") || Number(pageNumber) < showPexelsImagePage)  return
  

// }

  // if((!showPexelsOnShortSection && props?.exploreNextType === "short") || Number(pageNumber) === showPexelsImagePage || Number(pageNumber) === 5)  return
  // if((!showPexelsOnShortSection && props?.exploreNextType === "short"))  return
  console.log("fecth pexels...", pageState, pageNumber)

  
    let normalizedPexels = []
    
    // const itemPerPage = Number(pageNumber) === Number(initalLoadPage) ? 4 : 5
    // const itemPerPage = props?.exploreNextType === "long" &&  Number(pageState) <= 6 ? 6 : 5
    const itemPerPage = 20

    // const itemPerPage = 4
    const pexelsUrl = `https://api.pexels.com/v1/search?query=${encodeURIComponent(imageTopic)}&page=${pageNumber}&per_page=${itemPerPage}`;

//     const pexelsPhotos = await fetchPexelsImages(pexelsUrl);
//     normalizedPexels = normalizePexelsImages(pexelsPhotos, imageTopic);
// normalizedPexels = removeDuplicatePixelsImage(normalizedPexels)
//   pexelsImagesRef.current = normalizedPexels;

  pexelsRequest = (async () => {

    const pexelsPhotos =
      await fetchPexelsImages(pexelsUrl);

    let normalizedPexels =
      normalizePexelsImages(
        pexelsPhotos,
        imageTopic
      );

    normalizedPexels =
      removeDuplicatePixelsImage(
        normalizedPexels
      );

    pexelsImagesRef.current = normalizedPexels;

    return pexelsImagesRef.current;

  })();

  console.log("fecth pexels... reslut", normalizedPexels)

// return pexelsImagesRef.current
 return pexelsRequest;

}


// function mixPexelsAndPixabay(
//   exploreNextPhotos,
//   normalizedPexels, pageState
// ) {

//   const pixabayHits =
//     exploreNextPhotos?.hits || [];

//   const pexelsHits =
//     normalizedPexels || [];

//   const fullHits = [];

//   // const maxLength = Math.max(
//   //   pixabayHits.length,
//   //   pexelsHits.length
//   // );

// //   if (
// //   props?.exploreNextType === "long" &&
// //   Number(pageState) <= 20
// // ) {
// //   // return pexelsHits;
// //   return pixabayHits;
// // }

//   const maxLength =  pixabayHits.length  +  pexelsHits.length
  

//   for (let i = 0; i < maxLength; i++) {

//     // 🔥 SHORT SECTION
//     if (props?.exploreNextType === "short") {

//       // aggressive variety
//       if (pexelsHits[i]) {
//         fullHits.push(
//           pexelsHits[i]
//         );
//       }

//       if (pixabayHits[i]) {
//         fullHits.push(
//           pixabayHits[i]
//         );
//       }

//     }

//     // 🔥 LONG SECTION
//     else {

//       // FIRST 15:
//       // mostly Pixabay

       


//       // if (i  < 15 ) {
//       if (Number(pageState) <= 4) {
//       // if (Number(pageState) < showPexelsImagePage) {   

//       if ((i === 0 || i === 3) && pexelsHits[i]) {
//     fullHits.push(pexelsHits[i]);
//   }


//         if (pixabayHits[i]) {
//           fullHits.push(
//             pixabayHits[i]
//           );
//         }

//       }
      

   

//       else {

//            if (i % 4 === 0 &&  pexelsHits[i]) {
//           //  if (pexelsHits[i]) {
//           fullHits.push(
//             pexelsHits[i]
//           );
//         }

//         if (pixabayHits[i]) {
//           fullHits.push(
//             pixabayHits[i]
//           );
//         }

//         // const displayPexcelPerItem = Number(pageState) === 4 ? 2 : 2
//         const displayPexcelPerItem = Number(pageState) === 4 || Number(pageState) === 3  ? 3 : 5

//         // if (i % displayPexcelPerItem === 0 &&  pexelsHits[i]) {
//         // if (i % displayPexcelPerItem === 0 &&  pexelsHits[i]) {
//         // if (pexelsHits[i]) {
//         //   fullHits.push(
//         //     pexelsHits[i]
//         //   );
//         // }

//       }

//     }

//   }

//   console.log("mixPexel", props?.exploreNextType, pageState,  fullHits)

//   return fullHits;

// }

function mixPexelsAndPixabay(
  exploreNextPhotos,
  normalizedPexels,
  pageState
) {
  const pixabayHits = exploreNextPhotos?.hits || [];

  const fullHits = [];

  // =========================
  // SHORT SECTION
  // =========================
  if (props?.exploreNextType === "short") {

    // Take only 3 Pexels images
    const shortPexels =
      pexelsImagesRef.current.splice(0, 3);

    // Add the 3 Pexels images
    fullHits.push(...shortPexels);

    // Add Pixabay images
    fullHits.push(...pixabayHits);

    console.log(
      "SHORT Pexels:",
      shortPexels.length,
      "Remaining Pexels:",
      pexelsImagesRef.current.length
    );

    return fullHits;
  }


  // =========================
  // LONG SECTION
  // =========================
  if (props?.exploreNextType === "long") {

    // Take exactly ONE Pexels image
    const pexelsImage =
      pexelsImagesRef.current.shift();

    // Add Pexels image if available
    if (pexelsImage) {
      fullHits.push(pexelsImage);
    }

    // Add all Pixabay images
    fullHits.push(...pixabayHits);

    console.log(
      "LONG page:",
      pageState,
      "Pexels added:",
      pexelsImage ? 1 : 0,
      "Remaining Pexels:",
      pexelsImagesRef.current.length
    );

    return fullHits;
  }


  // =========================
  // FALLBACK
  // =========================
  return pixabayHits;
}


function getRankedImages(query = "", ideasSection = false, offset = 0, limit = 4) {
  const words = query.toLowerCase().split(/\s+/);

  const filtered = ranking.filter(item => {
    // const category = item.category.toLowerCase();
    const category = item.redirectURL.toLowerCase();

    return words.some(word => category.includes(word));
  });

  if (ideasSection) {
    return filtered
      .sort((a, b) => b.score - a.score)
      .slice(offset, offset + limit);
  }

  return filtered;
}
function normalizeRankingImage(item) {

  if (item.source === "pixabay") {

    return {
      id: Number(item.imageId),

      tags: item.redirectURL,

      _source: "pixabay",

      previewURL: item.previewURL,
      webformatURL: item.webformatURL,
      largeImageURL: item.largeImageURL,

      pageURL: item?.redirectURL || item?.category,

      imageWidth: item.imageWidth,
      imageHeight: item.imageHeight,

      webformatWidth: item.webformatWidth,
      webformatHeight: item.webformatHeight,

     likes:  randomPexelsRange(3000, 5000),

    views: randomPexelsRange(10000,  12000),

    downloads: randomPexelsRange(7000,  9000),

      _rankingScore: item.score,
      _category: item.category,
    };
  }

  if (item.source === "pexels") {

    return {
      id: Number(item.imageId),

      tags: item.redirectURL,

      _source: "pexels",

      previewURL: item.previewURL,
      webformatURL: item.webformatURL,
      largeImageURL: item.largeImageURL,

      pageURL: item?.redirectURL || item?.category,

      imageWidth: item.imageWidth,
      imageHeight: item.imageHeight,

      webformatWidth: item.webformatWidth,
      webformatHeight: item.webformatHeight,

    likes:  randomPexelsRange(3000, 5000),

    views: randomPexelsRange(10000,  12000),

    downloads: randomPexelsRange(7000,  9000),

      _rankingScore: item.score,
      _category: item.category,
    };
  }

  return null;
}

function singular(word) {
  if (word.endsWith("s") && word.length > 3) {
    return word.slice(0, -1);
  }
  return word;
}

function injectRankingImages(images, pageNum, query) {

    // if (pageNum <= 4) return images;
    if(props?.exploreNextType === "short" || Number(pageNum) < 5) return images
    console.log("inject ranking images")
const PAGE_SIZE = 20;

    // const ranked = getRankedImages(query).map(normalizeRankingImage);
    const ranked = getRankedImages(query).sort((a, b) => b.score - a.score).slice(
    (pageNum - 1) * PAGE_SIZE,
    pageNum * PAGE_SIZE
  ).map(normalizeRankingImage).filter(Boolean);
console.log("ranking mainobjecgt", ranked)
    if (!ranked.length) return images;
    const existing = new Set(images.map(i => i.id));

    const uniqueRanked = ranked.filter(
        img => !existing.has(img.id)
    );

    const result = [];

    let rankIndex = 0;

    images.forEach((img, index) => {

        if (index % 3 === 0 && rankIndex < uniqueRanked.length) {

            result.push(uniqueRanked[rankIndex++]);

        }

        result.push(img);
 
    });

    // 👇 Append all remaining ranking images
while (rankIndex < uniqueRanked.length) {
    result.push(uniqueRanked[rankIndex++]);
}

    return result;
}

function injectFeaturedImages(images, pageNum, query) {
 
  if (Number(pageNum) <= 6) return images;

  const words = query.toLowerCase().split(/[-\s]+/).filter(Boolean);

  const matchedImages = PintrestJson.filter(item =>
    words.some(word =>
      item._category.toLowerCase().includes(word)
    )
  );

  console.log("matched images from pintrest", matchedImages)


  if (matchedImages.length === 0) {
    return images;
  }

  const result = [];
  let featuredIndex = 0;

  images.forEach((image, index) => {
    // Insert a featured image before every group of 4 normal images
    if (index % 8 === 0 && featuredIndex < matchedImages.length) {    
      result.push(matchedImages[featuredIndex++]);
    }

    result.push(image);
  });

  // If any featured images remain, append them
  while (featuredIndex < matchedImages.length) {
    result.push(matchedImages[featuredIndex++]);
  }

  return result;
}
const exploreNextDataRef = useRef({});


const hasSentInitialImages = useRef(false);
const basePageRefForExploreNext = useRef(null);
const imageBufferRef = useRef([]);
const bufferedPageRef = useRef(0);

async function fetchBufferedPages(query, startPage) {

    const pages = [
        startPage,
        startPage + 1,
        startPage + 2
    ];

    const responses = await Promise.all(

        pages.map(async page => {

            const response = await safeFetch(

                `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&page=${page}`

            );

            return response.json();

        })

    );

    //--------------------------------------------------
    // Merge all pages
    //--------------------------------------------------

    let allHits = responses.flatMap(r => r.hits || []);

    //--------------------------------------------------
    // Remove invalid
    //--------------------------------------------------

    allHits = returnValidImage(allHits);

    //--------------------------------------------------
    // Remove duplicates
    //--------------------------------------------------

    const seen = new Set();

    allHits = allHits.filter(img => {

        if (seen.has(img.id)) return false;

        seen.add(img.id);

        return true;

    });

    //--------------------------------------------------
    // Score
    //--------------------------------------------------

    allHits = allHits.map(img => ({

        ...img,

        _qualityScore:
            img.likes * 2 +
            img.downloads * 0.05 +
            img.views * 0.01

    }));

    //--------------------------------------------------
    // Sort
    //--------------------------------------------------

    allHits.sort(

        (a, b) => b._qualityScore - a._qualityScore

    );

    //--------------------------------------------------
    // First page
    //--------------------------------------------------

    const first20 = allHits.slice(0, 20);

    imageBufferRef.current = allHits.slice(20);

    setupImageOnPage(
        { hits: first20 },
        startPage
    );

}


function getRankingFallbackImages(query, pageNum) {

 
  const PAGE_SIZE = 20;

  const matchedImages = getRankedImages(query);

  const sourceImages = matchedImages.length > 0  ? matchedImages    : ranking;

  const ranked = sourceImages.sort((a, b) => b.score - a.score).slice((Number(pageNum) - 1) * PAGE_SIZE, Number(pageNum) * PAGE_SIZE).map(normalizeRankingImage).filter(Boolean);

  console.log("using fallback ranking", matchedImages.length > 0 ? "MATCHED" : "ALL RANKING",  ranked );

  return ranked;
}


function callExploreNextFallback(query,  pageNum, reason = "api_error"){
    const fallbackImages = getRankingFallbackImages(query,  pageNum);

  if (fallbackImages.length > 0) {
    console.log("Using ranking.json fallback images", fallbackImages, reason);

     trackEvent("fallback_images_displayed", {
      fallbackQuery: query,
      fallbackPageNumber: pageNum,
      fallback_count: fallbackImages.length,
      fallback_source: "ranking",
      fallback_reason: reason,
      from : timeForPage()
    });

     if (props.componentFrom === "home") {

      setupImageOnPage(
        fallbackImages,
        pageNum
      );

      return
    }

    setupImageOnPage(
      { hits: fallbackImages },
      pageNum
    );

    return;
  }

}
const loveHomeImage = props.componentFrom === "home" && props.displayFor === "homeTopic" && props.forcedCategory.includes("love");
  async function getImages(url, exploreNextInfiniteScroll = false) {
      
    console.log("loading images...")
    // trackExploreNextVisit();
    // console.log("yes getImages runs")
    if((trakImages && props.componentFrom !== "home")){
      setloader(true);

    }
    

const queryMatch = url.match(/[\?&]q=([^&]+)/i);
const query = queryMatch ? decodeURIComponent(queryMatch[1]) : "default";

const pageMatch = url.match(/[\?&]page=(\d+)/i);
const pageNum = pageMatch ? pageMatch[1] : "1";

if (props.componentFrom !== "exploreNext"  && props.componentFrom !== "home"  &&  pageNum >= 2) {
  loadSavedImagesOnce(); // non-blocking, runs once
  console.log("saved image load for explore feed")
}

// if (pageNum >= 1) {
//   loadInterestImagesOnce();
// }

// if (shouldInjectInterest(pageNum)) {
//   const order = getInterestRotationOrder();
//   const rotateIndex =  Number(sessionStorage.getItem("interestRotateIndex") || 0);

//   const category = order?.[rotateIndex % order.length];
//   if (category) {
//     loadInterestImagesForCategory(category);
//   }
// }

// if (props.componentFrom !== "exploreNext" && props.componentFrom !== "home"  && shouldInjectInterest(pageNum)) {

  
//     const order = getInterestRotationOrder();
    
//   const rotateIndex =  Number(sessionStorage.getItem("interestRotateIndex") || 0);

//   const category = order?.[rotateIndex % order.length];
//   console.log("load interest 1", category)
//   if (category) {
//     console.log("load interest 2", category)
//     loadInterestImagesForCategory(category);
//   }
// }

if (props.componentFrom !== "exploreNext" && props.componentFrom !== "home" &&  shouldInjectInterest(pageNum)) {
  const category = getInterestCategoryForPage(Number(pageNum));

  if (category) {
    loadInterestImagesForCategory(category);
  }
}



// console.log("pageNum", pageNum)
    const pageKey = `${query.toLowerCase()}-page-${pageNum}`;
  if (fetchedPages.current.has(pageKey)) {
      // fetchLock.current = false; 
    console.log("loading stopped... for fetchpages", pageKey, fetchedPages.current);
    // return;
  }
  fetchedPages.current.add(pageKey);
  // console.log("🚀 Fetching:", pageKey);

// RemoveDuplicateHits(query, pageNum)
const componentPrefix = props.componentFrom || "explore";
const cacheKey = `${componentPrefix}-${(componentPrefix === "explore") ? query : props.displayImage}-page-${pageNum}`;

    let cacheCatch =  await getCache(cacheKey)


  const urlParams = new URLSearchParams(url.split("?")[1]);
const queryFromUrl = urlParams.get("q")?.toLowerCase();

const isExploreNext = props.componentFrom === "exploreNext";
const expectedQuery = isExploreNext ? props.displayImage?.toLowerCase() : moodQuery.toLowerCase(); // fallback for explore page
  let cacheArray = cacheKey.split("-").map(item => item.toLowerCase())
// console.log("query for", cacheArray, expectedQuery, cacheArray.includes(expectedQuery))


if (
 
  cacheCatch && cacheArray.includes(expectedQuery)

) {
  // console.log("💾 Using cached result for", cacheCatch, cacheKey, queryFromUrl, expectedQuery);
  console.log("loading images from cahches...", cacheCatch);

  if(cacheCatch?.hits && cacheCatch?.hits.length > 0){
    console.log("loading images we have results from cahches...", cacheCatch);
    fetchLock.current = false;
    setupImageOnPage(cacheCatch, pageNum);
    return;

  }
}



     try {
      let response, result
      
      if(props.componentFrom !== "exploreNext"){

        // response = await fetch(url);   
        response = await safeFetch(url)
        
        result = await response.json();
        setCache(cacheKey, result); 
      }
    // console.log("cacheKey for set", cacheKey, result)
    
    if (props.componentFrom === "home") {
      // // console.log("explore images", result.hits);
      
//       const maxImages = 7;
// const hits = result.hits.slice(0, maxImages);
// const cleanCount = hits.length - (hits.length % 3);
// const cleanHits = hits.slice(0, cleanCount);
// console.log("for home data", props.displayFor, hits, result.hits)
// return

 

  
  
let maxImages = props?.showEnd === "yes" ? 6 : 12;
maxImages = ShowFoursImageInRow ? 12 : 9

if(props.displayFor === "forExplore"){

// console.log("ShowEnd debug:", {
//   showEnd: props.showEnd,
//   displayFor: props.displayFor,
//   maxImages: props.showEnd === "yes" ? 5 : 9,
//   hitsCount: result?.hits?.length
// });

     // 2️⃣ Run the SAME image-selection/ranking system
    const selectedImages = pickStrongTopImages(
      result.hits,
      moodQuery,
      maxImages,
      false
    );

    console.log("query and objects", selectedImages, moodQuery)
    
    //  let imageForFeeds = prepareLayout(result.hits, 0, maxImages)
    let imageForFeeds = selectedImages.slice(0, maxImages)
    if(!props.showEnd){

      imageForFeeds = prepareLayout(selectedImages, 0, maxImages)
    }
    console.log("ShowEnd debug: selectedImages ", selectedImages, imageForFeeds);
     const variant = getRankingExperimentVariant();
  // Version A: raw API order
  const rawApiImages = result.hits.slice(0, maxImages);
      const abTestImages = variant === "A" ? rawApiImages : imageForFeeds;
  
  // setupImageOnPage(imageForFeeds)
  setupImageOnPage(abTestImages)
// newFeed
  // setupImageOnPage(result.hits.splice(0, 12))

  // Record which ranking version was exposed
trackEvent("ranking_experiment_exposure", {
  experiment_name: `home-ranking-ab-test-${variant}-${abTestImages.length}`,
});
  
    //  ⬇️ SEND TO HOME ONLY ONCE
  if (!hasSentInitialImages.current) {
     console.log("🔥 Sending initial images to Home");
      // props.instantLoadForExplore(imageForFeeds);
      props.instantLoadForExplore(abTestImages);
      hasSentInitialImages.current = true;  
  }
} else if(props.displayFor === "forSuggested"){

  const suggestedCount = 18
//     const rankedImages = rankImages(
//   result.hits,
//   moodQuery
// );

    
      // Skip the images already eligible for Home
   // First 9 belong to Home
  // const suggestedCandidates = rankedImages.slice(
  //   9,
  //   9 + suggestedCount
  // );
 


 let imagesForSuggesstion = prepareLayout(result.hits, 10, result.hits.length)
//  let imagesForSuggesstion = prepareLayout(suggestedCandidates, 0, suggestedCandidates.length)
 let engagedImages = getBeautifulImages(imagesForSuggesstion)
 engagedImages.length > 0 ? setupImageOnPage(engagedImages) :  setupImageOnPage(imagesForSuggesstion)
// setupImageOnPage(imagesForSuggesstion)


}
else if(props.displayFor === "forSavedOthers"){
  // Fetching for the saved By Others
  try{
          // console.log("explorenext url", exploreNextUrl)
          // window.addEventListener("load", async () => {
            const hourOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 3600000);
             const page = (hourOfYear % 5) + 1;
  // const response = await fetch(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&order=popular&editors_choice=true&image_type=photo&page=${page}&per_page=50`);  
  const response = await safeFetch(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&order=popular&editors_choice=true&image_type=photo&page=${page}&per_page=50`);  
  console.log("forSavedByOthers... 1", response)
  let savedByOthers = await response.json();

  console.log("forSavedByOthers... 2", savedByOthers)
  // let maxImages =  9;
  // let higherLikes = getBeautifulImages(savedByOthers.hits, 9)
    const selectedImages = pickStrongTopImages(
      savedByOthers.hits,
      moodQuery,
      maxImages,
      false
    );


  // console.log("forSavedByOthers... 3", higherLikes)
         
          // setupImageOnPage(higherLikes)
          setupImageOnPage(selectedImages)
          // })
  }catch(error){
    console.log("fetching home saved error")
  }
  // Fetching for the saved By Others

}

else if(props.displayFor === "personalized"){
  // Fetching for the saved By Others
  try{
          // console.log("explorenext url", exploreNextUrl)
          // window.addEventListener("load", async () => {
            const hourOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 3600000);
             const page = (hourOfYear % 5) + 1;
  // const response = await fetch(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${props.forcedCategory}&image_type=photo&page=3`);  
  const response = await safeFetch(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${props.forcedCategory}&image_type=photo&page=3`);  
          let savedByOthers = await response.json();
          let higherLikes = getBeautifulImages(savedByOthers.hits, maxImages, false)
         
          setupImageOnPage(higherLikes)
             // 🔥 Tell Home how many images actually exist
    notifyImageCount(higherLikes);
          // })
  }catch(error){
      notifyImageCount([]);
    console.log("fetching home saved error")
  }
  // Fetching for the saved By Others

}else if (props.displayFor === "homeTopic") {

   try{
      // let homeTopicPage = loveHomeImage ? 1 : 2 
      // let homeTopicPage = props.homeTopicKey
      // let homeTopicPage = 5
      let homeTopicPage = 1
      
  const response = await safeFetch(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${props.forcedCategory}&image_type=photo&page=${homeTopicPage}&per_page=${(!ShowFoursImageInRow && !isMobile) ? '20' : '35'}`);  
          let savedByOthers = await response.json();
          // let higherLikes = getBeautifulImages(savedByOthers.hits, 9, false)
let imageCount = props.forcedCategory.includes("love") ? maxImages : maxImages
imageCount = props?.render_right ? 4 : imageCount
    //        const higherLikes = pickStrongTopImages(
    //   savedByOthers.hits,
    //   props.forcedCategory,
    //   imageCount,
    //   false
    // );
    
    let higherLikes 
    if (props.render_right && props.clickedImage) {
  higherLikes = rankRightRelatedImages(
    savedByOthers.hits,
    props.clickedImage,
    props.forcedCategory,
    imageCount
  );
  console.log("higherLink for clicked image", props.clickedImage,  higherLikes)
} else {
  higherLikes = pickStrongTopImages(
    savedByOthers.hits,
    props.forcedCategory,
    imageCount,
    false
  );
}



         
          setupImageOnPage(higherLikes)
             // 🔥 Tell Home how many images actually exist
    notifyImageCount(higherLikes);


    // const ranked = getRankedImages(props.forcedCategory)
    //   .sort((a, b) => b.score - a.score)
    //   .map(normalizeRankingImage)
    //   .filter(Boolean);
  

    //   const higherLikes = pickStrongTopImages(
    //   ranked,
    //   props.forcedCategory,
    //   maxImages,
    //   false
    // );
     

   

    // setupImageOnPage(higherLikes);

    // notifyImageCount(higherLikes);

          // })
  }catch(error){
      notifyImageCount([]);
    console.log("fetching home saved error")
  }

  }


    } 
    else if(props.componentFrom === "exploreNext"){
 
      let exploreNextPhotos;
      let exploreNextUrl
      if(exploreNextInfiniteScroll){
        exploreNextUrl = url
      
console.log("exploreNext fecthing in if condition")
      }else{

        let perPage = window.innerWidth <= 580 ? 20 : 20;
        // perPage = !ShowFoursImageInRow && !isMobile ? '20' : '20'
// const orderType = Math.random() < 0.5 ? "popular" : "latest";

// const randomPage = Math.floor(Math.random() * 4) + 9;
// const randomPage = Math.random() < 0.3 ? Math.floor(Math.random() * 2) + 1  : Math.floor(Math.random() * 3) + 9;  
          
// exploreNextUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${props.displayImage}&image_type=photo&order=popular&page=1`;

// exploreNextUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${props.displayImage}&image_type=photo&order=${orderType}&page=${randomPage}` +
//   (perPage ? `&per_page=${perPage}` : "");

const modifiers = ["wallpaper", "background", "photography"];

const words = props.displayImage.toLowerCase().split("-");

const isUserSearchforBgOrWallper = words.some(word =>
  modifiers.includes(word)
);

const displayImageFor = words
  .filter(word => !modifiers.includes(word.toLowerCase()))
  .join(" ");

const orderType = "popular"
// const randomPage = Math.floor(Math.random() * 4) + 1;
// const basePage = isUserSearchforBgOrWallper ? 1 : randomPage;
if (basePageRefForExploreNext.current === null) {
  const randomPage = Math.floor(Math.random() * 4) + 1;

  basePageRefForExploreNext.current = isUserSearchforBgOrWallper
    ? 1
    : randomPage;
}

let basePage = basePageRefForExploreNext.current;



if(isUserSearchforBgOrWallper){

  
  exploreNextUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(displayImageFor)}&image_type=photo&page=${basePage}` +
    (perPage ? `&per_page=${perPage}` : "");

}else if (props.source && props.exploreNextType === "long"){
  // console.log("fetch for long section first...")
  console.log("short long....", props.displayImage, props.exploreNextType)
  basePage = returnExploreNextPageNumber(basePage, pageState)
  console.log("long fetch", basePage)

  const chipsQuery =  getQueryForPage(basePage, props?.displayImage);

    // let currentQuery =  createSafePixabayQuery(`${props.displayImage}-${chipsQuery}`);
     let currentQuery =  createSafePixabayQuery(`${props.displayImage}`);
// currentQuery = props.displayImage.trim() === "长江-江-船-货船-天空-风景-景观-自然-cinema" ? "nature-sky-river" :  props.displayImage

//      if (basePage === 2) {
//     fetchBufferedPages(currentQuery, basePage);
// }

  exploreNextUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(currentQuery)}&image_type=photo&page=${1}` +
    (perPage ? `&per_page=${perPage}` : "");
  console.log("long fetch query", exploreNextUrl)
    

}
else{
 
  // props.displayImage = props.displayImage.trim() === "长江-江-船-货船-天空-风景-景观-自然-cinema" ? "nature-sky-river" :  props.displayImage

  console.log("short ....", props.displayImage, props.exploreNextType)
    exploreNextUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(props.displayImage)}&image_type=photo&page=${basePage}` +
    (perPage ? `&per_page=${perPage}` : "");
}

  // exploreNextUrl = `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${displayImageFor}&image_type=photo&page=${randomPage}` +
  //   (perPage ? `&per_page=${perPage}` : "");



          console.log("fetch for explore first page", exploreNextUrl)
        

      }
      
        
        try{   
          // throw new Error("TESTING RANKING FALLBACK");
          const response = await safeFetch(exploreNextUrl);
          // let sendBaseToPexels = props?.exploreNextType === "long" ? basePageRefForExploreNext.current : undefined
          let sendBaseToPexels =basePageRefForExploreNext.current
          // let normalizedPexels = []          
          
       let normalizedPexels = await callPexel(props.displayImage, pageNum, sendBaseToPexels);
      

          

          exploreNextPhotos = await response.json();

          console.log("explorenext reesult", response, exploreNextPhotos)
          exploreNextDataRef.current[props.displayImage] = exploreNextPhotos;
          // const fullHits = [...(exploreNextPhotos?.hits || []), ...(normalizedPexels || [])];
          const fullHits =  mixPexelsAndPixabay(exploreNextPhotos, normalizedPexels , pageNum);

          let exploreCacheSet = {
            total: fullHits.length,
            totalHits: fullHits.length,
            hits: fullHits 
          }

          // setCache(cacheKey, exploreNextPhotos);   
          setCache(cacheKey, exploreCacheSet);   
          // const fullHits = exploreNextPhotos?.hits || [];    


          console.log("Chips fullHits", fullHits)
          storeImageChips(pageNum, fullHits)

          if(props?.exploreNextType === "short") {
   

          console.log("short display image", fullHits, exploreNextPhotos, normalizedPexels)

                
                let strongTopImages = pickStrongTopImages(fullHits,  props?.displayImage, 12, showPexelsOnShortSection)

                 console.log("new v1 on explore", strongTopImages)
     strongTopImages = rankForUserAction(strongTopImages, props?.displayImage)


  console.log("🔥 Strong Google grid:", strongTopImages)
strongTopImages = isMobile ? strongTopImages.slice(0, -1) : strongTopImages

  setupImageOnPage({ hits: strongTopImages }, pageNum)

            
          }else{
                       
             let remainingImages = fullHits;        
            //  let remainingImages = injectFeaturedImages(fullHits,  pageNum,  props.displayImage);   
            if(props?.exploreNextType === "long"){
//             const firstImages = remainingImages.slice(0, 9);
// const restImages = remainingImages.slice(9);

//            let  updatedRestImages  = injectRankingImages(restImages,  Number(pageNum), props.displayImage);

// console.log("long data setup", remainingImages)
                       
              
//               const finalImages = [ ...firstImages,  ...updatedRestImages ];
            
//   // setupImageOnPage({ hits: remainingImages }, pageNum);
//   setupImageOnPage({ hits: finalImages }, pageNum);

const finalImages = prepareLongExploreNextImages(
    remainingImages,
    Number(pageNum),
    props.displayImage
  );

  console.log(
    "🔥 Long final images",
    finalImages
  );

  setupImageOnPage(
    { hits: finalImages },
    pageNum
  );



  
         }else{
setupImageOnPage({ hits: remainingImages }, pageNum);

         } 
            
          }

  //  await exploreNextFetchImages(exploreNextInfiniteScroll,  exploreNextUrl, pageNum, cacheKey)

        }catch(error){
console.log("useing fallback")
callExploreNextFallback(props.displayImage, pageNum, "catch_explorenext")
         

             setloader(false);                 
            console.log("explorenext have no data", bottomLoader)
          trackInitalPageLoad(pageNum, 0, "error");

          
        }finally{
          fetchLock.current = false;

        }
    
         

        
    }
    
    else {
      console.log("loaded images", result)
      
        if (!result.hits || result.hits.length === 0) {
                // fallbackImagesLoad()
                return                
          }

    
     setupImageOnPage(result, pageNum)    
  
  
    }
  } catch (error) {
  //     console.error("Current props: GENERAL EXPLORE FALLBACK ERROR:", error);
  // console.error("Current props:", {
  //   componentFrom: props.componentFrom,
  //   displayFor: props.displayFor,
  //   showEnd: props.showEnd,
  //   moodQuery,
  //   pageNum,
  //   url
  // });

    callExploreNextFallback(moodQuery, pageNum, "catch_explore")
    setloader(false);        
    // fallbackImagesLoad()
    console.log("loading in ...catch eroor in app images", pageNum, error)
  }
  finally{
     fetchLock.current = false;
  }
}

function prepareLongExploreNextImages(
  remainingImages,
  page,
  query
) {
  if (!Array.isArray(remainingImages)) {
    return [];
  }

   const normalizedQuery = normalizeText(query);
 

  const showRankedImageOnTop = true &&  normalizedQuery.includes("bedroom")
  // if (page <= 5) {
  if (showRankedImageOnTop) {

    
    // return rankLongExploreNextImages(
    //   remainingImages,
    //   query
    // );

     const rankedImages = rankLongExploreNextImages(
      remainingImages,
      query
    );

    const bestPexels = rankedImages.find(
      img => img?._source === "pexels"
    );

    if (!bestPexels) {
      return rankedImages;
    }

    // Remove Pexels image from its ranked position
    const withoutPexels = rankedImages.filter(
      img => img.id !== bestPexels.id
    );

    // Put one Pexels image first
    return [
      bestPexels,
      ...withoutPexels
    ];

  }

  // Page 3+:
  // keep existing behavior
  const firstImages = remainingImages.slice(0, 9);

  const restImages = remainingImages.slice(9);

  const updatedRestImages = injectRankingImages(
    restImages,
    page,
    query
  );

  return [
    ...firstImages,
    ...updatedRestImages
  ];
}

function normalizeText(value = "") {
  return decodeURIComponent(String(value))
    .toLowerCase()
    .replace(/[-_+/]+/g, " ")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}


function createUID(img) {
  return (
    img._uid ||
    `${img.id || "noid"}-${img.webformatURL || img.largeImageURL || "nourl"}-${img._orderIndex || Date.now()}`
  );
}


const warmImageCache = (imgs) => {
  imgs.slice(0, 12).forEach(img => {
    const i = new Image();
    i.decoding = "async";
    i.src = toImageKitURL(makewebformatImageUrl(img), img.webformatWidth);
  });
};



function isAnimalImage(img) {
  if (!img?.tags) return false;

  const tags = img.tags.toLowerCase();

  return animalKeywords.some(keyword => tags.includes(keyword));
}

// function returnValidImage(indexedHits){
//   if(props.exploreNextType === "long") return indexedHits.filter(Boolean)

//   let validImages;

// const query = props?.displayImage?.toLowerCase() || "";

// // 🐄 If user SEARCHES animal intentionally → allow animals
// const isAnimalQuery = animalKeywords.some(keyword =>
//   query.includes(keyword)
// );

// if (isAnimalQuery) {
//   // Show everything (including animals)
//   validImages = indexedHits.filter(Boolean);
// } else {
//   // Remove animals
//   validImages = indexedHits
//     .filter(Boolean)
//     .filter(img => !isAnimalImage(img));
// }
// return validImages
// }
const SEARCH_STOP_WORDS = new Set([
  "idea",
  "ideas",
  "image",
  "images",
  "photo",
  "photos",
  "picture",
  "pictures",
  "wallpaper",
  "hd",
  "download",
  "free"
]);

function scoreImageRelevance(img, query) {
  const tags = (img.tags || "")
    .toLowerCase()
    .split(",")
    .map(t => t.trim());

  const queryWords = query
    .split(/[\s-]+/)
    .filter(Boolean)
    .filter(word => !SEARCH_STOP_WORDS.has(word));   // ✅ Use stop words here

  let score = 0;

  queryWords.forEach(word => {
    if (tags.some(tag => tag.includes(word))) {      // ✅ Better than tags.includes()
      score += 10;
    }
  });

  return score;
}

function applyRelevanceOnExploreNext(images, query) {
  // No query → don't apply relevance filtering
  if (!query) {
    return images;
  }

  const relevantImages = images.filter(
    img => scoreImageRelevance(img, query) >= 5
  );

  // 🛡️ Safety fallback
  if (relevantImages.length === 0) {
    console.warn(
      "No relevant images found. Falling back to original images.",
      query
    );

    return images;
  }

  return relevantImages;
}

function returnValidImage(indexedHits) {
  const query = props?.displayImage?.toLowerCase() || "";

  const isAnimalQuery = animalKeywords.some(keyword =>
    query.includes(keyword)
  );

let images = indexedHits.filter(Boolean).filter(img => {
    // ✅ Always keep curated Pinterest images
    if (img._source === "pintrest") {
      return true;
    }

    // ✅ User searched for animals

  
if(props?.componentFrom === "exporeNext"){
   

    return true;

}else{
    if (isAnimalQuery) {
      return true;
    }
    return !isAnimalImage(img);
}
  });

//   if (props?.componentFrom === "exploreNext") {
//   images = applyRelevanceOnExploreNext(images, query);
// }

return images;
}


function showClickMessageToast(page){

if(sessionStorage.getItem("ShowImageCLickToast")) return
  if(Number(page) === 2){
    // toast.info("Tap any image to explore more")
    // toast.info("Tap any image to see more like it")
    
    toast.info("Tap any image to download")
    sessionStorage.setItem("ShowImageCLickToast", "true")

  }

}


function storeImageChips(page, validImages){
  // 🔥 Generate chips ONLY for first load
if (props.exploreNextType === "short" &&  Number(page) === 1 ) {
  const topTags = GetTopTags(validImages);
  const chips = BuildChips(topTags, props.displayImage);

  console.log("Chips: 🔥", chips);

  // store in state (you need this)
  props.setImageChips(chips);
}
}

const pendingImagesRef = useRef([]);
const imageIdsRef = useRef(new Set());

// const localImageIdsRef = useRef(new Set());

// const imageIdsRef = props.componentFrom === "exploreNext" ? props?.renderedImageIdsRef : localImageIdsRef;

async function adjustImageVisiblity(mappedHits, performanceQuery){
  // Apply shared historical performance.
  
mappedHits = await adjustRankingByPerformance(
  mappedHits,
  performanceQuery
);

// Preserve the existing order when adjustments are equal.
// Only images with sufficient historical evidence get adjusted.
return mappedHits = mappedHits
  .map((img, i) => ({ ...img, _performanceOriginalIndex: i }))
  .sort(
    (a, b) =>
      (b._performanceAdjustment || 0) -
        (a._performanceAdjustment || 0) ||
      a._performanceOriginalIndex - b._performanceOriginalIndex
  )
  .map(({ _performanceOriginalIndex, ...img }) => img);
}


async function setupImageOnPage(result, page = 0) {

  console.log("loading start for images");

  // 🔒 Normalize data shapes ONCE
  const hits = Array.isArray(result?.hits) ? result.hits : [];
  const isHome = props.componentFrom === "home";

trackInitalPageLoad(page, hits.length , "getting_ready");
  /* ===========================
     🏠 HOME FEED
  ============================ */
  if (isHome) {
    const rawHits = Array.isArray(result) ? result : [];

    if (rawHits.length === 0) {
      setloader(false);
      return;
    }
    const makeImageCategoey = props?.componentFrom === "exploreNext" ? props?.displayImage : moodQuery

    let mappedHits = rawHits.map((img, i) => ({
      ...img,
      _orderIndex: images.length + i,
      // _category: makeImageCategoey,
      _category: getTargetTag(img),
      imageColor: "#ffffff",
        _uid: `${img.id}-${img.webformatURL}-${img.webformatWidth}`,
    }));
    const performanceQuery = props.forcedCategory || moodQuery || makeImageCategoey;
    // mappedHits = await adjustImageVisiblity(mappedHits, performanceQuery)
  

    setImages((prevImages) => {
      const existingIds = new Set(prevImages.map((img) => img.id));
      // const existingIds = new Set(prevImages.map(img => `${img.id}-${img.webformatURL}`));

      const uniqueNewImages = mappedHits.filter(
        (img) => !existingIds.has(img.id)
      );

      const newImages = [...prevImages, ...uniqueNewImages];

      if (props.displayFor === "forExplore") {
        props.featurStoredImage(newImages);
      }

      return newImages;
    });

    setloader(false);

    requestAnimationFrame(() => {
      setImageColors(mappedHits);
    });
   
   
  
  
    return;
  }

  /* ===========================
     🔍 EXPLORE / EXPLORENEXT
  ============================ */
  if (hits.length === 0) {
    setloader(false);
      trackInitalPageLoad(page, 0, "empty");
    return;
  }
  const makeImageCategoey = props?.componentFrom === "exploreNext" ? props?.displayImage : moodQuery

  console.log("image starting point 1", hits, props?.exploreNextType)
  const indexedHits = await Promise.all(
    hits.map(async (img, i) => {
      
      // let color = await getImageColors(img.previewURL, 1)
      
      
      return{
      ...img,
      _orderIndex: images.length + i,
      // _category: makeImageCategoey,
      _category: getTargetTag(img),
      imageColor: "#f8f9fa",
      
      
    }})
  );

  // const validImages = indexedHits.filter(Boolean);

  // const validImages =  returnValidImage(indexedHits)
  const validImages = props?.exploreNextType === "short" ? indexedHits.filter(Boolean) : returnValidImage(indexedHits)

  

  const hiddenImages =JSON.parse(localStorage.getItem("hiddenImages")) || [];
  const interactionScores = getInteractionScores();
const sessionInterest = sessionInterestRef.current || {};
// if(props?.exploreNextType === "long"){
// console.log("checking pintrest 1 validImage", validImages, props?.exploreNextType)
// }


  const filteredImages = validImages
    .filter((img) => !hiddenImages.includes(img.id))
    .map((img) => {
        const tags = img?.tags?.toLowerCase() || "";

  const sessionScore = Object.entries(sessionInterest).reduce((acc, [key, value]) => {

        if (tags.includes(key)) {
          acc += value;
        }

        return acc;

      }, 0);
console.log("session scroll from setupImageOnPage", sessionScore)

      return {
      ...img,
      _interestScore: scoreImageByInterest(img, interactionScores),
      _uid: `${img.id}-${img.webformatURL}-${img.webformatWidth}`,
       _sessionScore: sessionScore,
    }
  });
  

  const interactionScore = JSON.parse(localStorage.getItem("interactionScore")) || {};
  const hasSavedImages = JSON.parse(localStorage.getItem("savedImages"))?.length > 0;

  const canPersonalize = Object.keys(interactionScore).length >= 3;
  const isExploreFeed = props.componentFrom !== "home" && props.componentFrom !== "exploreNext";

  // const pageNum = Number(pageState || 1);
  const pageNum = Number(page || 1);

  // const rankedImages = isExploreFeed && canPersonalize ? softSortByInterest(filteredImages) : filteredImages;
  // let mixedImages = rankedImages;

  // if(props?.exploreNextType === "long"){
  //   console.log("checking pintrest 2", filteredImages, props?.exploreNextType)
  // }
  const performanceQuery = props.componentFrom === "exploreNext" ? props.displayImage
    : props.forcedCategory || moodQuery || makeImageCategoey;

// const performanceAdjustedImages = await adjustRankingByPerformance(filteredImages, performanceQuery );


  let mixedImages = filteredImages;// previous 
  // let mixedImages = performanceAdjustedImages; // new 

  if ( props?.exploreNextType !== "short" &&   props?.exploreNextType !== "long" ) {

  // mixedImages = [...filteredImages].sort(
  //     (a, b) =>
  //       (b._sessionScore || 0)  -   (a._sessionScore || 0)
  //   );

  mixedImages = [...filteredImages].sort((a, b) => {
  // mixedImages = [...performanceAdjustedImages].sort((a, b) => {
   const aScore =
      (a._interestScore || 0) +
      ((a._sessionScore || 0) * 0.25) + (a._performanceAdjustment || 0);;

   const bScore =
      (b._interestScore || 0) +
      ((b._sessionScore || 0) * 0.25) + (b._performanceAdjustment || 0);

   return bScore - aScore;

})

}


  // 🔹 Inject saved images
  if (isExploreFeed && hasSavedImages) {
    mixedImages = mixSavedImages(mixedImages, pageNum);
  }

  // 🔹 Inject interest images
  if (isExploreFeed && canPersonalize) {
    mixedImages = mixInterestImages(mixedImages, pageNum);
  }

  console.log("image injecting", {
    page: pageNum,
    canPersonalize,
    injectedInterest: mixedImages.some((i) => i._isInterestImage),
    injectedSaved: mixedImages.some((i) => i._isUserSaved),
  });

  
  console.log("image starting point 3", mixedImages, props?.exploreNextType)
// let  staggeredImages = mixedImages

//     if (props?.exploreNextType !== "short" ) {
// let chunksImages = cutInChunks(mixedImages, props?.componentFrom, props?.exploreNextType)

//     staggeredImages = chunksImages.map((img, i) => ({
//     ...img,
//     _delay: i * 30 ,    
//   }));
  
//   warmImageCache(staggeredImages);
// }

  const staggeredImages = mixedImages.map((img, i) => ({
    ...img,
    _delay: i * 30 ,   
    _layoutType: i % 2 === 0 ? "portrait" : "landscape", 
  }));


  
console.log("image starting point 4", staggeredImages, props?.exploreNextType)
  // setImages((prevImages) => {
  //   const existingIds = new Set(prevImages.map((img) => img.id));  
  //   const uniqueNewImages = staggeredImages.filter(
  //     (img) => !existingIds.has(img.id)
  //   );    

  //   storeImageSectionCount(uniqueNewImages)
  //   return [...prevImages, ...uniqueNewImages];
  // });


  const safeImages = staggeredImages.filter((img) => {
    if(img?._source === "pexels") return true 

    if (imageIdsRef.current.has(img.id)) {
      return false;
    }
    
      
      imageIdsRef.current.add(img.id);
    

    return true;
  });
  
  // if(props?.exploreNextType === "long"){

  //   console.log("image starting final ending", safeImages);
  // }

  setImages((prevImages) => {

  storeImageSectionCount(safeImages);

  return [...prevImages, ...safeImages];
});

console.log("image starting point 5", safeImages , props?.exploreNextType)

  setloader(false);
  setTrakImage(false);
  // showClickMessageToast(page)

  if (bottomLoader && validImages.length > 0) {
    setBottomLoader(false);
  }
  // setTimeout(()=>{
    trackInitalPageLoad(page, staggeredImages.length , "success");
  // }, 20)


  trackPageLoaded(page)

  
    // setImageColors(safeImages)
    requestAnimationFrame(() => {
      setImageColors(safeImages);
    });

  
}

function setImageColors(safeImages){
  Promise.all(
  safeImages.map(async (img) => {
      if (!img?._uid || !img?.previewURL) {
        return null;
      }

    const color = await getImageColors(
      img.previewURL,
      1
    );

    return {
      _uid: img._uid,
      imageColor: color[0]
    };

  })
).then((colorUpdates) => {

  const colorMap = new Map(
    colorUpdates.map(item => [
      item._uid,
      item.imageColor
    ])
  );

  setImages((prevImages) =>
    prevImages.map(img => {

      const color = colorMap.get(img._uid);

      return color
        ? {
            ...img,
            imageColor: color
          }
        : img;

    })
  );

});

}



function cutInChunks(mixedImages, componentFrom, exploreNextType){
   let imagesToRender = mixedImages;
// console.log("chunks in cutter function 1", imagesToRender)
if (
  props?.componentFrom === "exploreNext" &&
  props?.exploreNextType === "long"
) {

  const firstChunk = mixedImages.slice(0, 10);

  const remainingChunk = mixedImages.slice(10);



  console.log("chunks in cutter function 2", firstChunk, remainingChunk, mixedImages)
  pendingImagesRef.current = remainingChunk;
      // 🔥 PRELOAD NEXT BUFFER
  preloadImages(
    remainingChunk.slice(0, 10)
  );


  imagesToRender = firstChunk;
}

return imagesToRender
}

const trackedPages = useRef(new Set());

function trackPageLoaded(page){
  const currentPage = Number(page || 1);


  



if (
  currentPage >= 2 &&
  !trackedPages.current.has(currentPage)
) {
  trackPageLoadedInGa(page);
  trackedPages.current.add(currentPage);
}
}




function trackPageLoadedInGa(nextPage){
  // console.log("pagePathLoaded", props.displayImage)

 if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") !== "true") {
  const pageName = props.componentFrom || "explore"
  trackEvent(`explore_page_load_for_${pageName}`, {
    page_number: nextPage,
    pageLoadedPath: window.location.pathname,
    wherePageLoaded: pageName,
    pageLoadedQuery: props.displayImage || moodQuery  || "unknown",
    topicAndPage: `page-${nextPage}-${(props?.displayImage || "unknow").replace(/\s+/g, "-")}`,
  });
} 
}

// let trackInitalImageLoad = false
// function trackInitalPageLoad(pageNum, staggeredImages){
//   if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return 
//   // console.log("checking inital track 1",pageNum, staggeredImages.length)
  

//   if (!trackInitalImageLoad && props?.exploreNextType === "short" && Number(pageNum) === 1) {
//   trackEvent("initial_images_loaded", {
//     initialImageCount: staggeredImages.length,
//     source: props.componentFrom || "explore",
//     initialLoadQuery: props.displayImage || moodQuery || "unknown",
//     path: window.location.pathname
//   });
//   // console.log("checking inital track 2", staggeredImages.length)
//   trackInitalImageLoad = true
// }
// }


const trackInitialImageLoadRef = useRef(false);

function trackInitalPageLoad(pageNum, imageCount = 0, status = "success") {
  if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;
// console.log("yes it running for initload 1", pageNum, imageCount, status)
  if (
    !trackInitialImageLoadRef.current &&
    props?.componentFrom === "exploreNext" &&
    props?.exploreNextType === "short"
  ) {
    trackEvent("initial_images_loaded", {
      initialImageCount: imageCount,
      status: status, // 🔥 important
      source: props.componentFrom,
      initialLoadQuery: props.displayImage || "unknown",
      path: window.location.pathname,
      initalImageLoadedTopicAndCount: `${imageCount}-imageloaded-for-${(props?.displayImage || "unknow").replace(/\s+/g, "-")}`,
      referral: document.referrer || "direct",
    });

    if(status === "success"){
      trackInitialImageLoadRef.current = true;

    }
// console.log("yes it running for initload 2", pageNum, imageCount, status)

    
  }
}


function runInitialLoad(imageAutoUpdate = false){ 
   // Set the initial index
    // let currentCalculatedIndex = updatedHours();
    // setIndex(updatedHours());
    setIndex(prev => prev + 1);

  


    // document.title = `Explore images for ${content[currentCalculatedIndex]}`;
    // Fetch images for the initial index
    

      // getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${content[currentCalculatedIndex]}&image_type=photo&page=1`);
       const preload = location.state?.initialExploreImages;

  if (!imageAutoUpdate && preload?.length > 0) {
    console.log("⚡ Using preloaded images from Home", preload);
    // setImages(preload);
        setloader(true);    
    setupImageOnPage({ hits: preload })
   
  }else{
// &per_page=15

      //  if(window.innerWidth < 580){           
      //       getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${content[currentCalculatedIndex]}&image_type=photo&page=1`);
            
      //   }else{


const randomPage = Math.floor(Math.random() * 4) + 1;
          
          // getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${content[currentCalculatedIndex]}&image_type=photo&page=1`);
          
            // getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(moodQuery)}&image_type=photo&page=${randomPage}`);
            getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(moodQuery)}&image_type=photo&page=1`);

          
        

          
        
        // }
    }
    
    
    // addImageTouch();
    // Update the index every hour
    const interval = setInterval(() => {
      setIndex(prev => prev + 1);
    }, 60 * 60 * 1000); 

         

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
}

// const layoutEffectRan = useRef(false);

//   useLayoutEffect(() => {    
    
//     runInitialLoad()
//     layoutEffectRan.current = true; 
//   }, []);

const layoutEffectRan = useRef(false);

useLayoutEffect(() => {
  // Do not fetch until this section is close to the viewport.
  if (props.enabled === false) {
    return;
  }

  const cleanup = runInitialLoad();
  layoutEffectRan.current = true;

  return cleanup;
}, [props.enabled]);

  
const exploreNextVisitTrackedRef = useRef(false);

function trackExploreNextVisit() {

  if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;

  if (exploreNextVisitTrackedRef.current) return;

  // if (props?.componentFrom === "exploreNext" &&  props?.exploreNextType === "short" ) {

    trackEvent("explore_next_visit", {
        source:  props?.componentFrom,
        query:  props?.displayImage || "unknown",
        path: window.location.pathname,
        deviceWidth:  window?.innerWidth,
        commingSource: document?.referrer || "direct"
      }
    );

    exploreNextVisitTrackedRef.current =  true;
  // }
}





   const moodQuery = useMemo(() => {
  return updatedHours();
}, [index]);

const statusPackRef = useRef(null);


const statusPack = useMemo(() => {

  
  
  if(props.componentFrom === "home"){
      if (!images || images.length === 0) return [];

  // ⭐ Use ANY images
  // const pack = images.slice(0, 8);
  const pack = images;

  if (pack.length >= 3) {
    statusPackRef.current = pack;
    return pack;
  }

  return statusPackRef.current || [];

 
}else{

   if (!images || images.length === 0) return [];

  // Prefer vertical images
  // const vertical = images.filter(img => {
  //   const w = img.webformatWidth || 1;
  //   const h = img.webformatHeight || 1;
  //   return h > w;   // simple + reliable
  // });
  // const source = vertical.length > 0 ? vertical : images;


   const source = images
  // const source = images.filter((image)=> image?._source !== "pexels")

    // const shuffled = [...source].sort(() => Math.random() - 0.5);

  // const pack = source.slice(0, 8);

  const pack = source.slice(0, 8).map(img => ({
  ...img,
  optimizedURL: toImageKitURL(makewebformatImageUrl(img), img.webformatWidth, 80,true),
  previewOptimized: toImageKitURL(img.previewURL, img.previewWidth, 80,true),
  largeOptimized: toImageKitURL(makelargeImageUrl(img), img.imageWidth, 80,true)
}));

  // 🔥 Warm cache BEFORE render
  warmImageCache(pack);

  // Freeze once valid
  if (pack.length > 4) {
    statusPackRef.current = pack;
    return pack
  }
}
  
  return [];

}, [images, imageStates]);

useEffect(() => {
  if (statusPack.length > 4 && props.onStatusPackReady) {
    props.onStatusPackReady(statusPack);
  }
}, [statusPack]);





  useEffect(() => {
    const referenceTime = new Date("2025-01-01T00:00:00Z").getTime();
    
    const interval = setInterval(() => {
        const currentTime = Date.now();
        const minutesElapsed = Math.floor((currentTime - referenceTime) / (60 * 1000)) % 60;
        if(props.lastUpdatedAt){
          props.lastUpdatedAt(minutesElapsed);
        }
    }, 60 * 1000); // update every 1 minute

    return () => clearInterval(interval);
}, []);


let hasShownIconsForPage = false;
let imageIconObserver = null;

function showMobileIcon(firstColumn) {
  if(props?.exploreNextType === "long") return 
  
    if (hasShownIconsForPage) return;

  const firstImageCard = firstColumn.firstElementChild;
  if (!firstImageCard) return;

  // ⏳ wait until image is actually loaded
  if (!firstImageCard.classList.contains('image-loaded')) return;

  const likeEl = firstImageCard.querySelector('.explore_icons');
  // const shareEls = firstImageCard.querySelectorAll('.explore_images_share');
  const topActionEls = firstImageCard.querySelector('.image_topaction_element');

  console.log("yes comming...")
  if (!likeEl || !topActionEls) return;
  hasShownIconsForPage = true;
  

  imageIconObserver?.disconnect();
  imageIconObserver = null;

  // Show icons
  // shareEls.forEach(el => (el.style.transform = 'translate(0,0)'));
  likeEl.style.transform = 'translate(0,0)';
  firstImageCard.style.border = '3px solid black';
//   topActionEls.forEach(el => {
//   el.classList.add('show_image_top_action_element'); // ⭐ THIS IS THE REAL FIX
// });
  topActionEls.classList.add('show_image_top_action_element')
firstImageCard.classList.add('intro-active');

  const hideIcons = () => {
    // shareEls.forEach(el => (el.style.transform = ''));
      // 🚨 prevent intro from fighting menu system
  if (clickImageObjectRef?.current) return;
    likeEl.style.transform = '';
    firstImageCard.style.border = '';
    firstImageCard.classList.remove('intro-active');
  //   topActionEls.forEach(el => {
  //   el.classList.remove('show_image_top_action_element');
  // });

  topActionEls.classList.remove('show_image_top_action_element')

     sessionStorage.setItem('userInteract', true);
  };

  // firstImageCard.addEventListener('mouseover', hideIcons, { once: true });
  // firstImageCard.addEventListener('touchstart', hideIcons, {
  //   passive: true,
  //   once: true,
  // });

  const images = document.getElementsByClassName('explore_image');

  Array.from(images).forEach(image => {
    

    const onHover = () => hideIcons();
    const onTouch = () => hideIcons();

    image.addEventListener('mouseover', onHover);
    image.addEventListener('touchstart', onTouch, { passive: true });

    // store for cleanup
    image._onHover = onHover;
    image._onTouch = onTouch;
  });
    return () => {
    Array.from(images).forEach(image => {
      if (image._onHover) {
        image.removeEventListener('mouseover', image._onHover);
        delete image._onHover;
      }
      if (image._onTouch) {
        image.removeEventListener('touchstart', image._onTouch);
        delete image._onTouch;
      }
    });
  };

}



useEffect(() => {
  if (!images.length) return;

  const container = document.querySelector('.explore_mainexplore');
  if (!container) return;

  const firstColumn = container.firstElementChild;
  if (!firstColumn) return;

  imageIconObserver = new MutationObserver(() => {
    showMobileIcon(firstColumn);
  });

  imageIconObserver.observe(firstColumn, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  // Try immediately too
  showMobileIcon(firstColumn);

  return () => {
    imageIconObserver?.disconnect();
    imageIconObserver = null;
  };
}, [images]);







  //   useEffect(() => {
  //  let currentCalculatedIndex = updatedHours();    
  //   getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(currentCalculatedIndex)}&image_type=photo&page=1`);    
  // }, [index]);
  

//   useEffect(() => {
//   getImages(
//     `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(moodQuery)}&image_type=photo&page=1`
//   );
// }, [moodQuery]);




function getMoodQuery(currentHour, hoursElapsed) {
  let selectedGroup = [];

  if (currentHour >= 6 && currentHour < 12) {
    selectedGroup = timeBasedContent.morning;
  } else if (currentHour >= 12 && currentHour < 17) {
    selectedGroup = timeBasedContent.afternoon;
    console.log("afternoon time", selectedGroup)
    
  } else if (currentHour >= 17 && currentHour < 21) {
    selectedGroup = timeBasedContent.evening;
    console.log("eveing time", selectedGroup)
  } else {
    selectedGroup = timeBasedContent.night;
  }

  if (!selectedGroup.length) {
    return content[hoursElapsed % content.length];
  }

  // 🔥 Rotate 3 keywords instead of 1
  const baseIndex = hoursElapsed % selectedGroup.length;

  const moodKeywords = [];
  for (let i = 0; i < 3; i++) {
    const softCategory =
      selectedGroup[(baseIndex + i) % selectedGroup.length];



    // const resolved =  timeCategoryResolver[softCategory] || softCategory;

    // moodKeywords.push(resolved);
    moodKeywords.push(softCategory);
  }
console.log("moood catgeoyr in getmoodQuery function", moodKeywords)
  // Combine as one search query
  // return moodKeywords.join(" ");
  
  return props.componentFrom === "home" ? moodKeywords[moodKeywords.length - 1] : moodKeywords.join(" ");
  
}

  // function updatedHours(){
  //   const referenceTime = new Date("2025-01-01T00:00:00Z").getTime();
    

  //   // Function to calculate the current index based on elapsed hours 
  //     const currentTime = Date.now();
  //     const lastUpdated = props.lastUpdatedAtState || currentTime; // fallback if undefined
  //     const hoursElapsed = Math.floor((currentTime - referenceTime) / (60 * 60 * 1000));
  //           // Minutes within the current hour (0-59)
  //   const minutesElapsed = Math.floor((currentTime - referenceTime) / (60 * 1000)) % 60;
  //     // console.log("hours elapased", hoursElapsed, content.length, content[hoursElapsed])

  //      // Get current hour (0-23) in local time
  // let currentHour = new Date().getHours();

  // // let categoryIndex = timesCatgeoy(currentHour, hoursElapsed);
  // let categoryIndex =  getMoodQuery(currentHour, hoursElapsed);
  
  // // ✅ SAFETY FALLBACK (system-level)
  // if (categoryIndex === null || categoryIndex === undefined) {
  //   categoryIndex = hoursElapsed % content.length;
  // }


  //     console.log("explore masonary hours",currentTime, hoursElapsed, categoryIndex, referenceTime)
  //     // return hoursElapsed % content.length;
  //     if(props.lastUpdatedAt){
  //       props.lastUpdatedAt(minutesElapsed)

  //     }

  //     return categoryIndex;
   
  // }

  function updatedHours() {
  const referenceTime = new Date("2025-01-01T00:00:00Z").getTime();
  const currentTime = Date.now();

  const hoursElapsed = Math.floor(
    (currentTime - referenceTime) / (60 * 60 * 1000)
  );

  const minutesElapsed =
    Math.floor((currentTime - referenceTime) / (60 * 1000)) % 60;

  let currentHour = new Date().getHours();

  let moodQuery = getMoodQuery(currentHour, hoursElapsed);

  // ✅ SAFETY FALLBACK — always return string
  if (!moodQuery) {
    moodQuery = content[hoursElapsed % content.length];
  }

  console.log(
    "explore masonry moodQuery:",
    moodQuery,
    hoursElapsed
  );

  if (props.lastUpdatedAt) {
    props.lastUpdatedAt(minutesElapsed);
  }

  return moodQuery; // always string
}

  function timesCatgeoy(currentHour, hoursElapsed){  

  let selectedGroup = [];

  // 🌅 Morning: 6 AM – 11:59 AM
  if (currentHour >= 6 && currentHour < 12) {
    selectedGroup = timeBasedContent.morning;
  }

  // ☀️ Afternoon: 12 PM – 4:59 PM
  else if (currentHour >= 12 && currentHour < 17) {
    selectedGroup = timeBasedContent.afternoon;
  }

  // 🌇 Evening: 5 PM – 8:59 PM
  else if (currentHour >= 17 && currentHour < 21) {
    selectedGroup = timeBasedContent.evening;
  }

  // 🌙 Night: 9 PM – 5:59 AM
  else {
    selectedGroup = timeBasedContent.night;
  }
   const fallbackIndex = hoursElapsed % content.length;

  const selectedCategory =
    selectedGroup.length > 0 ? selectedGroup[hoursElapsed % selectedGroup.length]   : content[fallbackIndex];

      // Final category index (safe fallback)
  const categoryIndex =  content.indexOf(selectedCategory) !== -1 ? content.indexOf(selectedCategory)   : fallbackIndex;

  return categoryIndex
  }
  
 



//   function timesCatgeoy(currentHour, hoursElapsed) {
//   let selectedGroup = null;
//   let isTimeValid = true;

//   // 🌅 Morning: 6 AM – 11:59 AM
//   if (currentHour >= 6 && currentHour < 12) {
//     selectedGroup = timeBasedContent.morning;
//   }
//   // ☀️ Afternoon: ONLY 12 PM – 4:59 PM
//   else if (currentHour >= 12 && currentHour < 17) {
//     selectedGroup = timeBasedContent.afternoon;
//   }
//   // 🌇 Evening: 5 PM – 8:59 PM
//   else if (currentHour >= 17 && currentHour < 21) {
//     selectedGroup = timeBasedContent.evening;
//   }
//   // 🌙 Night: 9 PM – 5:59 AM
//   else if (currentHour >= 21 || currentHour < 6) {
//     selectedGroup = timeBasedContent.night;
//   }
//   // 🚫 Invalid time window
//   else {
//     isTimeValid = false;
//   }

//   // ✅ Case 1: Time is valid → STRICT time-based selection
//   if (isTimeValid && selectedGroup?.length) {
//     // const selectedCategory = selectedGroup[hoursElapsed % selectedGroup.length];
//       const softCategory =    selectedGroup[hoursElapsed % selectedGroup.length];

//   const resolvedCategory =    timeCategoryResolver[softCategory] || softCategory;

//     // const index = content.indexOf(selectedCategory);
//     const index = content.indexOf(resolvedCategory);

//     // If missing, show nothing (not random)
//     return index !== -1 ? index : null;
//   }

//   // ✅ Case 2: Time is invalid → FALLBACK to content rotation
//   return hoursElapsed % content.length;
// }

  useEffect(() => {
  clearCache()
  // runInitialLoad()
}, [moodQuery]);




// useEffect(() => {

  
//   if (!images.length) return;

//   const threshold = 550;

//   const checkIfNearBottom = () => {

//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//     const clientHeight = window.innerHeight;

//     const scrollHeight = document.documentElement.scrollHeight;

//     const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;

//     if (isNearBottom) {
//       console.log("📥 Auto load next page");

//       // setBottomLoader(true);
//       handleNextPage();
//     }
//   };

//   // ⭐ Run immediately (no scroll needed)
//   checkIfNearBottom();

//   // ⭐ Run on scroll
//   window.addEventListener("scroll", checkIfNearBottom, { passive: true });

//   // ⭐ Run on resize
//   window.addEventListener("resize", checkIfNearBottom);

//   return () => {
//     window.removeEventListener("scroll", checkIfNearBottom);
//     window.removeEventListener("resize", checkIfNearBottom);
//   };

// }, [images]);


useEffect(() => {

  if (!images.length) return;

  // 🔥 Start loading MUCH earlier
  // const threshold = window.innerHeight * 2;
  const threshold = window.innerHeight;

  const checkIfNearBottom = () => {

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const clientHeight =  window.innerHeight;

    const scrollHeight = document.documentElement.scrollHeight;

    const remainingScroll =  scrollHeight -   (scrollTop + clientHeight);

    // 🔥 PRELOAD BUFFERED IMAGES EARLY
    if (
      remainingScroll < threshold &&
      pendingImagesRef.current.length > 0
    ) {

      console.log(
        "⚡ Injecting buffered images early"
      );

      handleNextPage();

      return;
    }

    // 🔥 FALLBACK API FETCH
    const isNearBottom =
      remainingScroll < 550;

    if (isNearBottom) {

      console.log(
        "📥 Auto load next API page"
      );

      handleNextPage();
    }
  };

  // 🔥 Run immediately
  checkIfNearBottom();

  // 🔥 Scroll listener
  window.addEventListener(
    "scroll",
    checkIfNearBottom,
    { passive: true }
  );

  // 🔥 Resize listener
  window.addEventListener(
    "resize",
    checkIfNearBottom
  );

  return () => {

    window.removeEventListener(
      "scroll",
      checkIfNearBottom
    );

    window.removeEventListener(
      "resize",
      checkIfNearBottom
    );
  };

}, [images]);


const [shareData, setShareData] = useState({ imageUrl: "", title: "" });


function shareImage(image){
  if(image){
    // let currentCalculatedIndex = updatedHours();
    // let caption = document.title
    let caption = moodQuery
    console.log("explore images share", image, caption)
    
    setShareData({
      imageUrl: image,
      title: caption
    });
    trackImages("share_image_from_imageicon", image.previewURL)

    console.log("share on explore share", )
    // handleShare(caption,"", image, "explore");
    console.log("yes share click")
    handleShare(caption, "", image, "explore", window.location.href, null, "normalShare")

  }
}
  // Fetch images whenever the index changes

  
const moreOptionsRef = useRef(null)
const touchMovedRef = useRef(false);

  function sendClickFeed(event){    
    // event.stopPropagation()
    let shareButton = event?.currentTarget;
    if(shareButton){
      shareButton.firstElementChild.style.backgroundColor = "#05050524";
      shareButton.firstElementChild.style.color = "white";
      
      // shareButton.firstElementChild.style.backgroundColor = "white";
    }
    
  }
  function removeClickFeedForShare(event){
    let shareButton = event.currentTarget;
     shareButton.firstElementChild.style.backgroundColor = "white";
      shareButton.firstElementChild.style.color = ""; 
  }
  
  function removeClickFeed(event, imageUrl, type, imageId, forSavedByOther= false, imageIndex = undefined){    
    // event.stopPropagation()
    // event.preventDefault()
    let shareButton = event.currentTarget;
    console.log("share button", shareButton, type, forSavedByOther)
    if(forSavedByOther){
         shareButton.firstElementChild.style.backgroundColor = "white";
      shareButton.firstElementChild.style.color = "";
      return
    }
    // if(shareButton.classList.contains('explore_like_content')){

    if(shareButton){
      shareButton.firstElementChild.style.backgroundColor = "white";
      shareButton.firstElementChild.style.color = "";
      if(type === "share"){
        shareImage(imageUrl)

      }else{
        console.log("image object not url in share button ", imageUrl)
        openMoreOptions(event, type, imageId, imageUrl, imageIndex)
      }
      
    }else{
      if(type === "option"){
        console.log("image object not url not in share button", imageUrl)
        openMoreOptions(event, type, imageId, imageUrl, imageIndex)
      }

    }
    
  }
 
  // let lastOpenedImageId = null; 
  // let clickedImageObj = null

  const [lastOpenedImageId, setLastOpenedImageId] = useState(null);
const [clickedImageObj, setClickedImageObj] = useState(null);
// const clickImageObjectRef = useRef(null)
const localClickImageRef =  useRef(null);

const clickImageObjectRef =  props?.source  ? props?.clickImageObjectRef : localClickImageRef

let clickedImageIndex = useRef(null)
function openMoreOptions(event, type, imageId, clickedImageData, imageIndex) {
  event.stopPropagation(); 
  event.preventDefault(); 

  trackEvent("open_more_options", {
  page: props.componentFrom || "explore",
  image_id: imageId,
  source: props.displayFor || "explore_card",
});

  console.log("yes open open", imageIndex)
  if(props.componentFrom === "home" &&  props.setCurrentObj){
  // props.setCurrentObj({clickedImageObj: clickedImageData, clickedImageId: imageId})
  const newObj = { clickedImageObj: clickedImageData, clickedImageId: imageId, 
    
   };
  console.log("yes this is updating", newObj, clickedImageData, imageId)
props.setCurrentObj(newObj);
console.log("yes suggestest object set", newObj, clickedImageData,  imageId)

}
console.log("clickedImageData", clickedImageData)
    // Always clear previous active states
    if(document.querySelectorAll('.show_click_element')){

      document.querySelectorAll('.show_click_element').forEach(el => {
        el.classList.remove('show_click_element');
      });
    }

    if(document.querySelectorAll('.show_image_top_action_element')){

      document.querySelectorAll('.show_image_top_action_element').forEach(el => {
        el.classList.remove('show_image_top_action_element');
      });
    }
   
    if(document.querySelectorAll('.show_click_element_border')){
    document.querySelectorAll('.show_click_element_border').forEach(el => {
        el.classList.remove('show_click_element_border');
      });
    }

    // Find the container for this imageId
     let imageContainer
    if(props.componentFrom === "home"){
      imageContainer = document.querySelector(`[data-image-id="${imageId}"]`);
    }else{

      imageContainer = document.querySelector(`[data-image-id="${imageId}-${imageIndex}"]`);
    }

// show_image_top_action_element

  const exploreTopIcon = imageContainer.querySelectorAll('.explore_images_share')
  const ExploreTopActionIcon = imageContainer.querySelector('.image_topaction_element')
  // const ExploreTopActionIcon = imageContainer.querySelector('.app_image_top_actions')
  const exploreBottomIcon = imageContainer.querySelector('.explore_icons')
  clickedImageIndex.current = imageIndex
  // const exploreBottomIcon = imageContainer.querySelector(exploreBottomIcon.current)
  

  console.log("image container", imageContainer, exploreTopIcon, exploreBottomIcon)

  const sharedBox = document.querySelector('.app_sharer_container');
  const button = event.currentTarget;
  const rect = button.getBoundingClientRect();
  
  let top = rect.bottom + window.scrollY + 20;
  let left = rect.left + window.scrollX;

    // Get viewport size
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // Get sharedBox size (temporarily make it visible to measure if needed)
  sharedBox.style.opacity = '0';
  sharedBox.style.display = 'block'; 
  const boxWidth = sharedBox.offsetWidth;
  const boxHeight = sharedBox.offsetHeight;


  // Adjust horizontal position if overflowing
  if (left + boxWidth > window.scrollX + viewportWidth) {
    left = window.scrollX + viewportWidth - boxWidth - 10; // 10px margin
  }
  if (left < window.scrollX) left = window.scrollX - 10;

  // Adjust vertical position if overflowing
  if (top + boxHeight > window.scrollY + viewportHeight) {
    top = rect.top + window.scrollY - boxHeight - 10; 
  }
  if (top < window.scrollY) top = window.scrollY + 10;


  // Case 1: Clicking the same image again -> toggle
  if (clickImageObjectRef.current?.id === imageId) {
    if (getComputedStyle(sharedBox).opacity === "1") {
      sharedBox.style.opacity = `0%`;
      sharedBox.style.pointerEvents = `none`;
      

        Array.from(exploreTopIcon).forEach((item)=>{
          if(item.classList.contains('show_click_element')){
            item.classList.remove('show_click_element')

          }
      })
      if(exploreBottomIcon && exploreBottomIcon.classList.contains('show_click_element')){
        imageContainer.classList.remove('show_click_element_border')

        exploreBottomIcon.classList.remove('show_click_element')
      }
      if(exploreBottomIcon && exploreBottomIcon.classList.contains('show_image_top_action_element')){
        imageContainer.classList.remove('show_image_top_action_element')

        exploreBottomIcon.classList.remove('show_image_top_action_element')
      }
    
    } else {
      sharedBox.style.top = `${top}px`;
      sharedBox.style.left = `${left}px`;
      sharedBox.style.height = `auto`;
      sharedBox.style.opacity = `100%`;
      sharedBox.style.zIndex = `99999999999999`;
      sharedBox.style.pointerEvents = `auto`;

        Array.from(exploreTopIcon).forEach((item)=>{
        item.classList.add('show_click_element')
      })
      console.log("yes new top icon", ExploreTopActionIcon)
      if(ExploreTopActionIcon){
        ExploreTopActionIcon.classList.add('show_image_top_action_element')
        
      }
      console.log("yes new top icon main", ExploreTopActionIcon)
      if(exploreBottomIcon){
        exploreBottomIcon.classList.add('show_click_element')
        imageContainer.classList.add('show_click_element_border')

      }
    }
  } 
  // Case 2: Different image -> always show at new position
  else {
   
      sharedBox.style.opacity = `0`;
      sharedBox.style.pointerEvents = `none`;
    setTimeout(() => {
      sharedBox.style.position = 'absolute';
      sharedBox.style.width = `250px`;
      sharedBox.style.height = `auto`;
      sharedBox.style.top = `${top}px`;
      sharedBox.style.left = `${left}px`;
      sharedBox.style.opacity = `1`;
      sharedBox.style.pointerEvents = `auto`;

      Array.from(exploreTopIcon).forEach((item) => {
        item.classList.add('show_click_element');
      });
       if(ExploreTopActionIcon){
        ExploreTopActionIcon.classList.add('show_image_top_action_element')

      }
      if(exploreBottomIcon){

        exploreBottomIcon.classList.add('show_click_element');
        imageContainer.classList.add('show_click_element_border')
      }
    }, 50); // fade out delay before moving (200ms can be tuned)
  }

  // update the tracker
  // lastOpenedImageId = imageId;
  // clickedImageObj = clickedImageData;
clickImageObjectRef.current = {imageId: imageId, clickedImageData: clickedImageData, index: imageIndex , clickImageContext: props?.exploreNextType}
  setLastOpenedImageId(imageId)
  setClickedImageObj(clickedImageData)



  
  console.log("main final condition",clickImageObjectRef.current)

}




function closeAppSharer(){
   const sharedBox = document.querySelector('.app_sharer_container');
    if (sharedBox) {
      sharedBox.style.opacity = '0';
      sharedBox.style.pointerEvents = 'none';
    }

    // Remove highlight from icons
    document.querySelectorAll('.show_click_element').forEach((el) =>
      el.classList.remove('show_click_element')
    );
    
    document.querySelectorAll('.show_image_top_action_element').forEach((el) =>
      el.classList.remove('show_image_top_action_element')
    );
    document.querySelectorAll('.show_click_element_border').forEach((el) =>
      el.classList.remove('show_click_element_border')
    );
    setWeeklyModelOpen(false)

}
useEffect(() => {
  
  // Close sharer when user scrolls
  const handleScroll = () => {
   closeAppSharer()
  };

  // Close sharer when user clicks outside
  const handleClickOutside = (event) => {
    const sharedBox = document.querySelector('.app_sharer_container');
    if (!sharedBox) return;

    // If clicked outside the sharer
    if (!sharedBox.contains(event.target)) {
      sharedBox.style.opacity = '0';
      sharedBox.style.pointerEvents = 'none';

      document.querySelectorAll('.show_click_element').forEach((el) =>
        el.classList.remove('show_click_element')
      );
      document.querySelectorAll('.show_click_element_border').forEach((el) =>
        el.classList.remove('show_click_element_border')
      );
    }
  };

  window.addEventListener('scroll', handleScroll);
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('touchstart', handleClickOutside);


  return () => {
    window.removeEventListener('scroll', handleScroll);
    document.removeEventListener('click', handleClickOutside);
    document.removeEventListener('touchstart', handleClickOutside);
  };
}, []);

const [isSaved, setIsSaved] = useState(false);
const [isHideImage, setIsHideImage] = useState(false);
const [isdownloadedImage, setIsDownloadedImage] = useState(false);
const [isSuggested, setIsSuggested] = useState(false);
const [isDislikeImage, setDislikedImage] = useState(false);



useEffect(() => {
  // Decide which object to use
  const fromHome = props.suggestedObjectClickedValue;
  const sourceObj = fromHome ? fromHome.clickedImageObj : clickedImageObj;
  // const trigger = fromHome ? fromHome._forceUpdate : clickedImageObj;

  if (!sourceObj?.id) return;

  const id = sourceObj.id;

  // LS reads...
  const saved = JSON.parse(localStorage.getItem("savedImages")) || [];
  const hidden = JSON.parse(localStorage.getItem("hiddenImages")) || [];
  const disliked = JSON.parse(localStorage.getItem("DislikedImages")) || [];
  const suggested = JSON.parse(localStorage.getItem("suggestedImages")) || [];
  const downloaded = JSON.parse(localStorage.getItem("downloadedImages")) || [];

  // Update states
  setIsSaved(saved.some(img => img.id === id));
  setIsHideImage(hidden.includes(id));
  setDislikedImage(disliked.includes(id));
  setIsSuggested(suggested.some(img => img.id === id));
  setIsDownloadedImage(downloaded.includes(id));

}, [
  clickedImageObj?.id,                     
  props.suggestedObjectClickedValue?.clickedImageObj?.id,  


]);


function openSavedModel(){
     let mobileCartIcon = document.getElementById('cartmobileicon')
   let cartCounter = document.getElementById('cartmobileicon').firstElementChild
     document.getElementById("userCartContainer").classList.add("show_cart_container");     
     if(mobileCartIcon){
       mobileCartIcon.classList.add('active_cart_bg');
       cartCounter.style.color = "white";
     }
    document.body.style.overflowY = "hidden";
}


  function extendUserGuidesModelHeight(userGuideContent, type){
      if(userGuideContent){ 
  
              if(type === "weeklyForm"){
                  userGuideContent.style.transition = "all 0.2s linear"
                userGuideContent.style.height = "20dvh"
              }

    }
  }
   const [isLoadingGuides, setLoadingGuides] = useState(false)  
    const [openUserModelCounts, setOpenUserModelCounts] = useState(0)
    const [weeklyModelOpen, setWeeklyModelOpen] = useState(false)
  function openGuides() {
   
  
    setLoadingGuides(true)  
    

console.log("open sharer", weeklyModelOpen)
    
    let type ="weeklyForm"
    let buttonContent = "Got it!"
   let scrollY = window.scrollY;
   
    setTimeout(()=>{
    
  let userGuideContent = document.getElementById('WeeklyContent')
    if(!userGuideContent){
      return
    }
    
      if(window.innerWidth < 550){
        extendUserGuidesModelHeight(userGuideContent, type)
      }

    
document.getElementById("WeeklyGuides").classList.add("dialog_container_fluid_show")
document.getElementById("WeeklyGuides").style.transform = `translateY(0)`;
document.getElementById("WeeklyGuides").setAttribute("fromInfo", true) 
lockScroll()



  if(!sessionStorage.getItem("showEmailModel") && openUserModelCounts === 0){
    
    setOpenUserModelCounts(1)
    sessionStorage.setItem("showEmailModel", true)
  }
}, 0)


}

function lockScroll() {
  const scrollY = window.scrollY;

  document.body.dataset.scrollY = scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}

// useEffect(()=>{
// setTimeout(()=>{
//   openGuides()
// }, 5000)
// },[])

function trackEvent(name, params = {}) {    
  // console.log("track eventnew 1")
   if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return
// console.log("track eventnew 2")
  if (typeof window !== "undefined" && typeof window.gtag === "function") {    
    window.gtag("event", name, params);
  }
}

const handleSaveImage = (imageId, clickedImageObj, handleSuggested = false, ClickFromHome = true) => {  

if(ClickFromHome && props.componentFrom === "home"){
  clickedImageObj = props?.suggestedObjectClickedValue.clickedImageObj
}
 else if(clickImageObjectRef.current?.clickImageContext === "long"){
// clickImageObjectRef.current = {imageId: imageId, clickedImageData: clickedImageData, index: imageIndex , clickImageContext: props?.exploreNextType}

  clickedImageObj = clickImageObjectRef.current?.clickedImageData
  

}
else{
  
  clickedImageObj = clickedImageObj || props?.suggestedObjectClickedValue.clickedImageObj
}
  console.log("hanlde Save Image", clickedImageObj)
  if (!clickedImageObj) return;

  try {
    let savedImages
    if(handleSuggested){      
       savedImages = JSON.parse(localStorage.getItem("suggestedImages")) || [];
    }else{
       savedImages = JSON.parse(localStorage.getItem("savedImages")) || [];

    }
    const alreadySaved = savedImages.some(img => img.id === clickedImageObj.id);
// console.log("saved image object", clickedImageObj.id, props?.suggestedObjectClickedValue.clickedImageObj, props?.displayFor)
    // if (!savedImages.includes(clickedImageObj.id)) {
    if (!alreadySaved) {      
      // savedImages.push(clickedImageObj);
      savedImages.unshift(clickedImageObj);
      
    let filteredImage =  savedImages.filter((image)=> image !== null)

    if(handleSuggested){

      localStorage.setItem("suggestedImages", JSON.stringify(filteredImage));
      toast.success("Got it — we’ll show you more like this...");
      setIsSuggested(true); 
           closeAppSharer()
    }else{
      
  

      let savedImages = JSON.parse(localStorage.getItem("savedImages")) || [];
      let savedProductLength = savedImages.length;
      localStorage.setItem("savedImages", JSON.stringify(filteredImage));

      if(savedProductLength === 0){
        toast.success("Image saved — You have great taste 🔥");
        
      }else{
         const randomMessage = saveMessages[Math.floor(Math.random() * saveMessages.length)];
    toast.success(`Image saved — ${randomMessage}`);


      }
      // openGuides()
      // openSavedModel()
  
    
window.dispatchEvent(
  new CustomEvent("BN_SAVE_UPDATED", {
    detail: { id: clickedImageObj.id }
  })
);
      // toast.success("This memory now belongs to you.");
      setIsSaved(true); 
      console.log("saved images")
      showNewBadgeInSavedImage(clickedImageObj)


      if(props.fetchSavedImages){
        props.fetchSavedImages()

      }
      trackEvent("image_save", {
      page: props.componentFrom || "explore",
      image_id: clickedImageObj.id,
      source: props.displayFor || "explore_card",
      });
    }
    
      
    } else {
      if(handleSuggested){
        // toast.info("Already selected to yours suggested images");
        toast.info("✨ Already recommended for you")

      }else{
        toast.info("Image already saved");

      }
      // console.log("⚠️ Image already saved:", clickedImageObj.id);
    }
  } catch (error) {

    console.error("Error saving image:", error);
    
  }
};





function showNewBadgeInSavedImage(clickedImageObj){
  let newBadgeIds = JSON.parse(localStorage.getItem("savedNewBadges")) || [];
        if (!newBadgeIds.includes(clickedImageObj.id)) {
          console.log("saved id from saved function", clickedImageObj.id)
          newBadgeIds.push(clickedImageObj.id);
          // newBadgeIds.push("772991");
        }
        localStorage.setItem("savedNewBadges", JSON.stringify(newBadgeIds));

        console.log("Added NEW badge for image:", clickedImageObj.id);

}

const onSuggested = (imageId, clickedImageObj)=>{
  if(props.componentFrom === "home"){
  clickedImageObj = props?.suggestedObjectClickedValue.clickedImageObj
}  else if(clickImageObjectRef.current?.clickImageContext === "long"){
// clickImageObjectRef.current = {imageId: imageId, clickedImageData: clickedImageData, index: imageIndex , clickImageContext: props?.exploreNextType}

  clickedImageObj = clickImageObjectRef.current?.clickedImageData
  

}
else{
  
  clickedImageObj = clickedImageObj || props?.suggestedObjectClickedValue.clickedImageObj
}


   handleSaveImage(imageId, clickedImageObj, true)

}
const onDislike = (imageId, clickedImageObj)=>{
    if(props.componentFrom === "home"){
  imageId = props?.suggestedObjectClickedValue.clickedImageId
}
else if(clickImageObjectRef.current?.clickImageContext === "long"){

  imageId = clickImageObjectRef.current.imageId
  clickedImageIndex.current = clickImageObjectRef.current.index

}
else{
  
  imageId = imageId || props?.suggestedObjectClickedValue.clickedImageId
}

  handleHideImage(imageId, true)
}

const handleHideImage = (imageId, handleDislike = false) => {

  console.log("inside condition 1", clickImageObjectRef.current)

  // imageId = imageId || props?.suggestedObjectClickedValue.clickedImageId
  if(props.componentFrom === "home"){
  imageId = props?.suggestedObjectClickedValue?.clickedImageId
  console.log("inside condition 1")
}
else if(clickImageObjectRef.current?.clickImageContext === "long"){

  imageId = clickImageObjectRef.current.imageId
  clickedImageIndex.current = clickImageObjectRef.current.index

}
else{
  
  imageId = imageId || props?.suggestedObjectClickedValue?.clickedImageId
  console.log("inside condition 2", clickImageObjectRef.current, props?.exploreNextType)
}

  if (!imageId) return;
console.log("cross condition 3", imageId, clickedImageIndex.current , clickImageObjectRef.current)
  try {
    // Get hidden images from localStorage
    let hiddenImages
    if(handleDislike){
      hiddenImages = JSON.parse(localStorage.getItem("DislikedImages")) || [];
      // Avoid duplicates
      if (!hiddenImages.includes(imageId)) {
        hiddenImages.push(imageId);
        localStorage.setItem("DislikedImages", JSON.stringify(hiddenImages));
      }
      setDislikedImage(true)
      closeAppSharer()
      toast.info("Thanks! We'll show better recommendations.");


    }else{
      hiddenImages = JSON.parse(localStorage.getItem("hiddenImages")) || [];
  let element
    if(props.componentFrom === "home"){
      element = document.querySelector(`[data-image-id="${imageId}"]`);
    }else{

      element = document.querySelector(`[data-image-id="${imageId}-${clickedImageIndex.current}"]`);
    }
      // const element = document.querySelector(`[data-image-id="${imageId}-${clickedImageIndex.current}"]`);
      let clickedImage = element.querySelector('a')
      console.log("yes we get the image", clickedImage)
  
      // Avoid duplicates
      if (!hiddenImages.includes(imageId)) {
        hiddenImages.push(imageId);
        localStorage.setItem("hiddenImages", JSON.stringify(hiddenImages));
      }
  if(clickedImage){
    clickedImage.style.filter = "blur(80px)"
  }
  element.style.removeProperty("background-image")
  element.classList.add('disable-hover')
  setIsHideImage(true)
  closeAppSharer()

//   setTimeout(()=>{
// element.remove()
//   }, 800)

    }
   
 
  } catch (error) {
    if(handleDislike){
      console.error("Error Dislike:", error);

    }else{

      console.error("Error hiding image:", error);
    }
  }
};

function downloadImageFromButton(clickedObj){

  trackEvent("download_image_from_imagebutton", {downloadimageUrl: clickedObj?.previewURL, downloadImageCategory :  props?.displayImage, downloadFromWhichSection: props?.exploreNextType })
console.log("download image function")

   setTimeout(()=>{
 hitDownload({
    componentFrom: props?.componentFrom,
    clickedImageObj: clickedObj,
    displayImage: props?.displayImage,
    content,
    updatedHours
    
  })
    .then(() => {
      toast.success("Image downloaded");

      // setIsDownloadedImage(true);
      // setWeeklyModelOpen(true);
      // closeAppSharer()

 
    })
    .catch(() => {
      toast.error("Image couldn’t be downloaded. Please try again.");
      
    });
   }, 300)


}


function downloadedImage(lastOpenedImageId, ClickedImageObj) {
 
  // const clickedObj = props.componentFrom === "home" ? props?.suggestedObjectClickedValue?.clickedImageObj : clickedImageObj || props?.suggestedObjectClickedValue?.clickedImageObj;
  let clickedObj 
  if (props.componentFrom === "home"){
    clickedObj =  props?.suggestedObjectClickedValue?.clickedImageObj
  }
  else if(clickImageObjectRef.current?.clickImageContext === "long"){
// clickImageObjectRef.current = {imageId: imageId, clickedImageData: clickedImageData, index: imageIndex , clickImageContext: props?.exploreNextType}

  clickedObj = clickImageObjectRef.current?.clickedImageData
  

}
  else{
    clickedObj = clickedImageObj || props?.suggestedObjectClickedValue?.clickedImageObj

  }
console.log("download", clickedObj)
  hitDownload({
    componentFrom: props.componentFrom,
    clickedImageObj: clickedObj,
    displayImage: props.displayImage,
    content,
    updatedHours,
    lastOpenedImageId,
  })
    .then(() => {
      toast.success("Image downloaded");
      setIsDownloadedImage(true);
      setWeeklyModelOpen(true);
      closeAppSharer()

      // setTimeout(() => {
      //   openGuides();
      // }, 2000);
    })
    .catch(() => {
      toast.error("Image couldn’t be downloaded. Please try again.");
      closeAppSharer()
    });

}


  function clickOnMainContainer(event){
    event.preventDefault()
    // console.log("Scroll")
    const sharedBox = document.querySelector('.app_sharer_container');
    // console.log("Explore Ref click", window.getComputedStyle(sharedBox).opacity, event.target);
    if(!sharedBox && !sharedBox)  return 
    // sharedBox.style.opacity = getComputedStyle(sharedBox).opacity !== "0" && "0";
    if(window.getComputedStyle(sharedBox).opacity === "1"){
       if(document.querySelectorAll('.show_click_element')){

      document.querySelectorAll('.show_click_element').forEach(el => {
        el.classList.remove('show_click_element');
      });
    }
      sharedBox.style.opacity = "0"
      sharedBox.style.pointerEvents = "none"
    }
  }
  function onScrollClose(){
    console.log("scroll fire")
  }
  useEffect(()=>{
    if(!document.body || !exploreRef.current)  return 

  document.body.addEventListener('click', clickOnMainContainer);
  // exploreRef.current.addEventListener('scroll', onScrollClose);

  })

  function orignalElement(event){
    let shareButton = event?.currentTarget;
    if(shareButton){
      shareButton.firstElementChild.style.backgroundColor = "white";
      shareButton.firstElementChild.style.color = "";         
    }    
  }



// function storePosition(event, image){
//   // if(props.componentFrom === "exploreNext") return 
//   // ✅ SAVE EXPLORE STATE
//   sessionStorage.setItem(
//     "explore_state",
//     JSON.stringify({
//       images,              // your current images array
//       pageState,                // current page number
//       scrollY: window.scrollY,
//       timestamp: Date.now() // optional safety
//     })
//   );
//     }

//     useEffect(() => {
//       // if(location.state?.from !== "exploreNext") return 
//       console.log("yes scrolling and loading", location.state?.from)
//   const savedState = sessionStorage.getItem("explore_state");

//   if (savedState) {
//     const { images, page, scrollY } = JSON.parse(savedState);

//     setImages(images);
//    setPageState(page)
// console.log("yes scrolling")
//     requestAnimationFrame(() => {
//       // window.scrollTo(0, scrollY);
//            window.scrollTo({
//         top: scrollY,
//         behavior: "auto", // 👈 no animation
//       });
//     });


//   }
// }, []);

function hitExploreApi(query, nextPage){
   if(window.innerWidth < 580){
        getImages(
          `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&page=${nextPage}&per_page=8`
        );

      }else{
        getImages(
          `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&page=${nextPage}`
        );

      }
}

const recentlyUsedInterestRef = useRef([]);
const activeInterestCountRef = useRef(0);
const activeInterestRef = useRef(null);

function getTopSessionInterest(displayImage){

  const normalizedDisplay = (displayImage || "").toLowerCase().trim();

  const blockedWords = [
    normalizedDisplay,
    "nature",
    "landscape",
    "sky"
  ];

  // 🔥 KEEP SAME INTEREST FOR 2 FETCHES
  if(
     activeInterestRef.current &&
     activeInterestCountRef.current < 1
  ){

     activeInterestCountRef.current++;

     return activeInterestRef.current;

  }

  const entries =
    Object.entries(
      sessionInterestRef.current || {}
    );

  if (!entries.length){
    return null;
  }

  const sorted =
    entries.sort(
      (a, b) => b[1] - a[1]
    );

  const selectedInterest =
    sorted.find(([key, value]) => {

      const normalizedKey =
        key.toLowerCase();

      return (
        value >= 10 &&

        !blockedWords.some(
          blocked =>
            normalizedKey.includes(blocked)
        ) &&

        !recentlyUsedInterestRef.current.includes(
          normalizedKey
        )

      );

    });

  const finalInterest =
    selectedInterest?.[0] || null;

  if(finalInterest){

     activeInterestRef.current =
        finalInterest;

     activeInterestCountRef.current = 1;

     recentlyUsedInterestRef.current.push(
        finalInterest.toLowerCase()
     );

     recentlyUsedInterestRef.current =
        recentlyUsedInterestRef.current.slice(-3);

  }

  return finalInterest;

}

function hitExploreNextApi(query, nextPage){
   const useLatest = props?.source;   // 👈 condition here
  let orderParam = useLatest ? "&order=popular" : "";

    if(window.innerWidth < 580){
            
            // getImages(
            //   `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo${orderParam}&page=${nextPage}&per_page=8`,
            //   true
            // );

            // const per_item = props?.exploreNextType === "short" ? 8 : 15

              const per_item = props?.exploreNextType === "long" ? 20 : 15

              



            getImages(
              `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo${orderParam}&page=${nextPage}&per_page=${per_item}`,
              true
            );
          
            
          }else{
            


              
              // const per_item = props?.exploreNextType === "long" ? 15 : 15
              const per_item = props?.exploreNextType === "long" ? 20 : 15
              
             

              getImages(
                `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo${orderParam}&page=${nextPage}&per_page=${per_item}`,
                true
              );
            
          }
}


const chipIndexRef = useRef(0);
const chipSequenceRef = useRef([]);


useEffect(() => {
  if (props?.source && props.imageChips?.length) {
    chipSequenceRef.current = props.imageChips.map(c => 
      typeof c === "string" ? c : c.value || c.label
    );
    chipIndexRef.current = 0;

    console.log("sequence uery", chipSequenceRef.current)
  }
}, [props?.imageChips]);

// const useMainQueryRef = useRef(true);
// const pagePerQueryRef = useRef(0);
// const MAX_PAGES_PER_QUERY = 2; // or 3

// function retrunExploreNextQuery(baseQuery) {
//   const chipSequence = chipSequenceRef.current;

//   if (!chipSequence?.length) return baseQuery;

//   let currentQuery;

//   // 🔥 Step 1: Use MAIN query
//   if (useMainQueryRef.current) {
//     currentQuery = baseQuery;
//     useMainQueryRef.current = false;

//     pagePerQueryRef.current++;

//     if (pagePerQueryRef.current >= MAX_PAGES_PER_QUERY) {
//       pagePerQueryRef.current = 0;
//     }

//     return currentQuery;
//   }

//   // 🔥 Step 2: Use CHIP query
//   currentQuery =
//     chipSequence[chipIndexRef.current] || baseQuery;

//   if (pagePerQueryRef.current < MAX_PAGES_PER_QUERY - 1) {
//     pagePerQueryRef.current += 1;
//   } else {
//     pagePerQueryRef.current = 0;

//     if (chipIndexRef.current < chipSequence.length - 1) {
//       chipIndexRef.current += 1;
//     } else {
//       // 🔥 IMPORTANT: reset to main
//       chipIndexRef.current = 0;
//       useMainQueryRef.current = true;
//     }
//   }

//   return currentQuery;
// }
 

const CYCLE_LENGTH = 3; // 2 chip + 1 base
const START_SEQUENCE_AFTER_PAGE = 4;

function getChipIndex(baseQuery, totalChips) {
  let hash = 0;

  for (let i = 0; i < baseQuery.length; i++) {
    hash = (hash * 31 + baseQuery.charCodeAt(i)) >>> 0;
  }

  return hash % totalChips;
}

function getQueryForPage(page, baseQuery) {
  const chipSequence = chipSequenceRef.current;

  if (!chipSequence?.length) return baseQuery;

  // if (page < START_SEQUENCE_AFTER_PAGE) return baseQuery;

  // const relativePage = page - START_SEQUENCE_AFTER_PAGE - 1;
  const relativePage = page - START_SEQUENCE_AFTER_PAGE;

  // const chipIndex = relativePage % CYCLE_LENGTH;
// const chipIndex = 0;

  // if (cycleIndex === 2) {
  //   return baseQuery; // base page
  // }

  // // 🔥 chip pages
  // const chipIndex = Math.floor(relativePage / CYCLE_LENGTH) % chipSequence.length;

  // const chipIndex = runBaseLogic(relativePage, baseQuery, chipSequence)
  // 🔥 if null → base
  // if (chipIndex === null) {
  //   return baseQuery;
  // }



//   const chipIndex = 4
// console.log("chipsSequence", chipSequence)
//   return chipSequence[chipIndex] || baseQuery;


let chipIndex = getChipIndex(baseQuery, chipSequence.length);

  // If it happens to be the same chip, move to the next one.
  if (normalize(chipSequence[chipIndex]) === normalize(baseQuery)) {
    chipIndex = (chipIndex + 1) % chipSequence.length;
  }
console.log("chipsSequence", chipSequence, chipSequence[chipIndex])

  return chipSequence[chipIndex];
}
function normalize(str) {
  return str.toLowerCase().replace(/s$/, "");
}

function runBaseLogic(relativePage, chipSequence) {
  // EVEN → base
  if (relativePage % 3 === 0) {
    return null; // ✅ FIX
  }

  // ODD → chip
  return Math.floor(relativePage / 3) % chipSequence.length;
}



let fetchLock = useRef(false);
const MAX_SHORT_IMAGES = 8;
const shortPhaseCompleted = useRef(false);

function checkShortSectionLimit(){

    const reached =
    props?.exploreNextType === "short" &&
    images.length >= MAX_SHORT_IMAGES;

  if (reached) {
    shortPhaseCompleted.current = true; // ✅ mark complete
  }
  return reached;
}



const storeOnce = useRef(false)
const [shortImageSectionCount, setShortImageSectionCount] = useState()

function storeImageSectionCount(renderImages){

  if(props.exploreNextType === "long" || storeOnce.current) return

console.log("render image in short", renderImages.length, props?.exploreNextType)
  setShortImageSectionCount(renderImages.length)
  storeOnce.current = true

}


  useEffect(() => {
  if (props?.exploreNextType !== "short") return;

    // ✅ STOP if short phase is done
  if (shortPhaseCompleted.current) return;


  if (!shortImageSectionCount) return;

  const MIN_IMAGES = 8;
  const MAX_IMAGES = 12;

  if (
    shortImageSectionCount <= MIN_IMAGES &&
    images.length < MAX_IMAGES &&  !fetchLock.current
  ) {
    console.log("📥 Loading more for short section");

    // handleNextPage();
  }
}, [shortImageSectionCount, images]);


function consumeBufferedImages() {

  if(props?.exploreNextType === "short") return

  if (
    props?.componentFrom === "exploreNext" &&
    pendingImagesRef.current.length > 0
  ) {

    console.log("🔥 Using local buffered images");

    const nextChunk =
      pendingImagesRef.current.slice(0, 10);

    pendingImagesRef.current =
      pendingImagesRef.current.slice(10);

          // preloadImages(nextChunk);

    setupImageOnPage(
      { hits: nextChunk },
      pageState
    );

    return true;
  }

  return false;
}

function returnExploreNextPageNumber(loadedPage, pageState){
  let nextPage ;
  if(basePageRefForExploreNext.current === Number(pageState)){
nextPage = loadedPage + 1
console.log("yes already loaded... **")
  }else{
    nextPage = pageState + 1

    // console.log("yes already loaded... 1")
  }
  return nextPage;
}

  function handleNextPage(){
  
    if (props.componentFrom === "home" || checkShortSectionLimit()) return;
    
      // ✅ STOP condition for short section
 
    console.log("hanldeNext calling", shortImageSectionCount)
const usedBufferedImages = consumeBufferedImages();
if (usedBufferedImages) return;




     if (fetchLock.current) return;    
     if(props?.exploreNextType !== "short"){
       setBottomLoader(true);

     }

  fetchLock.current = true;
       if (props.componentFrom === "exploreNext" ) {
        
          // const nextPage = pageState + 1;
          console.log("yes already loaded... on handleNextPage 1", basePageRefForExploreNext.current)
          
          // const nextPage = Number(basePageRefForExploreNext.current) === Number(pageState) ?  setPageState(basePageRefForExploreNext.current + 1) : pageState + 1


          const nextPage = returnExploreNextPageNumber(basePageRefForExploreNext.current, pageState)

          console.log("yes already loaded... on handleNextPage 2",nextPage)
          setPageState(nextPage);
          setTrakImage(true);

            //  let currentQuery = props?.displayImage
             let currentQuery = createSafePixabayQuery(props?.displayImage)
          //  if(props.source &&  nextPage >= START_SEQUENCE_AFTER_PAGE){
          //   //  currentQuery = retrunExploreNextQuery(props.displayImage)
            
          //   currentQuery = getQueryForPage(nextPage, props.displayImage)

          //  }else{
          //   currentQuery = props.displayImage
          //  }

          // console.log("current query", currentQuery, nextPage, basePageRefForExploreNext.current)
          
//           if(Number(nextPage) === 3){
//             const chipsQuery =  getQueryForPage(nextPage, props?.displayImage);
//              currentQuery =  createSafePixabayQuery(`${chipsQuery}`);
// console.log("fetches for page 3", chipsQuery, currentQuery, chipSequenceRef.current)

//           }
          
// if(Number(nextPage) === 3 || Number(nextPage) === 5 || Number(nextPage) === 7 || Number(nextPage) === 10){
if(Number(nextPage) === 8){
          const topInterest =  getTopSessionInterest(props?.displayImage);
          if (topInterest && Math.random() < 1) {
                // currentQuery = `${props.displayImage} ${topInterest}`;
               currentQuery =  createSafePixabayQuery(`${topInterest}`);
               
            }
            // currentQuery =   buildExploreNextQuery(props?.displayImage);
}
          console.log("next page in mainpage", nextPage, currentQuery, sessionInterestRef.current)
        hitExploreNextApi(currentQuery, nextPage)
        

        
  


        } else {
          const nextPage = pageState + 1;
          setPageState(nextPage);
          console.log("hanldeNext calling in explore")

          // const currentCalculatedIndex = updatedHours();
          // const query = clickedTag || content[currentCalculatedIndex];
          const query = clickedTag || moodQuery;
     
      // hitExploreApi(query, nextPage)

         if(window.innerWidth < 580){
        getImages(
          `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&page=${nextPage}&per_page=8`
        );

      }else{
        getImages(
          `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&page=${nextPage}`
        );

      }



     
        }
        //  fetchLock.current = false;
    }


    function buildExploreNextQuery(displayImage) {

  const topInterest =
    getTopSessionInterest();

  const normalizedDisplay =
    (displayImage || "")
      .toLowerCase()
      .trim();

  const normalizedInterest =
    (topInterest || "")
      .toLowerCase()
      .trim();

  let mergedQuery =
    displayImage;

  // prevent duplicate merge
  if (
    topInterest &&
      !normalizedDisplay.includes(normalizedInterest) &&
  !normalizedInterest.includes(normalizedDisplay)
  ) {

    mergedQuery =
      `${displayImage} ${topInterest}`;
  }

  // always sanitize final query
  return createSafePixabayQuery(
    mergedQuery
  );
}


// function checkingElement(){
//   if(exploreRef.current.children.length < 5) return 

//   let mainContainerLastChild = exploreRef.current.children.length-2
//   return mainContainerLastChild
// }


function highlightTag(){

  let scrollTopElement = document.querySelector('.blog_tag_suggestion')
    if(scrollTopElement && scrollTopElement.children.length > 0){
      Array.from(scrollTopElement.children).forEach((tag)=>{
        // console.log("highlight tag", clickedTag)
        if(clickedTag !== "" && tag.innerText === clickedTag){
          tag.classList.add("highlight_tag")
        }
      })
    }

}

//Now Written below code is for the scrollTag functionality--------------------------
function fetchTagImages(){
  let scrollTopElement = document.querySelector('.blog_tag_suggestion')
  if(scrollTopElement && scrollTopElement.children.length > 0){
      // to Remove the all listner first
       Array.from(scrollTopElement.children).forEach((tag) => {
      if (tag.classList.contains('app_blog_tag_text')) {
        // Clean up existing listener
        tag.replaceWith(tag.cloneNode(true)); // Removes all listeners
      }
    });


    Array.from(scrollTopElement.children).forEach((tag)=>{
      if(tag.classList.contains('app_blog_tag_text')){
        tag.addEventListener('click', async (e)=>{
       
      // e.preventDefault()
      // setImages([])
      // setloader(true)
setClickedTag(e.target.innerText)
sessionStorage.setItem("userFav", e.target.innerText)
        setImages([]);
        setPageState(1);
        setloader(true);
        setTrakImage(true); 
        setBottomLoader(false); 
        // console.log("blogcolRef", blogColRef.current)
        // e.target.classList.add("highlight_tag")
        
       
        // Call the getBlogs function
        

    await  getImages(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${e.target.innerText}&image_type=photo`, true)
      // console.log("yes tag clicked", e.target.innerText,  blogColRef.current)
     

      
     })
      }
      
  
    })

  }
}

// useEffect(()=>{
//   setTimeout(()=>{

//     fetchTagImages()
//   }, 300)
// })

function pexelsImageUrlFromImageKit(originalUrl, safeWidth, quality){
   try {

      const url =
        new URL(originalUrl);

      let relativePath =
        url.pathname.replace(
          /^\/photos\//,
          ""
        );

      return `https://ik.imagekit.io/k4vr4hitu/tr:w-${safeWidth},q-${quality},f-auto/${relativePath}`;

    } catch (err) {

      return originalUrl;

    }
}


function toImageKitURL(originalUrl, width = 640, quality= 80, statusPack = false) {
  quality = window.innerWidth < 576 ? 50 : 80;
if (!originalUrl) return "";

  // =========================
  // ⭐ PEXELS
  // =========================

  if (
    originalUrl.includes(
      "pexels.com"
    )
  ) {
    const safeWidthforPexels = Math.min(width || 640, 1280);
    let pexelsImageUrl = pexelsImageUrlFromImageKit(originalUrl, safeWidthforPexels, quality)
    return pexelsImageUrl
   
  }

//   if (!statusPack &&  originalUrl.includes("pixabay.com")) {
//   return originalUrl;
// }

  const basePixabayUrl = "https://pixabay.com/get/";
  const cdnPixabayUrl = "https://cdn.pixabay.com/";

  let relativePath = "";

  // Extract relative path based on known Pixabay sources
  if (originalUrl.startsWith(basePixabayUrl)) {
    relativePath = originalUrl.replace(basePixabayUrl, "");
  } else if (originalUrl.startsWith(cdnPixabayUrl)) {
    relativePath = originalUrl.replace(cdnPixabayUrl, "");
  } else {
    try {
      // Handle cases where full URL is passed but doesn't match known bases
      const url = new URL(originalUrl);
      relativePath = url.pathname.startsWith("/") ? url.pathname.slice(1) : url.pathname;
    } catch (err) {
      // Fallback to the original (if it's already relative or malformed)
      relativePath = originalUrl;
    }
  }
    // ⭐ HARD CLAMP WIDTH
  const safeWidth = Math.min(width || 640, 1280);

  console.log("Original: 1", originalUrl);
console.log(" Original Relative:", relativePath);
console.log(" Original ImageKit:", `https://ik.imagekit.io/k4vr4hitu/tr:w-${safeWidth},q-${quality},f-auto/${relativePath}`);

  // Return the ImageKit CDN URL with transformations
  return `https://ik.imagekit.io/k4vr4hitu/tr:w-${safeWidth},q-${quality},f-auto/${relativePath}`;
}







//  useEffect(() => {
//   let start = null;

//   const timer = setTimeout(() => {
//     if (images.length > 0) {
//       start = Date.now();
//     }
//   }, 15000); // Delay start time tracking by 15 sec

//   return () => {
//     clearTimeout(timer);
//     if (start) {
//       const timeSpent = Date.now() - start;
//       window.gtag('event', 'time_on_page', {
//         event_category: 'Explore Page',
//         event_label: 'Explore Component',
//         value: Math.round(timeSpent / 1000),
//       });
//     }
//   };

//   }, []);

    // function exploreSimilarImages(event, image){
    function exploreSimilarImages(image){
      
      if(!image) return
      
    // event.stopPropagation();            
    // const url  = `/explore-next/${image.type}/${image.tags.split(',')[0]?.trim().toLowerCase().replace(/\s+/g, '-')}`;
    // console.log("handle image click... from exploreSimilarImage")         
    // navigate(url, { state: { imageData: image } });

//  event.stopPropagation();

  const tag = image.tags?.split(',')[0]
    ?.trim()
    .toLowerCase()
    .replace(/\s+/g, '-');

  const newUrl = `/explore-next/photo/${tag}`;

  const currentPath = window.location.pathname;

  // 🚀 If already on same page → DO NOT navigate
  if (currentPath === newUrl) {
    return;
  }
  console.log("image explore", image, newUrl)

  navigate(newUrl, { state: { imageData: image } });


    }

    function hideExploreNextAppStatus(){
      if(props.setHideExploreStatus && !localStorage.getItem("clickExploreNextTop")){
            setTimeout(()=>{
                    localStorage.setItem("clickExploreNextTop", "true")
                    props.setHideExploreStatus(true)
            }, 500)
      }
    }

    function handleImageClick(img, uuid, hasOverlay = false, isFirstImageClick = false, clickedImageUrl, eventOn="explore_image_click", hasCreator = false, imagePosition="unknow") {
      sessionStorage.setItem("showExploreReturnToast", "true");
      // console.log("click image tracking working", eventOn)

       if(props.dismissAppStatus && !localStorage.getItem('hideDiscoveryNote')){
            props.dismissAppStatus()
        }
      
      hideExploreNextAppStatus()
  
      console.log("handle image click...")
      // console.log("image status", imageStates[index].loaded)      
      // if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;
      // if (!imageStates[uuid]?.previewLoaded) return; 

      

      const from = (props.componentFrom || "explore").toLowerCase();

      if(isFirstImageClick){
          trackEvent(`explore_first_image_click_${from}`, {
        img_id: img?.id,
        clickedImageTags: img?.tags || "No tags",
        image_url: img?.previewURL || img?.webformatURL,
        clickedImagePath: window.location.pathname,
        clickedImageFromComponent: from,
        clickedImageHasOverlay: hasOverlay,   
        deviceWidth: time,   
      });

      }else{

      
console.log("image click on", eventOn)
      trackEvent(`${eventOn}_${from}`, {
        img_id: img?.id,
        clickedImageTags: img?.tags || "No tags",
        image_url: img?.previewURL || img?.webformatURL,
        clickedImagePath: window.location.pathname,
        clickedImageFromComponent: from,
        clickedImageHasOverlay: hasOverlay,
        clickImageUrl: clickedImageUrl,
        clickImageSource: img?._source || "pixabay",
        displayCreator: hasCreator,
        imagePosition: imagePosition
      });

      // console.log("image clickesnew", clickedImageUrl, hasOverlay, img?.tags)
    }
      
  
    }

const [showReturnToast, setShowReturnToast] = useState(false);

useEffect(() => {
  const flag = sessionStorage.getItem("showExploreReturnToast");
  const hidden = localStorage.getItem("hideExploreReturnToast") === "true";

  if ((props.componentFrom !== "home" && props.componentFrom !== "exploreNext") && flag === "true" && !hidden) {
    setShowReturnToast(true);
        localStorage.setItem("hideExploreReturnToast", "true");
                 
    sessionStorage.removeItem("showExploreReturnToast");
  }
}, []);

useEffect(() => {
  if (!showReturnToast) return;

  const timer = setTimeout(() => {
    setShowReturnToast(false);
  // if(props.dismissAppStatus){
  //     props.dismissAppStatus()
  //   }
   
  }, 5000); // 👈 3 seconds

  return () => clearTimeout(timer);
}, [showReturnToast]);

const ShowFoursImageInRow =  true

const breakpointColumnsObj = {
  default: props?.columns ? props?.columns  : ShowFoursImageInRow ? 4 : 3,   // 4 columns on large screens
  // default: window.location.pathname === "/explore" || props?.componentFrom === "exploreNext"  ? 4 : 3,   // 4 columns on large screens
  1100:  props?.columns ? props?.columns : 3,      // 3 columns if width <= 1100px
  700: 3,       // 2 columns if width <= 700px
  500: 2        // 1 column on small screens

  //   default: 4,
  // 1500: 4,
  // 1280: 3,
  // 700: 2,
  // 500: 1
};

function handleLoaded(id) {
  setImageStates((prev) =>
    prev.map((img) =>
      img.id === id ? { ...img, loaded: true } : img
    )
  );
}


function handleVisible(id) {
  setImageStates(prev =>
    prev.map(img => img.id === id ? { ...img, visible: true } : img)
  );
}



const imageStatesRef = useRef(imageStates);

useEffect(() => {
  imageStatesRef.current = imageStates;
}, [imageStates]);

function showPreviewImage(uid, currentTarget){

  // if(!isMobile) return
// console.log("show image from  preview...")
  if(images.length > 10 && !imageStatesRef?.current[uid]?.fullLoaded) return
  

  
   const state = imageStatesRef.current[uid];

  //  console.log("show image from  preview... come after condiditon")
    
     if (!state?.previewLoaded) {
       
       requestAnimationFrame(() => {
        setTimeout(()=>{
          markPreviewLoaded(uid); 

        // currentTarget.style.border = "5px solid blue"
        // console.log("show image from  preview... show from function")
        // }, 300)
        }, 1300)
  
});
      
      
    }
}


const sessionInterestRef = useRef({});
function boostSessionInterest(image) {

  if(image?._source === "pexels") return 

  const tags = image?.tags?.toLowerCase()?.split(",") || [];

  tags.forEach(tag => {

    const cleanTag = tag.trim();

    sessionInterestRef.current[cleanTag] =
      (sessionInterestRef.current[cleanTag] || 0) + 2;

  });

  // category boost
  const category = image?._category;

  if (category) {

    sessionInterestRef.current[category] = (sessionInterestRef.current[category] || 0) + 5;

  }
console.log("session scroll from boostSessionInterest", sessionInterestRef.current)


}

function getDistanceFromCenter(element) {
  const rect = element.getBoundingClientRect();

  const imageCenter =
    rect.top + rect.height / 2;

  const viewportCenter =
    window.innerHeight / 2;

  return Math.abs(imageCenter - viewportCenter);
}
function getClosestImageToCenter() {
  let closestUid = null;
  let closestDistance = Infinity;

  Object.entries(displaySeeMoreImageRef.current).forEach(
    ([uid, element]) => {

      const rect = element.getBoundingClientRect();

      // Ignore off-screen images
      if (
        rect.bottom < 0 ||
        rect.top > window.innerHeight
      ) {
        return;
      }

      const distance = getDistanceFromCenter(element);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestUid = uid;
      }
    }
  );

  return closestUid;
}

function getDistanceFromViewportCenter(element) {
  const rect = element.getBoundingClientRect();

  const imageCenterX = rect.left + rect.width / 2;
  const imageCenterY = rect.top + rect.height / 2;

  const viewportCenterX = window.innerWidth / 2;
  const viewportCenterY = window.innerHeight / 2;

  return Math.sqrt(
    Math.pow(imageCenterX - viewportCenterX, 2) +
    Math.pow(imageCenterY - viewportCenterY, 2)
  );
}


const seeMoreRef = useRef({});
const activeSeeMoreRef = useRef(null);
const displaySeeMoreImageRef = useRef({});
const hoverTimerRef = useRef({});

function displaySeeMore(uid, imageObject) {

  if(imageObject?.webformatHeight < 180) return 

  // const centerUid =   getClosestImageToCenter();
  // const centerUid =  Math.random() > 0.5 ? getClosestImageToCenter()  : getClosestImageToCenter();

  // const centerUid = getClosestImageToCenter();

  // // Only allow center-most image
  // if (centerUid !== uid) {
  //   return;
  // }

  if (
    activeSeeMoreRef.current &&
    activeSeeMoreRef.current !== uid
  ) {
    const previousButton =
      seeMoreRef.current[activeSeeMoreRef.current];

    if (previousButton) {
      previousButton.style.display = "none";
    }
  }

  const button = seeMoreRef.current[uid];

  if (button) {
    button.style.display = "flex";
    

requestAnimationFrame(() => {
  button.classList.add("show");
});
    activeSeeMoreRef.current = uid;
  }
}

function hideSeeMore(uid) {
  const button = seeMoreRef.current[uid];

  if (button) {
    // button.style.display = "none";
    button.classList.remove("show");

setTimeout(() => {
  button.style.display = "none";
}, 350);

  }

  if (activeSeeMoreRef.current === uid) {
    activeSeeMoreRef.current = null;
  }
}
function getRedirectinUrl(image){
   let targetTag = getTargetTag(image)

  if(image?._source === "pexels"){
    console.log("pexels image tags", image.tags)
    targetTag = extractImageCategory(image.tags, content)
    console.log("set target nevigate url", targetTag, content)
  }
  return targetTag
}
const recordedImpressionsRef = useRef(new Set());

function trackRecommendationImpression(image, index) {
  // if (
  //   props.componentFrom !== "home" ||
  //   props.displayFor !== "homeTopic"
  // ) {
  //   return;
  // }

  const imageId = image?.id;
  if (imageId == null) return;

  const query =
    props.forcedCategory ||
    image?._category ||
    moodQuery ||
    "";
    let component = props?.componentFrom || "explore"
    const source = image?._source || "pixabay";
  const impressionKey = `${component}:${query}:${source}:${imageId}`;

  if (recordedImpressionsRef.current.has(impressionKey)) {
    return;
  }

  recordedImpressionsRef.current.add(impressionKey);

  console.log("Impression started:", imageId);

  import("../recommendations/sharedLearning")
    .then(({ recordImageImpression }) => {
      console.log("Impression started: Sending impression to backend:", imageId);

      return recordImageImpression({
        image,
        query,
        component: props.componentFrom || "explore",
        position: index,
      });
    })
    .then((success) => {
      console.log("Impression started: Backend request result:", success);

      if (success === false) {
        recordedImpressionsRef.current.delete(impressionKey);
      }
    })
    .catch((error) => {
      recordedImpressionsRef.current.delete(impressionKey);

      console.error("Failed to send impression:", error);
    });
}


function trackImageViewDuration(id, entry,  currentTarget, image, uid){
      // if (gaDisable)  return
    const index = Number(currentTarget.dataset.index);
    // Track a recommendation impression after 1 second.
setTimeout(() => {
  if (visibleMapRef.current.get(id)) {
    // trackRecommendationImpression(image, index);
  }
}, 1000);

    
let redirectUrl = getRedirectinUrl(image)
    setTimeout(() => {

    if (visibleMapRef.current.get(id)) {
      // console.log("image tracked by 2s", id);

      trackEvent("viewed_image_2s", {trackImageId: `${image?._source || "pixabay"}-${id}` , categoryImage: props?.displayImage || moodQuery, viewed3SImageUrl: image?.previewURL, viewedImageSource: image?._source || "pixabay", redirectionURL: redirectUrl, imagePosition: index, from: window.location.pathname, deviceWidth: `${window?.innerWidth}-${window.innerWidth <= 768 ? "mobile" : "desktop"}-${time}`})
      boostSessionInterest(image)
      // displaySeeMore(uid);
         // ✅ Only scale selected images
      // if (shouldScale(index)) {
        // ScaleImageAfter2s(currentTarget);
        
      // }
      
    }
  }, 2000);

  setTimeout(()=>{
     if (visibleMapRef.current.get(id)) {
      trackEvent("viewed_image_3s", {trackImageId: `${image?._source || "pixabay"}-${id}` , categoryImage: props?.displayImage || moodQuery, viewed3SImageUrl : image?.previewURL, viewedImageSource: image?._source || "pixabay", redirectionURL: redirectUrl, imagePosition: index, from: window.location.pathname, deviceWidth: `${window?.innerWidth}-${window.innerWidth <= 768 ? "mobile" : "desktop"}-${time}`})
    //  boostSessionInterest(image)
    //   console.log("viewed_3s", image)
      


     }
  }, 3000)

  setTimeout(() => {
    if (visibleMapRef.current.get(id)) {
           
      trackEvent("viewed_image_4s", {trackImageId: `${image?._source || "pixabay"}-${id}` , categoryImage: props?.displayImage || moodQuery, viewed3SImageUrl: image?.previewURL,  viewedImageSource: image?._source || "pixabay", redirectionURL: redirectUrl, imagePosition: index, from: window.location.pathname, deviceWidth: `${window?.innerWidth}-${window.innerWidth <= 768 ? "mobile" : "desktop"}-${time}`})
      // boostSessionInterest(image)
      observerRef.current.unobserve(entry.target);
     
    }
  }, 4000);
}


const imageTimersRef = useRef({});
const stalledTrackedRef = useRef(new Set());
const loadedImageUidsRef = useRef(new Set());
function trackImageStalled(image){

  if (!image?._uid) return;

  
  if (imageTimersRef.current[image._uid]) {
    clearTimeout(imageTimersRef.current[image._uid]);
  }

  imageTimersRef.current[image._uid] = setTimeout(() => {

    const state = imageStatesRef.current?.[image._uid];

    if (!state?.fullLoaded) {

      if (!stalledTrackedRef.current.has(image._uid)) {

        stalledTrackedRef.current.add(image._uid);

        trackEvent("image_stalled", {
          imageId: image?.id,
          uid: image?._uid,
          category: props?.displayImage,
          page: pageState,
          source: image?._source || "pixabay",
        });

        console.log("IMAGE STALLED", image);
      }
    }

  }, 7000);
}



const imageDataMapRef = useRef(new Map());
const setImageRef = useCallback((el, id, uid, index, image) => {
  if (!el) return;

  // 🔥 debug
  
// console.log("REF ATTACHED", id);

  if (!observerRef.current) return;

  el.dataset.id = id
  el.dataset.uid = uid;
  el.dataset.index = index;
  imageDataMapRef.current.set(uid, image);
  // trackImageStalled(image);
  observerRef.current.observe(el);
}, []);

const handleScroll = debounce(() => {
  const centerUid = getClosestImageToCenter();

  if (!centerUid) return;
   // wait until image loaded
  

const imageObject =  imageDataMapRef.current.get(centerUid);

displaySeeMore(centerUid, imageObject);
  
}, 300);


function debounce(fn, delay) {
  let timer;

  return (...args) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}



const observed = useRef(new Set());
const observerRef = useRef(null);
const visibleMapRef = useRef(new Map());
const seeMoreTimerRef = useRef({});

useEffect(() => {
  // if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;
    const isAnalyticsDisabled = localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true";

  observerRef.current = new IntersectionObserver((entries) => {

entries.forEach((entry) => {
  const id = entry.target.dataset.id;
  const uid = entry.target.dataset.uid;
 const currentTarget = entry.target
 const imageObject = imageDataMapRef.current.get(uid);
  if (entry.isIntersecting) {
    visibleMapRef.current.set(id, true);
    showPreviewImage(uid, currentTarget)
      

  } else {
    visibleMapRef.current.set(id, false);
  }


  if (!entry.isIntersecting) {
      visibleMapRef.current.set(id, false);

      hideSeeMore(uid);

  // if (seeMoreTimerRef.current[id]) {
  //   clearTimeout(seeMoreTimerRef.current[id]);
  // }
       return;
  }
if (!observed.current.has(id)) {
  observed.current.add(id);
  
trackImageViewDuration(id, entry, currentTarget, imageObject, uid)
}

// if (seeMoreTimerRef.current[id]) {
//   clearTimeout(seeMoreTimerRef.current[id]);
// }

// seeMoreTimerRef.current[id] = setTimeout(() => {

//   if (visibleMapRef.current.get(id)) {
//     if(props?.source){
//     displaySeeMore(uid, imageObject);
//     }
//   }

// }, 2000);


});
  }, { threshold: 0.6 });


// if(props?.source){
//   window.addEventListener("scroll", handleScroll);

// }

  return () =>{ 
    // if(props?.source){
    // window.removeEventListener("scroll", handleScroll);
    // }
    observerRef.current.disconnect();
  }
}, []);



function shouldScale(index) {
  return index % 8 === 0; // every 6th image
}

function shouldDisplayLabel(index, image) {
  const seed = image.id || image._uid || index;
  const hash = (seed * 9301 + 49297) % 233280;
  const random = hash / 233280;

  // fixed positions (every 8th)
  if (index !== 0 && index % 15 === 0) return true;

  // reduce frequency
  // if (random < 0.01) {
  if (random < 0.03) {
    // spacing control using index itself
    return index % 40 !== 0; // avoid clustering
  }

  return false;
}

function getRandomNumber(seed) {
  const hash = (seed * 9301 + 49297) % 233280;
  return Math.floor((hash / 233280) * 10) + 1;
}

function getImageLabel(image, index) {

  if(Number(pageState) <= 8) return

  const isShort = props.exploreNextType === "short";

    // ⭐ SHORT MODE → show ONLY once
  if ( index === 6  && isShort) {
    return index === 6 ? "🔥 Popular style" : undefined;
  }

  const seed = image.id || image._uid || index;
const hash = (seed * 9301 + 49297) % 233280;
const random = hash / 233280;

  if(!shouldDisplayLabel(index, image)) return 
  
  // 1. High downloads → strong intent
  // if (image.downloads > 2500) return "🔥 Popular style";

  // 2. High views → trending
  // if (image.views > 5000) return "Trending";

  // 3. Portrait image → story
  if (image.webformatHeight > image.webformatWidth)
    return "Looks Great on Instagram Story";

  // 4. Category based
  if ((image._category === "nature" || image._category === "sunset") && random < 0.03)
    return "✨ Creator Favourite";

  // 5. fallback (light variation)
  const fallback = [
    `✨ Used by ${getRandomNumber(seed)}K`,
    "🔥 Fresh style",
    "🌿 Calm vibe",
    "🔥 Popular style",
    "📈 Trending image"
  ];

  return fallback[index % fallback.length];
}

function ScaleImageAfter2s(currentTarget){
     let image = currentTarget.querySelector('img')
     if(!image) return
    
      image.style.transition = "all 0.3s ease-in-out"
      image.style.transform = "scale(1.3)"

      setTimeout(()=>{
      image.style.transform = "scale(1)"
      }, 300)
}

function showLongSectionImageBlur(index, hasOverlay) {
  // const isShortType = props.exploreNextType === "long";

  // existing condition (0 and 2)
  // const isInitialBlur = isShortType && (index === 0 || index === 2);

  // new condition (every 8th index)
  const isEvery8th = index % 8 === 0;

  // return isInitialBlur || (hasOverlay && isEvery8th);
  return (hasOverlay && isEvery8th);
}

function formatIdeaLabel(text, targetTag) {
  if (!text) return "";

  let words = text.trim().toLowerCase().split(/\s+/);

  if(targetTag === "idealabel"){
  // Add '&' before the last word if there are more than 3 words
  if (words.length > 3) {
    words.splice(words.length - 1, 0, "&");  
  }
  let result = words.join(" ");
  // Truncate if more than 4 original words
  if (text.trim().split(/\s+/).length > 7) {
    result = result.split(/\s+/).slice(0, 5).join(" ") + "...";
  }

  // Capitalize only the first character
  return result.charAt(0).toUpperCase() + result.slice(1);

  }else{

     if (words.length > 2) {
    words.splice(words.length - 1, 0, "&");  
  }
  let result = words.join(" ");
  // Truncate if more than 4 original words
  if (text.trim().split(/\s+/).length > 2) {
    result = result.split(/\s+/).slice(0, 1).join(" ") + "more...";
  }

  // Capitalize only the first character
  return result.charAt(0).toUpperCase() + result.slice(1);
  }
}


function capitalize(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// function generateHumanTitle(category) {
//   const words = category
//     .toLowerCase()
//     .split(/\s+/)
//     .filter(Boolean)
//     .filter(w => !STOP_WORDS.has(w))
//     .map(singular);

//   if (words.length === 0) return "Images";

//   if (words.length === 1) {
//     const word = capitalize(words[0]);

//     // If the word has more than 3 letters, append "Photos"
//     if (word.length > 3) {
//       return `${word} Pictures`;
//     }

//     return word;
//   }

//   if (words.length === 2) {
//     return `${capitalize(words[1])} ${capitalize(words[0])}`;
//   }

//   return words.map(capitalize).join(" ");
// }

function generateHumanTitle(category) {
  const words = (category || "")
    .toLowerCase()
    .split(/[\s-]+/)
    .map(singular)
    .filter(Boolean)
    .filter(w => !STOP_WORDS.has(w));

  if (!words.length) return "Images";

  const unique = [...new Set(words)];

  const hasMore = unique.length > 3;

  const selected = unique.slice(0, 3);

  const title = selected.map(capitalize).join(" ");

  return hasMore
    ? `${title} & More`
    : `${title} Pictures`;
}

function getBestUniqueTag(tags, usedTitles) {
  const allTags = (tags || "")
    .split(",")
    .map(t => t.trim())
    .filter(Boolean);

  for (const tag of allTags) {
    const imageTitle = generateHumanTitle(tag);

    if (!usedTitles.has(imageTitle.toLowerCase())) {
      usedTitles.add(imageTitle.toLowerCase());

      return {
        tag,
        imageTitle,
      };
    }
  }

  const fallbackTag = allTags[0] || "Image";

  return {
    tag: fallbackTag,
    imageTitle: generateHumanTitle(fallbackTag), // <-- same property
  };
}

const showPostCTA = isNatureQuery(props.displayImage);

let showHomeCaption = false
function buildExploreFeed(images, options) {
  const feed = [];
  const { isReturning, preferredCategory, isMobile } = options;
    // const postCardEnabled = props?.exploreNextType === "long" && showPostCTA;
    const postCardEnabled = false;

  // Reserve a different image for the post card
  const postCardImage = (postCardEnabled || showHomeCaption) ? images[7]   : null;

  const postCardImageId =  postCardImage?._uid;

  images.forEach((img, index) => {
       // into the normal IMAGE feed.
    if (img?._uid === postCardImageId) {
      return;
    }
    feed.push({
      type: "IMAGE",
      image: img,
      index,

      // ❌ Personalization disabled for now
      // belowText:
      //   index === 9 && isReturning && preferredCategory && !isMobile
      //     ? `Because you explored ${preferredCategory} ✨`
      //     : null,
    });


      // 🔁 Purpose-driven text every 9 images
   if (index === 2) {

    let typeText = window.innerWidth > 580 ? "Click" : "Tap"


  feed.push({
    type: "ImportantText",
  // label: `${props.componentFrom === "exploreNext" ? "Scroll less. Discover better visuals..." : `${typeText} any image to see similar more images...`}`,
  // label: `${props.componentFrom === "exploreNext" && !props.source ? "Scroll less. Discover better visuals..." : `${typeText} any image to see similar more images...`}`,
    // label: `Perfect for wallpaper or posts 📱`,
    // label: `Perfect for ${props.displayImage} posts`,
    label: "Tap image → download or explore ⬇️",
  });
}

    // 🔁 Purpose-driven text every 9 images
   if (index > 0 && index % 9 === 0) {
  const textIndex = Math.floor(index / 9) - 1;

  const texts = isMobile ? PURPOSE_TEXTS_MOBILE : PURPOSE_TEXTS_DESKTOP;

  const label = texts[textIndex % texts.length];

  feed.push({
    type: "ImportantText",
    label,
  });
}

console.log("yes show post", showPostCTA)
if (!isMobile && index === 6 && postCardEnabled && postCardImage) {
  
    feed.push({
    type: "POST_CARD",
    image: postCardImage,
    label: "✨ Create a post from this image",
  });
}

if (!isMobile && index === 3 && showHomeCaption && postCardImage) {
  
    feed.push({
    type: "POST_CARD",
    image: postCardImage,
    label: "✨ Create a post from this image",
  });
}

    // ❌ Personalization anchor disabled
    // if (index === 9 && isReturning && preferredCategory && !isMobile) {
    //   feed.push({
    //     type: "SECTION",
    //     label: `Because you explored ${preferredCategory} ✨`,
    //   });
    // }

    // 🌱 Freshness cue (keep)
    if (index === 40) {
      feed.push({
        type: "TEXT",
        label: "✨ Fresh picks for today",
      });
    }
    let displayIdeaFirstIndex = postCardEnabled ? 25 : 13
    if(props?.exploreNextType === "long" && (index === displayIdeaFirstIndex ||  index === 75)){

 const SECTION_OFFSET = {
  displayIdeaFirstIndex : 0,
  75: 4,
  120: 8,
  180: 12,
};     

 const start = SECTION_OFFSET[index] ?? 0;

    // take next 4 real images from your feed to show in idea cards
      const rankedIdeas = getRankedImages(props?.displayImage, true, start, 4).filter(
    img =>
      img.webformatURL &&
      img.webformatURL !== "(not set)"
  ).sort((a, b) => b.score - a.score)
  .slice(0, 4)
  .map(normalizeRankingImage)
  .filter(Boolean);

  console.table("ideas image 0",
  rankedIdeas.map(i => ({
    id: i.id,
    source: i._source,
    webformatURL: i.webformatURL,
    largeImageURL: i.largeImageURL,
    previewURL: i.previewURL,
  }))
);

const usedTitles = new Set();
const ideas = rankedIdeas.map((ideaImg) => {
  const firstTag = ideaImg.tags?.split(",")[0]?.trim() || "Image";
  console.log("idea image tags",ideaImg.tags);

    const { tag, imageTitle } = getBestUniqueTag(
    ideaImg.tags,
    usedTitles
  );

  return {
    // label: formatIdeaLabel(firstTag, "idealabel"),
    label: imageTitle,
    tag: firstTag.toLowerCase().replace(/\s+/g, "-"),
    img: ideaImg.webformatURL ||
      ideaImg.largeImageURL,
    imageData: ideaImg,
  };
});
  // push as 1 section after 4 images
  feed.push({ type: "SECTION", items: ideas, heading: index === displayIdeaFirstIndex ? "Ideas you might love" : "Popular to Explore", });

    }


  });

  return feed;
}

// const markLoaded = (uid) => {
//   setImageStates(prev => {
//     if (prev[uid]?.loaded) return prev;
//     return {
//       ...prev,
//       [uid]: { loaded: true }   // ❌ OVERWRITES previewLoaded
//     };
//   });
// };

const markFullLoaded = (uid) => {
   loadedImageUidsRef.current.add(uid);

  if (imageTimersRef.current[uid]) {
    clearTimeout(imageTimersRef.current[uid]);
    delete imageTimersRef.current[uid];
  }
  setImageStates(prev => {
    if (prev[uid]?.fullLoaded) return prev;
    return {
      ...prev,
      [uid]: {
        ...prev[uid],      // ✅ KEEP previewLoaded
        fullLoaded: true
      }
    };
  });
};

const markPreviewLoaded = (uid) => {
  setImageStates(prev => {
    if (prev[uid]?.previewLoaded) return prev;
    return {
      ...prev,
      [uid]: {
        ...prev[uid],
        previewLoaded: true
      }
    };
  });
};







const captionUIDs = useMemo(() => {
  const step = 3;   // gap (5,8,11 ≈ every 3 items)
  const offset = 4; // start from index 4 → (5th item visually)
    const max = 10;
  const start = 20

if(pageState > 3){
  const selectedImages = images.filter((img, index) => {
    const valid =
      !img._isUserSaved &&
      !img._isInterestImage &&
      img.likes >= 100;
      
        const positionMatch = (index - offset) % step === 0;
        return valid && positionMatch;    

  })
  return new Set(selectedImages.map(img => img._uid));
  }else{

      const selectedImages = images
    .filter(img => !img._isUserSaved && !img._isInterestImage && img.likes > 20) // control condition
    .slice(start, start + max);

  return new Set(selectedImages.map(img => img._uid));

  }
  

}, [images, pageState]);

  useEffect((event) => {
      // console.log("props.triggers", props)
    
      if (!props.triggerExploreStart) return;
    
      const firstImage = images?.[0];
      if (firstImage) {
        exploreSimilarImages(firstImage)
        handleImageClick(firstImage, firstImage._uid, false, true);
        console.log("top start image click")
      }
    }, [props.triggerExploreStart]);


// const memorizedImages= useMemo(()=>{

//   const interactionScore =
//     JSON.parse(localStorage.getItem("interactionScore") || "{}");

//   // const isReturning = Object.keys(interactionScore).length > 0;
//   const canPersonalize = Object.keys(interactionScore).length >= 3;

//     const preferredCategory =  Object.keys(interactionScore).sort((a, b) => interactionScore[b] - interactionScore[a])[0] ;


//   const feed = buildExploreFeed(images, {
//     isReturning: canPersonalize,
//     preferredCategory,
//     isMobile,
//   });



//   return feed.map((item, index) => {
//         // if (!imageStates[index]) return null; 
//         if (item.type === "IMAGE") {
          
//           const image = item.image;
          
          
//           // const index = item.index;
//           const showCaption = captionUIDs.has(image?._uid);
// const isShortExplore =  props.componentFrom === "exploreNext" &&  props.exploreNextType === "short";
// // const displayCaptionOverlay = !props.source && props?.userIntent?.intent !== "download"
// const displayCaptionOverlay = props?.userIntent?.intent === "mixed"
// const isBackgroundOverlay =
//   (props?.userIntent?.tagType === "background" ||
//    props?.userIntent?.tagType === "wallpaper") &&
//   !isMobile &&
//   props.componentFrom !== "home" &&
//   (index === 0 || index === 2); 

// const hasOverlay =   isBackgroundOverlay || (displayCaptionOverlay && (!isMobile && props.componentFrom !== "home" && (showCaption || index === 0 || index === 2)))


//           console.log("imageuuid", image,  image._uid)     
//         const location = window.location.href.split("/")
//         const imageTagText = location[location.length - 1]
        

//          let firstTag = image.tags.split(",")[0]?.trim().toLowerCase();
//   let secondTag = image.tags.split(",")[1]?.trim().toLowerCase();

//   // check if last URL segment matches the first tag
//   let useSecond = imageTagText === firstTag;

//   let targetTag = (useSecond ? secondTag : firstTag)?.replace(/\s+/g, "-");
    

          
//         return (
//           <>
//              {/* If no images loaded and not loading → fallback screen */}
//     {images.length === 0 && !loader && (
//       <div className="empty-explore-state d-flex flex-column align-items-center justify-content-center mt-5">
//         {/* <img src="/no-results.svg" width="140" alt="No images" />
//         <p className="mt-3 text-muted">No images found. Try scrolling again later 🌎</p> */}
//       </div>
//     )}


//           <div ref={(el)=> {
//             (blogColRef.current[index] = el)     
//   //            if (el && !imageStates[image._uid]?.previewLoaded) {
//   //   markPreviewLoaded(image._uid);
//   // }       
             
//              }} 
//             //  className={props.componentFrom === "home" ? 'column position-relative explore_image':'column position-relative explore_image'}
//              className={`column position-relative explore_image ${imageStates[image._uid]?.fullLoaded ? "image-loaded" : "image-loading"} 
//              ${hasOverlay ? 'no_border_hover' : ''}`}

//               key={image.id} 
//              style={{
// //     backgroundColor: image.imageColor,  // ✅ Correct location
// //     // width: image.webformatWidth,
// //       '--image-color': image.imageColor,
// //         backgroundImage: `url(${image.previewURL})`,  
// //     backgroundSize: "cover",
// //     backgroundPosition: "center",
// //     backgroundRepeat: "no-repeat",
// //     willChange: "transform",
// // transform: "translateZ(0)"
// //     // height: image.webformatHeight
 
//   }} 
//               onClick={(event)=> exploreSimilarImages(image)} 
//               // data-image-id={image.id}
//               data-image-id={props.componentFrom === "home" ? `${image.id}` : `${image.id}-${index}`}
//                tabIndex={0}
//                onKeyDown={(e) => {
    
//                 if (e.key === 'Enter' || e.key === ' ') {
//                   e.preventDefault();
//                   exploreSimilarImages(image);
//                 }
//               }}
// // uuid={image._uid}
//               >      
          
// <Link class="explore_image_link explorenext_image_link"
//  to={`/explore-next/${image.type}/${targetTag}`}
//    style={{
//     // backgroundColor: image.imageColor, 
//     // width: image.webformatWidth,
//       // '--image-color': image.imageColor,
//         backgroundImage: `url(${image.previewURL})`,  
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//     willChange: "transform",
// transform: "translateZ(0)"
//     // height: image.webformatHeight
//   }} 
// state={{ imageData: image }} 
//  onClick={(e) =>{
//  e.stopPropagation()
// //  storePosition(e, image)
//  handleImageClick(image, image._uid)
//   // const caption = GetCaptionForImages(image?._category);

//  }
//  } 


// >
//   <div className="image-wrapper" 
//   style={{
//       width: '100%',
//       aspectRatio: `${image.webformatWidth} / ${image.webformatHeight}`,
//       overflow: 'hidden',
//       position: 'relative',
//       // height: "100%",
//       height: `${(image.webformatHeight >= 450 && (props.componentFrom === "home" || props?.exploreNextType === "short"))? '250px' : '100%'}`,
//       // height: props.componentFrom === "home" && image.webformatHeight / image.webformatWidth > 1.5 ? "260px" : "100%"
//       // contentVisibility: "auto",
//       //   containIntrinsicSize: `${image.webformatHeight}px`,

//     }}
//   // uid={image._uid}
//   ref={(el) => setImageRef(el, image.id, image._uid, index, image)}
//   >

// {/* <img
//   src={image.previewURL}
//   style={{
//     position: "absolute",
//     inset: 0,
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     opacity: 0,
//     pointerEvents: "none"
//   }}
//   onLoad={() => markPreviewLoaded(image._uid)}
//   onError={() => markPreviewLoaded(image._uid)}
//   alt={generateCaption(image)}
// /> */}

     
     
     
     
//      {!imageStates[image._uid]?.previewLoaded  && <div className="skeleton" />}

//      {/* {!imageStates[image._uid]?.fullLoaded  && <div className="skeleton" />} */}


//   {/* {image._isUserSaved && <div className="saved-new-badge  position-absolute saved_badge">SAVED</div>} */}
  
//    {/* {image._isUserSaved && <div className="saved-new-badge  position-absolute saved_badge">SAVED</div>} 
//    {image._isInterestImage && <div className="saved-new-badge  position-absolute saved_badge" style={{backgroundColor: "green"}}>Interest {image._category}</div>}  */}


//             <img
//             // className="explore-image"
            
//             // className={`explore_page_image explore-image ${imageStates[image._uid]?.fullLoaded ? 'loaded' : ''}`}
//             className={`explore_page_image explore-image `}
//                  style={{
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//         display: 'block',
        
//   transition: "opacity 0.25s ease",
//   transitionDelay: `${image._delay || 0}ms`
//       }}
//       //            style={{
//       //   maxWidth: '100%',
//       //   maxHeight: '100%',
//       //   objectFit: 'contain',
//       //   display: 'block',
//       // }}

//         // fetchPriority={(props.displayFor === "forExplore" && index < 5) ? "high" : "auto"  }
//         // fetchPriority={(index < 6) ? "high" : "auto"  }
//         fetchPriority={pageState <= 2 && index < 6 ? "high" : "auto"}
        

//  onContextMenu={(e) => {
//   if (window.innerWidth < 576) {
//     e.preventDefault(); 

//   }
//     // openAppSharer(image); 
//     // removeClickFeed(e, image.webformatURL, "option", image.id);
//   }}
            
  
//     src={toImageKitURL(image.webformatURL, image.webformatWidth)}
//   srcSet={
//     `
//     ${toImageKitURL(image.previewURL, image.previewWidth)} ${image.previewWidth}w,
//     ${toImageKitURL(image.webformatURL, image.webformatWidth)} ${image.webformatWidth}w,
//     ${toImageKitURL(image.largeImageURL, image.imageWidth)} ${image.imageWidth}w
//   `
//   }
  
  
//   sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
//               // loading="lazy"     
//           loading={index < 3 ? "eager" : "lazy"}

// decoding="async"
                  
              
//               onClick={() => updateInteractionScore(image.tags, image._category, 2)}
//   //           width={blogColRef.current[index]?.offsetWidth}
//   // height={blogColRef.current[index]?.offsetHeight}

    
//         data-image-ids={image.id}

//     //   onLoad={(e) => {

  
//     //  console.log("onimage load",e.target.complete)
//     //     if (e.target.complete) {
//     //       setImageStates((prev) => {
//     //         const newState = [...prev];
//     //         newState[index] = { 
              
//     //           // loaded: true
//     //             ...(newState[index] || {}),
//     //     fullLoaded: true,
            
//     //          };
            
//     //         return newState;
//     //       });
//     //     }


//     //   }}

//     //  onLoad={() => markFullLoaded(image._uid)}
//       onLoad={(e) => {
//     markPreviewLoaded(image._uid);   
//     markFullLoaded(image._uid);
//     // ⭐ DOM-only update (NO REACT RERENDER)
//   e.currentTarget.classList.add("loaded")
//   }}

//   ref={(el) => {
//     if (el && el.complete && !imageStates[image._uid]?.fullLoaded) {
//     markFullLoaded(image._uid);
//   }
//   }}
//               onError={(e) =>{
//               const originalUrl = image.webformatURL;
//               e.target.src = originalUrl;
//               e.target.srcset = `
//                 ${image.previewURL} 150w,
//                 ${image.webformatURL} 640w,
//                 ${image.largeImageURL} 1280w
//               `;
//                       //  e.target.style.display = "none";
//                         }}
           
//                       alt={generateCaption(image)}
         
//             />




//    {(!hasOverlay) && (
//       <RenderImageBatches index={index} source={props?.source} exploreNextType={props.exploreNextType} />
//   )}

     
            

//             {(props.displayFor === "forSavedOthers") ? 
// <>

// <Link class="explore_image_link "
//  to={`/explore-next/${image.type}/${targetTag}`}  onContextMenu={false}

//  state={{ imageData: image }} 
//  onClick={(e) =>{
//  e.stopPropagation()
// //  storePosition(e, image)
//   updateInteractionScore(image.tags, image._category, 2)
//  }
//  } 
//  >
//     <div className="explore_like_content d-flex align-items-center position-absolute explore_images_share home_saved"         

//              onClick={(event) => {
//       // event.stopPropagation();
//       // event.preventDefault();
//       removeClickFeed(event, image, "", image.id, true);
    
//     }}
//     onMouseDown={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
//       sendClickFeed(event);
//     }}
//     onTouchStart={(event) => {
//       event?.preventDefault();
//       event?.stopPropagation();
//       sendClickFeed(event);
          
//     }}
//     onTouchEnd={(event) => {
//       // event.stopPropagation();
//       // event.preventDefault();
//       removeClickFeed(event, image, "", image.id , true);
//     }}
//     onMouseOut={orignalElement}
//     // ref={moreOptionsRef}
    

//           title="Click to see similar images"
//                 >
//             {/* <i class="fa-solid fa-arrow-up-right-from-square explore_image_share_icon  touch_none" title="Click to see similar images"></i> */}
            
//             <i class="fa-solid fa-magnifying-glass explore_image_share_icon  touch_none" ></i>

            
            
//             </div>  
//             </Link>
            

// </>
// : 

// <>
//   {(!hasOverlay) && (<>

//     <div className={(props.componentFrom === "home" && props.displayFor === "forExplore") ? `home_explore_icons explore_icons position-absolute explore_bottom_icon` : `explore_icons position-absolute explore_bottom_icon`} onClick={(e) => e.stopPropagation()}  >
//             <div className="explore_like_content d-flex align-items-center">
//               <i className="fa-solid fa-heart"></i>
//               <span className="explore_fonts mx-1">{image.likes + 750}</span>
//             </div>  

//             <div className="explore_like_content d-flex align-items-center">
//             <i class="fa-regular fa-eye"></i>
//               <span className="explore_fonts mx-1">{image.views}</span>
//             </div>   

//             <div className="explore_like_content d-flex align-items-center">
//             <i class="fa-solid fa-download"></i>
//               <span className="explore_fonts mx-1">{image.downloads}</span>
//             </div>                  
//             </div>

// <div className={`app_image_top_actions position-absolute image_share_menu_container image_topaction_element`} onClick={(e) => e.stopPropagation()}>

//  {/* {image._isUserSaved ? <div className=" saved_badge main_action_button">Saved</div> : <div className="saved_badge main_action_button">Save</div>}  */}

// {/* <div className="saved_badge main_action_button main_save_button"
//       onClick={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
//       handleSaveImage(image.id, image);
//     }}
//     onMouseDown={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
      
//       makeButtonSmall(event);
//     }}
//     onTouchStart={(event) => {
//       event.stopPropagation();
     
//       makeButtonSmall(event);
//     }}
//     onTouchEnd={(event) => {
//       event.stopPropagation();
    
//       makeButtonBig(event) 
      
//     }}
//     onMouseOut={(e)=> makeButtonOriginal(e)}

// >{saved  ? `Saved` : `Save`}</div> */}
// {/* {captionText} */}

// {/* {(props.componentFrom!== "home" && showCaption) ? (
//   <div className="caption_link_container saved_badge main_action_button main_save_button" 
//    onClick={(e) => {
//       e.stopPropagation();
//       e.preventDefault();

//       const caption = GetCaptionForImages(image?._category);

//       navigate("/tools", {
//         state: { captionText }
//       });
//     }}
//   >
//   <div className="caption-text" 
 
//     >
    
//     Get Caption 
//   </div>
//   <i className="fa-solid fa-angle-right"></i>

//   </div>
// ): */}
// {(props?.exploreNextType === "short" && index === 0) ? <span className="saved_badge main_action_button main_save_button">Popular 🔥</span> :
// <SaveButton
//   image={image}
//   handleSaveImage={handleSaveImage}
// />}
// {/* } */}


// {/* ${imageStates[image._uid]?.previewLoaded ? "image-loaded" : "image-loading"} */}
//            <div className={`image_right_action`}>
//              {/* <div className="explore_like_content d-flex align-items-center position-absolute explore_images_share adjust_right" */}
//             <div className="explore_like_content d-flex align-items-center"
          

//              onClick={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
//       removeClickFeed(event, image.webformatURL, "share", image.id);
//     }}
//     onMouseDown={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
//       sendClickFeed(event);
//     }}
//     onTouchStart={(event) => {
//       event.stopPropagation();
//       //event.preventDefault();
//       sendClickFeed(event);
//     }}
//     onTouchEnd={(event) => {
//       event.stopPropagation();
//      // event.preventDefault();
//       // removeClickFeed(event, image.webformatURL, "share", image.id);
//       removeClickFeedForShare(event) 
      
//     }}
//     onMouseOut={orignalElement}

          
//                 >
//             <i class="fa-solid fa-share explore_image_share_icon"></i>
            
//             </div>    


//           {/* <div className="explore_like_content d-flex align-items-center position-absolute explore_images_share"          */}
//           {/* <div className="explore_like_content d-flex align-items-center "         

//              onClick={(event) => {
//       // event.stopPropagation();
//       // event.preventDefault();
//       removeClickFeed(event, image, "option", image.id, false, index);
//     }}
//     onMouseDown={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
//       sendClickFeed(event);
//     }}
//     onTouchStart={(event) => {
//       // event?.preventDefault();
//       event?.stopPropagation();
//       sendClickFeed(event);
          
//     }}
//     onTouchEnd={(event) => {
//       event.stopPropagation();
//       // event.preventDefault();
//       // removeClickFeed(event, image, "option", image.id, false ,index);
//       removeClickFeedForShare(event)
//     }}
//     onMouseOut={orignalElement}
//     ref={moreOptionsRef}

          
//                 >
//             <i class="fa-solid fa-ellipsis explore_image_share_icon touch_none"></i>
            
//             </div>   */}
// {/* <i className={props.isImageSaved ? "fa-solid fa-bookmark" : "fa-regular fa-bookmark"}></i> */}

//   {/* <SaveIconOnImage
//   removeClickFeeded={removeClickFeed}
//   image={image}
//   imageId={image.id}
//   sendClickFeed={sendClickFeed}
//   orignalElement={orignalElement}
//   isImageSaved={isSaved}

//    /> */}
//            </div>
//   </div>   

//   </>
//   )}   

            
// </>
// }


// {(!hasOverlay) && (
//      <RenderImageBatches index={index} source={props?.source} exploreNextType={props.exploreNextType} />
//  )}
//      {( (props?.userIntent?.intent === "mixed") && (!isMobile && props.componentFrom !== "home" )) && (<>
//       <RenderImageOverlay showCaption={showCaption} index={index} image={image} 
//       imageCategory={props.displayImage || moodQuery} 
//       getStableCaption={getStableCaption} componentFrom={props.componentFrom} exploreNextType={props.exploreNextType} pageState={pageState} />
//      </>)}    

//    {((props?.userIntent?.tagType === "background" || props.userIntent?.tagType === "wallpaper") && (!isMobile && props.componentFrom !== "home" )) && (<>
//       <RenderImageOverlayForBackground index={index} image={image} imageFor={props.userIntent.tagType} exploreNextType={props.exploreNextType}
//       />
//      </>)}    
//       </div>
//       </Link>
//             {/* {!loaded && <div className="app_loader" />} */}

//             <div className="image_botton_action_conainer d-flex align-items-center ">


// <p className="explore_image_text explore-soft-text">{generateCaption(image)}</p>

//    <div className="explore_like_content d-flex align-items-center explore_more_option_icon"         

//              onClick={(event) => {
//       // event.stopPropagation();
//       // event.preventDefault();
//       removeClickFeed(event, image, "option", image.id, false, index);
//     }}
//     onMouseDown={(event) => {
//       event.stopPropagation();
//       event.preventDefault();
//       sendClickFeed(event);
//     }}
//     onTouchStart={(event) => {
//       // event?.preventDefault();
//       event?.stopPropagation();
//       sendClickFeed(event);
          
//     }}
//     onTouchEnd={(event) => {
//       event.stopPropagation();
//       // event.preventDefault();
//       // removeClickFeed(event, image, "option", image.id, false ,index);
//       removeClickFeedForShare(event)
//     }}
//     onMouseOut={orignalElement}
//     ref={moreOptionsRef}

          
//                 >
//             <i class="fa-solid fa-ellipsis explore_image_share_icon touch_none"></i>
            
//             </div>  


//             </div>




          
//           </div>
//           </>

//         );
//       }

//       // props.componentFrom !== "exploreNext" &&
// // if ((props.componentFrom !== "home" && props.exploreNextType !== "short") && (item.type === "SECTION" || item.type === "TEXT")) {
// //   const dismissKey = `${item.type}-${index}`;

  
// // const isClosing = closingTexts.has(dismissKey);

// //   return (
// //     <div
// //       key={dismissKey}
// //       // className="explore-soft-text"
// //       className={`explore-soft-text ${isClosing ? "closing" : ""}`}
// //       id={dismissKey}
// //     >
// //       <span className="brand_button_text ">{item.label}</span>
// //       {(!isMobile) &&
// //       <>
// //       <i
// //         className="fa-solid fa-xmark desktop_feedback explore_purposetext_close"
// //         onClick={() => dismissText(dismissKey)}
// //       ></i>

// //       </>
// //       }
// //     </div>
// //   );
// // }


   
//  return null;

//           {/* </Link> */}
//       })
// }, [images, imageStates]) 



//images
const showDownloadOnBottom = true;

function makeImageHeight(index, image){
  const imageRatio = image.webformatHeight / image.webformatWidth;

let dynamicHeight = "100%";

if (props.componentFrom === "home" || props?.exploreNextType === "short") {
  dynamicHeight = isMobile ? '100%' : "250px"

  
}else{
  // Tall cinematic cards
  if (index % 7 === 0) {
    dynamicHeight = "420px";
  }

  // Medium aesthetic cards
  else if (index % 5 === 0) {
    dynamicHeight = "320px";
  }

  // Small breathing cards
  else if (index % 3 === 0) {
    dynamicHeight = "240px";
  }

  // Natural aspect-ratio cards
  else if (imageRatio > 1.5) {
    dynamicHeight = "380px";
  }

  else {
    dynamicHeight = "100%";
  }
}
return dynamicHeight

}

// function makeImageHeight(index, image) {

//   const imageRatio =
//     image.webformatHeight /
//     image.webformatWidth;

//   // Stable home feed
//   if (((image.webformatHeight >= 450 || image.webformatHeight <= 170) && (props.componentFrom === "home" || props?.exploreNextType === "short"))) {
//     return "250px";
//   }

//   // Default natural masonry
//   let dynamicHeight = "100%";

//   // Rare featured portrait cards
//   if (
//     imageRatio > 1.45 &&
//     index % 11 === 0
//   ) {
//     dynamicHeight = "420px";
//   }

//   // Slightly taller cinematic cards
//   else if (
//     imageRatio > 1.25 &&
//     index % 7 === 0
//   ) {
//     dynamicHeight = "340px";
//   }

//   // Compact breathing cards
//   else if (
//     imageRatio < 0.85 &&
//     index % 5 === 0
//   ) {
//     dynamicHeight = "230px";
//   }

//   return dynamicHeight;
// }


const pexelsHeightCache = {};

function getRandomPexelsHeight() {

  // if (pexelsHeightCache[imageId]) {
  //   return pexelsHeightCache[imageId];
  // }

  const heights = [];

  for (let h = 350; h <= 480; h += 5) {
    heights.push(h);
  }

  const height =
    heights[Math.floor(Math.random() * heights.length)] + "px";

  // pexelsHeightCache[imageId] = height;

  return height;
}



function getTargetTag(image) {
  if (!image?.pageURL) return null;

  // return image.description;
  // return image.name;

  const parts = image.pageURL.split("/").filter(Boolean);
  const slug = parts[parts.length - 1];

  // Remove the trailing image ID
  return slug.replace(/-\d+$/, "");
}
function makewebformatImageUrl(image){

  console.log("previewURL for...", image.previewURL);

  return image?._source !== "pexels" ? image.previewURL.replace("_150.jpg", "_640.jpg") : image.previewURL

}

function makelargeImageUrl(image){

  return image?._source !== "pexels" ? image.previewURL.replace("_150.jpg", "_1280.jpg") : image.previewURL

}


const memorizedImages= useMemo(()=>{

  const interactionScore =
    JSON.parse(localStorage.getItem("interactionScore") || "{}");

  // const isReturning = Object.keys(interactionScore).length > 0;
  const canPersonalize = Object.keys(interactionScore).length >= 3;

    const preferredCategory =  Object.keys(interactionScore).sort((a, b) => interactionScore[b] - interactionScore[a])[0] ;


  const feed = buildExploreFeed(images, {
    isReturning: canPersonalize,
    preferredCategory,
    isMobile,
  });



  return feed.map((item, index) => {
        // if (!imageStates[index]) return null; 
        if (item.type === "IMAGE") {
          
          const image = item.image;
          
          if(!image.previewURL) return
       
          
          // const index = item.index;
          const showCaption = captionUIDs.has(image?._uid);

const isShortExplore =  props.componentFrom === "exploreNext" &&  props.exploreNextType === "short";
// const displayCaptionOverlay = !props.source && props?.userIntent?.intent !== "download"
const displayCaptionOverlay = props?.userIntent?.intent === "mixed"
const isBackgroundOverlay =(props?.userIntent?.tagType === "background" || props?.userIntent?.tagType === "wallpaper") && !isMobile &&  props.componentFrom !== "home" &&
  (index === 0 || index === 2); 

// to hide the caption over on explorenext for google user
// const hasOverlay =   Boolean(isBackgroundOverlay || (displayCaptionOverlay && (!props.source && !isMobile && props.componentFrom !== "home" && (showCaption || index === 0 || index === 2))))     
const hasOverlay =   false   

// to show the caption over on explorenext for google user
// const hasOverlay =   Boolean(isBackgroundOverlay || (displayCaptionOverlay && (!isMobile && props.componentFrom !== "home" && (showCaption || index === 0 || index === 2))))     


// const hasOverlay =   Boolean(isBackgroundOverlay || (displayCaptionOverlay && (!isMobile && props.componentFrom !== "home" && props?.exploreNextType !== "short"  && (showCaption))))     





          console.log("imageuuid", image,  image._uid)     
        const location = window.location.href.split("/")
        const imageTagText = location[location.length - 1]
        

         let firstTag = image.tags.split(",")[0]?.trim().toLowerCase();
  let secondTag = image.tags.split(",")[1]?.trim().toLowerCase();
  // const objectType = image.type || "photo"
  const objectType = image?.type && image.type !== "undefined" && image.type !== "undeifned" ? image.type : "photo";

  // check if last URL segment matches the first tag
  let useSecond = imageTagText === firstTag;

  // let targetTag = (useSecond ? secondTag : firstTag)?.replace(/\s+/g, "-");
  let targetTag = getTargetTag(image)

  if(image?._source === "pexels"){
    console.log("pexels image tags", image.tags)
    targetTag = extractImageCategory(image.tags, content)
    console.log("set target nevigate url", targetTag, content)
  }
 


  
    const label = getImageLabel(image, index);
const showImageBlur = showLongSectionImageBlur(index, shouldDisplayLabel(index, image))

const imageCreatorsBadge = imageStates[image._uid]?.previewLoaded  && shouldDisplayLabel(index, image)
  const username = image?.user;
  const avatar = image?.userImageURL;

  // const hasCreator = Boolean(username && avatar);
  const hasCreator = false
          
        return (
          <>
             {/* If no images loaded and not loading → fallback screen */}
    {images.length === 0 && !loader && (
      <div className="empty-explore-state d-flex flex-column align-items-center justify-content-center mt-5">
        {/* <img src="/no-results.svg" width="140" alt="No images" />
        <p className="mt-3 text-muted">No images found. Try scrolling again later 🌎</p> */}
      </div>
    )}


          <div ref={(el)=> {
            (blogColRef.current[index] = el)     
   

  
             
             }} 
            //  className={props.componentFrom === "home" ? 'column position-relative explore_image':'column position-relative explore_image'}
            // ${imageCreatorsBadge && showImageBlur ? 'no_border_hover' : ''}
             className={`column position-relative explore_image ${imageStates[image._uid]?.previewLoaded ? "image-loaded" : "image-loading"} 
             ${hasOverlay ? 'no_border_hover' : ''} `}
              data-id={image.id}
              key={image.id} 
             style={{
    // backgroundColor: image.imageColor,  // ✅ Correct location
//     // width: image.webformatWidth,
//       '--image-color': image.imageColor,
//         backgroundImage: `url(${image.previewURL})`,  
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//     willChange: "transform",
// transform: "translateZ(0)"
//     // height: image.webformatHeight

 backgroundColor: image?.imageColor,
   "--image-color": image?.imageColor
 
  }} 
             // onClick={(event)=> exploreSimilarImages(event, image)} 
              // data-image-id={image.id}
              data-image-id={props.componentFrom === "home" ? `${image.id}` : `${image.id}-${index}`}
              data-index={index}
               tabIndex={0}
              //  onKeyDown={(e) => {
    
              //   if (e.key === 'Enter' || e.key === ' ') {
              //     e.preventDefault();
              //     exploreSimilarImages(e, image);
              //   }
              // }}
// uuid={image._uid}


              >      
          
<Link class="explore_image_link explorenext_image_link"
 to={`/explore-next/${objectType}/${targetTag}`}
   style={{
    // backgroundColor: image.imageColor, 
    // width: image.webformatWidth,
      // '--image-color': image.imageColor,
        backgroundImage: `url(${image.previewURL})`,  
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    willChange: "transform",
transform: "translateZ(0)"
    // height: image.webformatHeight
  }} 
state={{ imageData: image }} 
 onClick={(e) =>{
//  e.stopPropagation()
//  storePosition(e, image)
 handleImageClick(image, image._uid, !hasOverlay && shouldDisplayLabel(index, image), false, targetTag, "explore_image_click", hasCreator, index)
  // const caption = GetCaptionForImages(image);

 }
 } 


>
  <div className={`image-wrapper `} 
  style={{
      width: '100%',
      aspectRatio: `${image.webformatWidth} / ${image.webformatHeight}`,
      
    //   aspectRatio: props?.exploreNextType === "short"
    // ? `${image.webformatWidth} / ${image.webformatHeight}`
    // : image?._layoutType === "portrait"
    //   ? "4 / 5"
    //   : "4 / 3",
      overflow: 'hidden',
      position: 'relative',
      // height: `${((image.webformatHeight >= 450 || image.webformatHeight <= 170) && (props.componentFrom === "home" || props?.exploreNextType === "short"))? '250px' : `100%` }`,

      // height: `${isMobile ? makeImageHeight(index, image) : `${((image.webformatHeight >= 450 || image.webformatHeight <= 170) && (props.componentFrom === "home" || props?.exploreNextType === "short"))? '250px' : `100%`}`}`,
      
//       height: `${
//     (props.exploreNextType !== "short" && image?._source === "pexels")
//     ? (
//         image.webformatHeight >= 450
//           ? (isMobile ? "320px" : image?.imageNewHeight || "480px")
//           : "100%"
//       )
//     : (
//         (
//           image.webformatHeight >= 450 ||
//           image.webformatHeight <= 170
//         ) &&
//         (
//           props.componentFrom === "home" ||
//           props?.exploreNextType === "short"
//         )
//       )
//         ? "250px"
//         : "100%"
// }`

height: `${

  props?.render_right ? `${props?.render_height || 300}px` :
  props?.exploreNextType === "short" && isMobile
    ? "250px"  : props?.componentFrom === "home" && isMobile
      ? "auto"
      :   (
        props.exploreNextType !== "short" && image?._source === "pexels"
      )
        ? (
            image.webformatHeight >= 450
              ? (isMobile ? "320px" : image?.imageNewHeight || "480px")
              : "100%"
          )
        : (
            // (
            //   image.webformatHeight >= 450 ||
            //   image.webformatHeight <= 170
            // ) &&
            (
              (props.componentFrom === "home" && !isMobile) ||
              props?.exploreNextType === "short"
            )
          )
            ? isMobile ? "250px" : "250px"
            : "100%"
}`

 

    }}
  // uid={image._uid}

   ref={(el) =>{
     setImageRef(el, image.id, image._uid, index, image)
        if (el) {
          displaySeeMoreImageRef.current[image._uid] = el;
        }

     }}
      
     onMouseEnter={() => {
  console.log("mouse enter", image._uid);
  if(isMobile) return

  clearTimeout(hoverTimerRef.current[image._uid]);

  hoverTimerRef.current[image._uid] = setTimeout(() => {
    displaySeeMore(image._uid, image);
  }, 1000);
}}

onMouseLeave={() => {
  console.log("mouse leave", image._uid);

  clearTimeout(hoverTimerRef.current[image._uid]);

  hideSeeMore(image._uid);
}}

  >

{/* <img
  src={image.previewURL}
  style={{
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: 0,
    pointerEvents: "none"
  }}
  onLoad={() => markPreviewLoaded(image._uid)}
  onError={() => markPreviewLoaded(image._uid)}
  alt={generateCaption(image)}
/> */}

     
     
     
     
     {!imageStates[image._uid]?.previewLoaded  && <div className="skeleton" />}

     {/* {!imageStates[image._uid]?.fullLoaded  && <div className="skeleton" />} */}

 

      {/* {(props?.exploreNextType === "long" && image?._source === "pexels" && index > 5) && <div className="saved-new-badge  position-absolute saved_badge featured_pexels">✦ Featured</div>}   */}
     
    {props?.exploreNextType === "short" && index === 7 && <div className="saved-new-badge  position-absolute saved_badge new_updatedbadge">Popular Today</div>}
   
  

  <div
    className="see-more-like-this caption_link_container saved_badge main_action_button main_save_button get_caption_inside_image emoji_button link_three_dot"
      ref={(el) => {
    if (el) {
      seeMoreRef.current[image._uid] = el;
    }
  }}
   style={{ display: "none", alignItems: "center", border: "1px solid white", borderRadius: "30px", transform: "scale(0.9)" }}
   
  >
     {/* See more {imageTopicName} <i className="fa-solid fa-angle-right"></i> */}
    {/* Create Post <i className="fa-solid fa-angle-right"></i> */}
    {/* Add Emoji 🤩  <i className="fa-solid fa-angle-right"></i> */}
    {/* <i class="fa-solid fa-palette"></i> Color Palette <i className="fa-solid fa-angle-right"></i> */}
    {/* <i class="fa-solid fa-folder"></i> Open Collection <i className="fa-solid fa-angle-right"></i> */}

    {/* View collection for {targetTag} <i className="fa-solid fa-angle-right"></i>  */}

    {/* More similar for this image <i className="fa-solid fa-angle-right"></i> */}
    {/* Click to see what's new <i className="fa-solid fa-angle-right"></i> */}
      {/* Use this Image <i className="fa-solid fa-angle-right"></i> */}
   {/*   Get this Image <i className="fa-solid fa-angle-right"></i> */}
      {/* Find more like this <i className="fa-solid fa-angle-right"></i> */}
      {/* Find related images <i className="fa-solid fa-angle-right"></i> */}

   {/* Edit this image <i className="fa-solid fa-angle-right"></i>*/}

      {/* Open photo · Find a caption <i className="fa-solid fa-angle-right"></i> */}
      Open image to get caption <i className="fa-solid fa-angle-right"></i>
  </div>

{/* {image._source === "ranking" && <div className="saved-new-badge  position-absolute saved_badge">Ranking</div>}  */}
  
   {/* {image._isUserSaved && <div className="saved-new-badge  position-absolute saved_badge">SAVED</div>} 
   {image._isInterestImage && <div className="saved-new-badge  position-absolute saved_badge" style={{backgroundColor: "green"}}>Interest {image._category}</div>}  */}


            <img
            // className="explore-image"
            
            
            // className={`explore_page_image explore-image ${imageStates[image._uid]?.fullLoaded ? 'loaded' : ''} ${(!isMobile && props?.exploreNextType !== "short" && showImageBlur) ? 'set_blur' : ""}`}
            className={`explore_page_image explore-image ${imageStates[image._uid]?.fullLoaded ? 'loaded' : ''}`}

                 style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        
        
  transition: "opacity 0.25s ease",
  transitionDelay: `${image._delay || 0}ms`,
  // filter: `${props?.source && props?.exploreNextType === "short" && props.index === 0 ? 'none' : 'blur(1px'}`
  
      }}
      //            style={{
      //   maxWidth: '100%',
      //   maxHeight: '100%',
      //   objectFit: 'contain',
      //   display: 'block',
      // }}

        // fetchPriority={(props.displayFor === "forExplore" && index < 5) ? "high" : "auto"  }
        // fetchPriority={(index < 6) ? "high" : "auto"  }
        fetchPriority={pageState <= 2 && index < 6 ? "high" : "auto"}
        

 onContextMenu={(e) => {
  if (window.innerWidth < 576) {
    e.preventDefault(); 

  }
  trackEvent("image_right_click", {
        imageId: image.id,
        viewed3SImageUrl: image.previewURL
    })
    // openAppSharer(image); 
    // removeClickFeed(e, image.webformatURL, "option", image.id);
  }}
            
  
    //  src={toImageKitURL(image.webformatURL, image.webformatWidth)}
    src={toImageKitURL(image.previewURL, image.previewWidth)}
    

  srcSet={
    
    `
    ${toImageKitURL(image.previewURL, image.previewWidth)} ${image.previewWidth}w,
    ${toImageKitURL(makewebformatImageUrl(image), image.webformatWidth)} ${image.webformatWidth}w,
    ${toImageKitURL(makelargeImageUrl(image), image.imageWidth)} ${image.imageWidth}w
  `
  }
  
  
  sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
              // loading="lazy"     
          loading={index < 3 ? "eager" : "lazy"}

decoding="async"
                  
              
              onClick={() => updateInteractionScore(image.tags, image._category, 2)}
  //           width={blogColRef.current[index]?.offsetWidth}
  // height={blogColRef.current[index]?.offsetHeight}

    
        data-image-ids={image.id}

    //   onLoad={(e) => {

  
    //  console.log("onimage load",e.target.complete)
    //     if (e.target.complete) {
    //       setImageStates((prev) => {
    //         const newState = [...prev];
    //         newState[index] = { 
              
    //           // loaded: true
    //             ...(newState[index] || {}),
    //     fullLoaded: true,
            
    //          };
            
    //         return newState;
    //       });
    //     }


    //   }}

    //  onLoad={() => markFullLoaded(image._uid)}
      onLoad={(e) => {

    markPreviewLoaded(image._uid);   
    markFullLoaded(image._uid);
    // ⭐ DOM-only update (NO REACT RERENDER)

    if (imageTimersRef.current[image._uid]) {
  clearTimeout(imageTimersRef.current[image._uid]);
}
  e.currentTarget.classList.add("loaded")
  }}

  ref={(el) => {
    if (el && el.complete && !imageStates[image._uid]?.fullLoaded) {
    markFullLoaded(image._uid);
  }
  }}
              onError={(e) =>{
                if(image?._source === "pexels")  return
                
             const originalUrl = image?.previewURL;
             e.target.src = originalUrl;

// -------------------------------------------------------------------------------------------
            //  const originalUrl = image.previewURL.replace("_150.", "_640.");
            // const img = e.currentTarget;

            //   e.target.src = originalUrl;
            //   if (img.dataset.fallbackApplied) return;

            //   img.dataset.fallbackApplied = "true";  
            // e?.target?.removeAttribute("srcset");
            // e?.target?.removeAttribute("sizes");

//----------------------------------------------------------------------------------------------

// const img = e.currentTarget;

//   if (img.dataset.fallbackApplied) return;

//   img.dataset.fallbackApplied = "true";
//   img.removeAttribute("srcset");
//   img.removeAttribute("sizes");
//   img.src = originalUrl;


    
  

// if (imageTimersRef.current[image._uid]) {
//    clearTimeout(imageTimersRef.current[image._uid]);
   
//     }
  

            
           


                    
                        }}
           
                      alt={generateCaption(image)}
         
            />






     
      </div>
       
 {( props.exploreNextType !== "short" && !hasOverlay && imageStates[image._uid]?.previewLoaded) && (
     <RenderImageBatches index={index} imageTopic={targetTag} source={props?.source} exploreNextType={props.exploreNextType} />
 )}
 {/* pageState >= 12 &&  */}
 {(props.exploreNextType !== "short" && imageStates[image._uid]?.previewLoaded && !hasOverlay && shouldDisplayLabel(index, image)) && (
     <CreatorsBadge imageBlur={showImageBlur} creatorsText = {label} />
 )}
 {/* !props?.source &&  */}
 
     {/* {( (!props?.source && props.exploreNextType !== "short" && props?.userIntent?.intent === "mixed") && (!isMobile && props.componentFrom !== "home" )) && (<>
      <RenderImageOverlay showCaption={showCaption} index={index} image={image} 
      imageCategory={props.displayImage || moodQuery} 
      getStableCaption={getStableCaption} componentFrom={props.componentFrom} exploreNextType={props.exploreNextType} pageState={pageState} />
     </>)}     */}

   {((props?.userIntent?.tagType === "background" || props.userIntent?.tagType === "wallpaper") && (!isMobile && props.componentFrom !== "home" )) && (<>
      <RenderImageOverlayForBackground index={index} image={image} imageFor={props.userIntent.tagType} exploreNextType={props.exploreNextType}
      />
     </>)}    

      </Link>
            {/* {!loaded && <div className="app_loader" />} */}



{(props.displayFor === "forSavedOthers" || (props?.exploreNextType === "short" && index === 5)) ? 
<>

<Link class="explore_image_link "
 to={`/explore-next/${objectType}/${targetTag}`}  onContextMenu={false}

 state={{ imageData: image }} 
 onClick={(e) =>{
//  e.stopPropagation()
//  storePosition(e, image)
  updateInteractionScore(image.tags, image._category, 2)
 }
 } 
 >
    <div className="explore_like_content d-flex align-items-center position-absolute explore_images_share home_saved"         

             onClick={(event) => {
      // event.stopPropagation();
      // event.preventDefault();
        handleImageClick(image, image._uid, !hasOverlay && shouldDisplayLabel(index, image), false, targetTag)
      removeClickFeed(event, image, "", image.id, true);
    
    }}
    onMouseDown={(event) => {
      event.stopPropagation();
      event.preventDefault();
      sendClickFeed(event);
    }}
    onTouchStart={(event) => {
      event?.preventDefault();
      event?.stopPropagation();
      sendClickFeed(event);
          
    }}
    onTouchEnd={(event) => {
      // event.stopPropagation();
      // event.preventDefault();
      removeClickFeed(event, image, "", image.id , true);
    }}
    onMouseOut={orignalElement}
    // ref={moreOptionsRef}
    

          title="Click to see similar images"
                >
            {/* <i class="fa-solid fa-arrow-up-right-from-square explore_image_share_icon  touch_none" title="Click to see similar images"></i> */}
            
            <i class="fa-solid fa-magnifying-glass explore_image_share_icon  touch_none" ></i>

            
            
            </div>  
            </Link>
            

</>
: 

<>
{/* ${props.exploreNextType === "short" ? `explorenext_google_user` : ''} */}
   {(!hasOverlay) && (
   
    <>
    {/* ${props?.source && 'show_download_only'} */}
     <div className={(props.componentFrom === "home" && props.displayFor === "forExplore") ? `home_explore_icons explore_icons position-absolute ` : `explore_icons position-absolute 
     ${hasCreator ? `justify-content-start hascreator_photo` : `justify-content-around`}
     `} 
    //  onClick={(e) =>{ 
      
    //     e.stopPropagation()
      
    // }} 
    
    >
         
         {/* {!props?.source ? (<> */}

<ShowLikes image={image} />
          
         {/* </>) : (<> */}


     {/* <div className="explore_like_content d-flex align-items-center explore_download_button">
            <i class="fa-solid fa-download"></i>    
            

            </div>          

         </>)} */}


          {/* <button className={`mt-2 image_overlay_tap_button related_interest_image_title download_status_image_button three_dot  update_cta`}>
       
  Get Ready Post with Hashtags <i className="fa-solid fa-angle-right"></i>  


        </button> */}
            
              


            </div>
    </>
   )}
{/* {(!imageCreatorsBadge || (!hasOverlay && !showImageBlur)) && ( */}
{(!hasOverlay) && (
<>
<div className={`app_image_top_actions position-absolute image_share_menu_container image_topaction_element`} onClick={(e) => e.stopPropagation()}>

 {/* {image._isUserSaved ? <div className=" saved_badge main_action_button">Saved</div> : <div className="saved_badge main_action_button">Save</div>}  */}

{/* <div className="saved_badge main_action_button main_save_button"
      onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
      handleSaveImage(image.id, image);
    }}
    onMouseDown={(event) => {
      event.stopPropagation();
      event.preventDefault();
      
      makeButtonSmall(event);
    }}
    onTouchStart={(event) => {
      event.stopPropagation();
     
      makeButtonSmall(event);
    }}
    onTouchEnd={(event) => {
      event.stopPropagation();
    
      makeButtonBig(event) 
      
    }}
    onMouseOut={(e)=> makeButtonOriginal(e)}

>{saved  ? `Saved` : `Save`}</div> */}
{/* {captionText} */}

 {/* {(props.componentFrom!== "home"  && showCaption) && (
  <div className="caption_link_container saved_badge main_action_button main_save_button" 
   onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();

      const caption = GetCaptionForImages(image);

      navigate("/tools", {
        state: { captionText }
      });
    }}
  >
  <div className="caption-text" 
 
    >
    
    
    {captionText}
  </div>
  <i className="fa-solid fa-angle-right"></i>

  </div>
)} */}
{/* {(props?.exploreNextType === "short" && index === 0) ? <span className="saved_badge main_action_button main_save_button"

 onClick={(e) => {
      e.stopPropagation(); // stop Link click

                  // exploreSimilarImages(e, image);

   navigate(`/explore-next/${image.type}/${targetTag}`, {
        state: { imageData: image }
      });

      handleImageClick(image, image._uid)

      updateInteractionScore(image.tags, image._category, 2)
     
    }}


>Copy caption 🔥</span> : */}
{/* } */}



{/* {isMobile ? (*/}

<SaveButton
  image={image}
  handleSaveImage={handleSaveImage}
  downloadImageFromButton={downloadImageFromButton}
  isMobile={isMobile}
/>

{/* ) : (<>

 <div className="saved_badge main_action_button main_save_button image_text_content ">

{showPostReady(image) ?  `${formatTargetTag} Treding Post for SM` : (
  <>
  
  {formatTargetTag}

   </>)}


</div>


</>)} */}


{/* ${imageStates[image._uid]?.previewLoaded ? "image-loaded" : "image-loading"} */}
           <div className={`image_right_action`}>
             
          


          
       

{/* {isMobile ?( */}
  <>

  <div className="explore_like_content d-flex align-items-center"
          

             onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
      removeClickFeed(event, image.previewURL, "share", image.id);
      // downloadImageFromButton(image);
    }}
    onMouseDown={(event) => {
      event.stopPropagation();
      event.preventDefault();
      sendClickFeed(event);
    }}
    onTouchStart={(event) => {
      // event.stopPropagation();
        touchMovedRef.current = false;
      //event.preventDefault();
      sendClickFeed(event);
    }}
    onTouchMove={() => {

  touchMovedRef.current = true;

}}
    onTouchEnd={(event) => {
      // event.stopPropagation();
     // event.preventDefault();
      // removeClickFeed(event, image.webformatURL, "share", image.id);
       if (touchMovedRef.current) {

    removeClickFeedForShare(event);

    return;
  }
      removeClickFeedForShare(event) 
      
    }}
    onMouseOut={orignalElement}
title={"Share"}
// title={"Download"}
          
                >
            <i class="fa-solid fa-share explore_image_share_icon"></i>
            {/* <i class="fa-solid fa-download explore_image_share_icon"></i> */}
            
            </div>    


   <div className="explore_like_content d-flex align-items-center "         

             onClick={(event) => {
      // event.stopPropagation();
      // event.preventDefault();
      removeClickFeed(event, image, "option", image.id, false, index);
    }}
    onMouseDown={(event) => {
      event.stopPropagation();
      event.preventDefault();
      sendClickFeed(event);
    }}
    onTouchStart={(event) => {
      // event?.preventDefault();
      // event?.stopPropagation();
         touchMovedRef.current = false;
      sendClickFeed(event);
          
    }}
        onTouchMove={() => {

  touchMovedRef.current = true;

}}
    onTouchEnd={(event) => {
      // event.stopPropagation();
      // event.preventDefault();
      // removeClickFeed(event, image, "option", image.id, false ,index);
           if (touchMovedRef.current) {

    removeClickFeedForShare(event);

    return;
  }
      removeClickFeedForShare(event)
    }}
    onMouseOut={orignalElement}
    ref={moreOptionsRef}
title={"More options"}
          
                >
            <i class="fa-solid fa-ellipsis explore_image_share_icon touch_none"></i>
            
            </div>  

</>
{/* ) : (<>

            <SaveButton
  image={image}
  handleSaveImage={handleSaveImage}
/>






</>)} */}



           </div>
  </div>    
</>

)}
  

            
</>
}

          
          </div>
          </>

        );
      }

      // props.componentFrom !== "exploreNext" &&
if ((props.componentFrom !== "home" && props.exploreNextType !== "short") && (item.type === "TEXT")) {
  const dismissKey = `${item.type}-${index}`;

  
const isClosing = closingTexts.has(dismissKey);

  return (
    <div
      key={dismissKey}
      // className="explore-soft-text"
      className={`explore-soft-text ${isClosing ? "closing" : ""}`}
      id={dismissKey}
    >
      <span className="brand_button_text increase_font_weight">{item.label}</span>
      {(!isMobile) &&
      <>
      <i
        className="fa-solid fa-xmark desktop_feedback explore_purposetext_close"
        onClick={() => dismissText(dismissKey)}
      ></i>

      </>
      }
    </div>
  );
}

if (item.type === "POST_CARD") {
  const postImage = item.image;
  

  if (!postImage?.previewURL) {
    return null;
  }
   const objectType =
    postImage?.type &&
    postImage.type !== "undefined" &&
    postImage.type !== "undeifned"
      ? postImage.type
      : "photo";

  const targetTag = getTargetTag(postImage);

return(<PostCard 
  // postImage={postImage} 
  // index = {index}
  // toImageKitURL={toImageKitURL}
  // item={item}

      key={`post-card-${index}`}
      postImage={postImage}
      index={index}
      imageStates={imageStates}
      markPreviewLoaded={markPreviewLoaded}
      toImageKitURL={toImageKitURL}
          makewebformatImageUrl={makewebformatImageUrl}
      makelargeImageUrl={makelargeImageUrl}
      item={item}
          objectType={objectType}
      targetTag={targetTag}
      handleImageClick={handleImageClick}
      componentFrom={props.componentFrom}
      displayFor={props.displayFor}
      displayCategory={props.forcedCategory}

/>)
}
if(item.type === "SECTION"){
  
  const validItems = item.items.filter(
  (idea) => idea.img && idea.img !== "(not set)"
);

if (!validItems.length) {
  return null;
}
console.log("SECTIONMAIN", item);

   return(
    <div className="column position-relative ideas-wrapper">
    {/*   <span className="ideas-heading">Ideas you might love</span> */}
      {/* <span className="ideas-heading">People Clicked These Next</span> */}
      <span className="ideas-heading">  {item.heading}</span>

      <div className="ideas-list">
        {item.items.map((idea, i) => (
          <Link 
            key={i} 
            to={`/explore-next/photo/${idea.tag}`} 
            className="idea-card-item"
             onClick={(e) =>{
//  e.stopPropagation()
//  storePosition(e, image)
 handleImageClick(idea, idea._uid, false, false, idea.img, "idea_image")
  // const caption = GetCaptionForImages(image);

 }
 } 
          >
            {/* <img src={idea.img} alt={idea.label} /> */}
            <img
  src={idea.img}
  alt={idea.label}
  onLoad={() => console.log("ideas images 1 ✅ Loaded", idea.img)}
  onError={(e) => {
    console.log("ideas images 2  ❌ Failed", idea.img);
    console.log("ideas images 3 ",idea);
  }}
/>
            <div className="idea-dark-overlay"></div>
            <div className="idea-text-center">{idea.label}</div>
          </Link>
        ))}
      </div>
    </div>
  )

}


   
 return null;

          {/* </Link> */}
      })
}, [images, imageStates]) 

useEffect(() => {
  const ogImageTags = document.querySelectorAll('meta[property="og:image"], meta[property="og:description"], meta[name="description"]');
  ogImageTags.forEach(tag => tag.remove());
}, []);


  if (!bottomLoader && loader === true) {
    return (
      <>
      
        {/* <Loader></Loader> */}

{/* <ScrollTag  tagList={content} showBlog={getImages} /> */}
{(props.componentFrom !== "exploreNext") &&
<>
           {/* <div className="container mt-ps90 app_container"> */}

{/* <ScrollTag whereFrom="explore"  tagList={content} showBlog={getImages} /> */}
        {/* </div> */}
        </>
}

{(props.componentFrom === "home") ? <SkeltonLoading itemsPerColumn= {3} loadingFor="home"  /> : <SkeltonLoading  itemsPerColumn={6} />}
        
      </>
    );
  } else {
    return (
      <>

        {
      (props.componentFrom !== "home" && props.componentFrom !== "exploreNext" ) && 
  <Helmet>
  {/* <title>Explore Images for {moodQuery} | BrowseNext</title> */}
  <title>Explore {moodQuery} Images | BrowseNext</title>

  <meta
    name="description"
    content="Browse high-resolution images updated hourly in categories like fashion, tech, couples, nature, fitness, romantic, food, and more — all free to use on BrowseNext."
  />
  <meta name="robots" content="index, follow" />
  <meta
    name="keywords"
    content="Free stock images, trending images, hourly updated photos, romantic pictures, nature wallpapers, fashion gallery, tech stock images, couples, lifestyle, hugs, aesthetic images"
  />
  <meta property="og:title" content={`Explore Trending ${moodQuery} Images | BrowseNext`} />
  <meta
    property="og:description"
    content="Explore fresh, high-quality images updated every hour across popular categories. Discover, save, share, and get inspired with visuals curated on BrowseNext."
  />
  <meta
    property="og:image"
    content={ shareData.imageUrl ||  images[0]?.webformatURL || "https://www.browsenext.today/favicons.png"}
  />
  <meta property="og:url" content="https://www.browsenext.today/explore" />
  <meta name="twitter:card" content="summary_large_image" />
  <link rel="canonical" href="https://www.browsenext.today/explore" />

   <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          "name": moodQuery,
          "description": "Browse high-resolution images updated hourly in categories like fashion, tech, couples, nature, fitness, romantic, food, and more — all free to use.",
          "url": `https://www.browsenext.today/explore`,
          "image": ["https://www.browsenext.today/favicons.png"],
        })}
      </script>


  <link rel="preload" as="image" href={images[0]?.webformatURL} />
  <link rel="preload" as="image" href={images[1]?.webformatURL} />
  <link rel="preload" as="image" href={images[2]?.webformatURL} />
  <link rel="preload" as="image" href={images[3]?.webformatURL} />
</Helmet>


    
  }
        {props.componentFrom !== "home" &&
        <>
            {/* <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "left",
            marginBottom: "20px",
            marginTop: "90px",
            maxWidth: "89%",
            gap: "10px 0px",
            padding: "0px 20px",
          }}
          className="container app_product_headline"
        >
          <AppPagesHeading heading={"Explore Image for " +  document.title.split(' ')[3]}  />
          <div>
          <span className="image_suggestion_text">Next every hours Upcoming images </span>
     
          <div class="upcomming_images">
            <span className="app_product_headline_text">Music</span>
            <span className="app_product_headline_text">Music</span>
            <span className="app_product_headline_text">Music</span>
            <span className="app_product_headline_text">Music</span>
          </div>
          </div>
          
        </div> */}

{/* {(props.componentFrom !== "exploreNext") &&
        <div className="container mt-ps90 app_container">

<ScrollTag  whereFrom="explore" tagList={content} showBlog={getImages} />
        </div>
} */}

        </>
    }
  {/* <div className="hero seo-text">
    <h1>Explore {moodQuery} Images✨</h1>
    <p>Download HD {moodQuery} images for Instagram, Facebook, WhatsApp status, Twitter, LinkedIn, and more — free, fast, and ready to use.</p>
  </div> */}
 

  {/* <div className="app_container"> */}



 <Masonry  
 breakpointCols={breakpointColumnsObj}
//   className="my-masonry-grid"
  //  className={`${props.componentFrom === "home" ? 'container p-0 pinterest-layout mt-4 my-masonry-grid masnary_home' : 'container my-masonry-grid explore_mainexplore'} ${props.componentFrom === "exploreNext" ? 'pt-ps90 ' : 'pt-ps90 '}`} 
   className={`${props.componentFrom === "home" ? 'container p-0 pinterest-layout mt-2 my-masonry-grid masnary_home' : 'container my-masonry-grid explore_mainexplore max-width-full'}  ${props.exploreNextType === "short" || props.exploreNextType === "long" || props.componentFrom === "exploreNext" ? 'p-0 max-width-full' : ''}` } 
  columnClassName="my-masonry-grid_column"
 >
 
 
    {memorizedImages}
    {/* {props.componentFrom === "home" ? <ExploreLinkButton /> : null} */}
    </Masonry>

     
     
    
    {/* </div> */}
    <div ref={bottomObserverRef} style={{ height: '1px' }} />
    {(bottomLoader && props.componentFrom !== "home") && 
    (
    <div class="bottom_loader optimise_loader container">
       <div className="app_loader explore_bottom_loader" />
       {/* <SkeltonLoading count={5}/> */}
       {/* <span className="explore_bottom_loader_text">Loading more images...</span> */}
    </div>)

    }

    <AppShareer componentFrom="explore" loadingImages={loader} isImageSaved={isSaved}  onSave={() =>{ 
      console.log("before saved onClick", lastOpenedImageId, clickedImageObj)
      handleSaveImage(lastOpenedImageId, clickedImageObj)
      }} 
    onHide={()=> handleHideImage(lastOpenedImageId)}
    isHide={isHideImage}
    onDownload={(e)=>{downloadedImage(lastOpenedImageId, clickedImageObj)}}
    isDownloaded={isdownloadedImage}
    onSuggested={()=> onSuggested(lastOpenedImageId, clickedImageObj)}
    isSuggested={isSuggested}
    onDislike={()=> onDislike(lastOpenedImageId, clickedImageObj)}
    isDislike={isDislikeImage}
    isMobile

    />
    {/* <Alert position="bottom-center"> </Alert> */}
    <ShareOnDesktop imageUrl={shareData.imageUrl} title={`Take a look for  ${shareData.title} on BrowseNext`} imageName={shareData.title} shareType="images"  />
     {showReturnToast && (
  <ExploreReturnToast text='Your explored images are waiting on Home.' setShowReturnToast={setShowReturnToast} />
)}
{/* && Number(pageState) > 4 */}
{/* {((exploreRoute || exploreNextRoute) && Number(pageState) >= 2) && <ExploreIntent componentFrom="explore" />} */}

    {/* setWeeklyModelOpen */}
    {/* {weeklyModelOpen && ( */}
      {/* <>
      <WeeklyForms
    title="Get Weekly Image collection"
    setWeeklyModelOpen={setWeeklyModelOpen}
    
    displayFor="emailPopup"
    
    buttonText={"Submit"}
    
    loadingFes={setLoadingGuides}
    isLoadingGuidesws={isLoadingGuides}

  />
      </> */}
    {/* )} */}
      
    
      </>
    );
  }
};

export default ExploreMasonry;


function SaveIconOnImage (props) {

  return(
    <>
       {/* <div className="explore_like_content d-flex align-items-center position-absolute explore_images_share"          */}
       <div className="explore_like_content d-flex align-items-center "         

             onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
       props.removeClickFeeded(event, props.image, "save", props.imageId);

    }}
    onMouseDown={(event) => {
      event.stopPropagation();
      event.preventDefault();
      props.sendClickFeed(event);
    }}
    onTouchStart={(event) => {
      event?.preventDefault();
      event?.stopPropagation();
      props.sendClickFeed(event);
          
    }}
    onTouchEnd={(event) => {
      event.stopPropagation();
      event.preventDefault();
      props.removeClickFeeded(event, props.image, "save", props.imageId);
    }}
    onMouseOut={props.orignalElement}
    // ref={moreOptionsRef}

          
                >
            {/* <i class="fa-solid fa-ellipsis explore_image_share_icon touch_none"></i> */}

            <i className={props.isImageSaved ? "fa-solid fa-bookmark image_save_icon explore_image_share_icon" : "fa-regular fa-bookmark explore_image_share_icon image_save_icon"}></i>
            
            </div>  
    </>
  )
  
}




export function ExploreReturnToast(props) {
  // const toastRef = useRef();
  const hideToast = () => {
    // setTimeout(() => {
    //   const el = toastRef.current;
    //   if (el) {
    //     el.remove(); // same behaviour as your AppStatusElement
    //     sessionStorage.setItem("hideExploreReturnToast", "true");
    //   }
    // }, 2000);
    props.setShowReturnToast(false);

  // if user manually closes, remember it forever
  localStorage.setItem("hideExploreReturnToast", "true");
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center my-3 explore-soft-text app_status_item explore_toast_message"
      // ref={toastRef}
    >
      <span className="brand_button_text">
        {props.text}
      </span>

      <i
        className="fa-solid fa-xmark explore_purposetext_close home_status_close_button"
        onClick={hideToast}
      ></i>
    </div>
  );
}


// function ShowLikes(props){

//   return(
//     <>
//     <div className="explore_like_content d-flex align-items-center">
//               <i className="fa-solid fa-heart"></i>
//               <span className="explore_fonts mx-1">{formatLikeCount(props.image.likes + 700)}</span>
//             </div>  

//             <div className="explore_like_content d-flex align-items-center">
//             <i class="fa-regular fa-eye"></i>
//               <span className="explore_fonts mx-1">{formatLikeCount(props.image.views)}</span>
//             </div>   

//             <div className="explore_like_content d-flex align-items-center">
//             <i class="fa-solid fa-download"></i>
//               <span className="explore_fonts mx-1">{formatLikeCount(props.image.downloads)}</span>
//             </div>  
//     </>
//   )
// }

function ShowLikes({ image }) {
  const username = image?.user;
  const avatar = image?.userImageURL;

  // const hasCreator = Boolean(username && avatar);
  const hasCreator = false;

  if (hasCreator) {
    return (
      <div className="explore_creator_content ">
        <img
          src={avatar}
          alt={username}
          className="explore_creator_avatar"
        />

<div className="contain_userinfo">
        <span className="explore_fonts mx-1 owner_username">
          {username}

        </span>

        {/* <span className="explore_fonts mx-1 user_likedby">
        Liked By {(image?.likes || 0) + 700} People

        </span> */}

        </div>
      </div>
    );
  }

  return (
    <>
      <div className="explore_like_content d-flex align-items-center">
        <i className="fa-solid fa-heart"></i>
        <span className="explore_fonts mx-1">
          {formatLikeCount((image?.likes || 0) + 700)}
        </span>
      </div>

      <div className="explore_like_content d-flex align-items-center">
        <i className="fa-regular fa-eye"></i>
        <span className="explore_fonts mx-1">
          {formatLikeCount(image?.views || 0)}
        </span>
      </div>

      <div className="explore_like_content d-flex align-items-center">
        <i className="fa-solid fa-download"></i>
        <span className="explore_fonts mx-1">
          {formatLikeCount(image?.downloads || 0)}
        </span>
      </div>
    </>
  );
}



function PostCard({
  postImage,
  index,
  toImageKitURL,
  item,
  imageStates,
  markPreviewLoaded,
  makewebformatImageUrl,
  makelargeImageUrl,
  objectType,
  targetTag, 
  handleImageClick,
  componentFrom, displayFor, displayCategory

}) {
  const isLoaded =
    imageStates[postImage._uid]?.previewLoaded;
    const loveHomeImage = componentFrom === "home" && displayFor === "homeTopic" && displayCategory.includes("love");

  return (
    <div
      key={`post-card-${index}`}
      className="column position-relative post-card-wrapper"
    >
      <div
        className="post-card"
        style={{
          backgroundColor: postImage?.imageColor,
          "--image-color": postImage?.imageColor
        }}
      >
        {!isLoaded && (
          <div className="skeleton" />
        )}

        <Link
          className="post-card__link"
          to={`/explore-next/${objectType}/${targetTag}`}
          state={{ imageData: postImage }}
           style={{
    ...(loveHomeImage ? {} : { aspectRatio: "3 / 4" })
  }}
          onClick={(e) => {
            e.stopPropagation();
             handleImageClick(
      postImage,
      postImage._uid,
      false,
      false,
      targetTag,
      "post_card_click",
      false,
      index
    );

            console.log(
              "Create post card clicked",
              postImage
            );
          }}
        >
          <img
            className="post-card__image"
            src={toImageKitURL(
              postImage.previewURL,
              postImage.previewWidth
            )}
            srcSet={`
              ${toImageKitURL(
                postImage.previewURL,
                postImage.previewWidth
              )} ${postImage.previewWidth}w,

              ${toImageKitURL(
                makewebformatImageUrl(postImage),
                postImage.webformatWidth
              )} ${postImage.webformatWidth}w,

              ${toImageKitURL(
                makelargeImageUrl(postImage),
                postImage.imageWidth
              )} ${postImage.imageWidth}w
            `}
            sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
            alt={postImage.tags || "Create a post"}
            loading={index < 3 ? "eager" : "lazy"}
            decoding="async"
            onLoad={() => {
              markPreviewLoaded(postImage._uid);
            }}
            onError={() => {
              markPreviewLoaded(postImage._uid);
            }}
          />

          <div className="post-card__overlay">
          <div className="post_contain_info">
            <div className="left_post_text">
                <div className="post-card__title">
              {/* Love this moment? */}
               {/* {loveHomeImage ? 'Caption Idea' : 'Turn this image into a post' } */}
               {loveHomeImage ? 'Caption Idea' : 'Caption Ideas' }

            </div>

            <div className="post-card__subtitle">
              {/* Turn this image into a post */}
              {/* Get ready-to-use captions & hashtags for this image */}
              {loveHomeImage ? 'Some moments become memories forever...' : 'Turn this image into a post' }

            </div>
            </div>

            <div className="post-card__actions">
              <button className="post-card__button"
              
              
              >
                {/* Create Post */}
                Get Caption
              </button>
            </div>
          </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

